
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireae56"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireae56"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hS1nG", function(module, exports) {

$parcel$export(module.exports, "initShareButton", function () { return $69d5e79eccad0b4f$export$a3e9bef18d0e9ac6; });
function $69d5e79eccad0b4f$var$showToast(message, duration = 3000) {
    let toast = document.querySelector('.toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.className = 'toast';
        document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('visible');
    setTimeout(()=>{
        toast.classList.remove('visible');
    }, duration);
}
function $69d5e79eccad0b4f$var$copyToClipboard(text) {
    if (!navigator.clipboard) $69d5e79eccad0b4f$var$fallbackCopyToClipboard(text);
    navigator.clipboard.writeText(text).then(()=>$69d5e79eccad0b4f$var$showToast('Link copied to clipboard!')).catch((err)=>{
        console.error('Failed to copy:', err);
        $69d5e79eccad0b4f$var$fallbackCopyToClipboard(text);
    });
}
function $69d5e79eccad0b4f$var$fallbackCopyToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed'; // Avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        $69d5e79eccad0b4f$var$showToast(successful ? 'Link copied to clipboard!' : 'Unable to copy link');
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        $69d5e79eccad0b4f$var$showToast('Unable to copy link');
    }
    document.body.removeChild(textArea);
}
function $69d5e79eccad0b4f$export$a3e9bef18d0e9ac6(buttonElement) {
    buttonElement.addEventListener('click', async ()=>{
        const url = window.location.href;
        const title = document.title;
        const text = "Check out this cryptocurrency market cap race!";
        if (!navigator.share) {
            $69d5e79eccad0b4f$var$copyToClipboard(url);
            return;
        }
        try {
            await navigator.share({
                title: title,
                text: text,
                url: url
            });
            $69d5e79eccad0b4f$var$showToast('Shared successfully!');
        } catch (err) {
            if (err.name !== 'AbortError') {
                $69d5e79eccad0b4f$var$showToast('Error sharing. Link copied to clipboard instead.');
                $69d5e79eccad0b4f$var$copyToClipboard(url);
            }
        }
    });
}

});

parcelRegister("kUihX", function(module, exports) {

$parcel$export(module.exports, "createCoinElement", function () { return $55297e4c6bbd02f2$export$e19a0f968695bd98; });
function $55297e4c6bbd02f2$export$e19a0f968695bd98(coin, selectedOrAvailable, enabled = true, onClick) {
    const coinDiv = document.createElement('div');
    coinDiv.className = selectedOrAvailable == 'selected' ? 'coin-item' : 'available-coin-item';
    const img = document.createElement('img');
    img.src = `/icons/${coin.imageName}`;
    img.alt = coin.name;
    img.loading = 'lazy';
    const name = document.createTextNode(coin.name);
    coinDiv.appendChild(img);
    coinDiv.appendChild(name);
    const button = document.createElement('button');
    button.className = selectedOrAvailable == 'selected' ? 'remove-coin' : 'add-coin';
    button.innerHTML = selectedOrAvailable == 'selected' ? "\xd7" : '+';
    button.setAttribute('aria-label', selectedOrAvailable == 'selected' ? `Remove ${coin.name}` : `Add ${coin.name}`);
    if (!enabled) {
        button.disabled = true;
        coinDiv.classList.add('disabled');
    }
    coinDiv.addEventListener('click', ()=>{
        onClick(coin.id);
    });
    coinDiv.appendChild(button);
    return coinDiv;
}

});

parcelRegister("hf2iT", function(module, exports) {

$parcel$export(module.exports, "AvailableCoinsComponent", function () { return $8dfa3ff2cc5868aa$export$6da043726cefb612; });

var $kUihX = parcelRequire("kUihX");
class $8dfa3ff2cc5868aa$export$6da043726cefb612 {
    constructor(rootElement, selectedCoins, allCoins, addCoinCb){
        this.rootElement = rootElement;
        this.selectedCoins = selectedCoins;
        this.allCoins = allCoins;
        this.addCoinCb = addCoinCb;
        this.searchFilter = '';
        this.coinsContainer = rootElement.querySelector('.available-coins-list');
        this.coinSearchInputEl = rootElement.querySelector('.coin-search');
        this.init();
        this.update();
    }
    init() {
        this.coinSearchInputEl.addEventListener('input', (e)=>{
            this.searchFilter = e.target.value.trim().toLowerCase();
            this.update();
        });
    }
    update() {
        let selectableCoins = this.allCoins.filter((coin)=>!this.selectedCoins.has(coin.id));
        if (this.searchFilter) selectableCoins = selectableCoins.filter((coin)=>coin.name.toLowerCase().includes(this.searchFilter));
        this.coinsContainer.innerHTML = '';
        selectableCoins.forEach((coin)=>{
            const coinElement = (0, $kUihX.createCoinElement)(coin, "available", true, ()=>{
                this.searchFilter = '';
                this.coinSearchInputEl.value = '';
                this.addCoinCb(coin.id);
            });
            this.coinsContainer.appendChild(coinElement);
        });
    }
}

});

parcelRegister("kj7if", function(module, exports) {

$parcel$export(module.exports, "router", function () { return $17f46cc60e038b36$export$5375cda95f0b0eb4; });
class $17f46cc60e038b36$export$55185c17a0fcbe46 {
    constructor(){
        this.routes = [];
        this.defaultRoute = null;
        // Listen to hash changes
        window.addEventListener('hashchange', ()=>this.handleRoute());
        // Handle initial route
        window.addEventListener('load', ()=>this.handleRoute());
    }
    /**
     * Add a new route
     * @param pattern Route pattern (e.g., "/user/:id/profile")
     * @param callback Callback to execute when route matches
     */ on(pattern, callback) {
        this.routes.push({
            pattern: pattern,
            callback: callback
        });
    }
    /**
     * Set the default route handler
     * @param callback Callback to execute when no routes match
     */ default(callback) {
        this.defaultRoute = callback;
    }
    /**
     * Navigate to a new route
     * @param path Path to navigate to
     * @param query Optional query parameters
     */ navigate(path, query = {}) {
        const queryString = this.buildQueryString(query);
        const hash = queryString ? `#${path}?${queryString}` : `#${path}`;
        window.location.hash = hash;
    }
    /**
     * Get current route parameters
     */ getParams() {
        const { pathname: pathname } = this.parseHash();
        const route = this.findMatchingRoute(pathname);
        return route ? this.extractRouteParams(pathname, route.pattern) : {};
    }
    getPathName() {
        return this.parseHash().pathname;
    }
    /**
     * Get current query parameters
     */ getQuery() {
        const { search: search } = this.parseHash();
        return this.parseQueryString(search);
    }
    handleRoute() {
        const { pathname: pathname, search: search } = this.parseHash();
        const route = this.findMatchingRoute(pathname);
        if (route) {
            const params = this.extractRouteParams(pathname, route.pattern);
            const query = this.parseQueryString(search);
            route.callback(params, query);
        } else if (this.defaultRoute) this.defaultRoute({}, {});
    }
    parseHash() {
        const hash = window.location.hash.slice(1); // Remove #
        const [pathname, search] = hash.split('?');
        return {
            pathname: pathname || '/',
            search: search || ''
        };
    }
    findMatchingRoute(pathname) {
        return this.routes.find((route)=>this.isRouteMatch(pathname, route.pattern)) || null;
    }
    isRouteMatch(pathname, pattern) {
        const patternParts = pattern.split('/');
        const pathParts = pathname.split('/');
        if (patternParts.length !== pathParts.length) return false;
        return patternParts.every((part, i)=>{
            if (part.startsWith(':')) return true; // Variable part always matches
            return part === pathParts[i];
        });
    }
    extractRouteParams(pathname, pattern) {
        const params = {};
        const patternParts = pattern.split('/');
        const pathParts = pathname.split('/');
        patternParts.forEach((part, i)=>{
            if (part.startsWith(':')) {
                const paramName = part.slice(1);
                params[paramName] = pathParts[i];
            }
        });
        return params;
    }
    parseQueryString(search) {
        const params = {};
        if (!search) return params;
        const searchParams = new URLSearchParams(search);
        searchParams.forEach((value, key)=>{
            // Check if the value contains commas, if so split it into an array
            if (value.includes(',')) params[key] = value.split(',');
            else params[key] = value;
        });
        return params;
    }
    buildQueryString(query) {
        // Build the query string manually to avoid URLSearchParams encoding
        const parts = [];
        Object.entries(query).forEach(([key, value])=>{
            // Don't encode the key since it's a simple identifier
            if (Array.isArray(value)) {
                // Join array values with commas and don't encode the commas
                const encodedValues = value.map((v)=>encodeURIComponent(v)).join(',');
                parts.push(`${key}=${encodedValues}`);
            } else // Only encode the value, not the key
            parts.push(`${key}=${encodeURIComponent(value)}`);
        });
        return parts.join('&');
    }
}
const $17f46cc60e038b36$export$5375cda95f0b0eb4 = new $17f46cc60e038b36$export$55185c17a0fcbe46(); // Example usage:
 /*
router.on('/user/:id', (params, query) => {
    console.log('User ID:', params.id);
    console.log('Query params:', query);
});

router.on('/search', (params, query) => {
    console.log('Search query:', query.q);
    console.log('Filters:', query.filters); // Will be an array if comma-separated
});

router.default((params, query) => {
    console.log('404 - Route not found');
});

// Navigate with parameters
router.navigate('/user/123', { tab: 'profile', view: 'details' });

// Navigate with array parameters - will be comma-separated in URL
router.navigate('/search', { 
    q: 'test',
    filters: ['price', 'date'] // Will appear as ?filters=price,date in URL
});
*/ 

});

parcelRegister("1VIpI", function(module, exports) {

$parcel$export(module.exports, "coinsHistoricalDataMap", function () { return $a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9; });
$parcel$export(module.exports, "dataUrl", function () { return $a96d8b9dfeae5591$export$93cd470b47132a62; });
$parcel$export(module.exports, "loadAllCoinsData", function () { return $a96d8b9dfeae5591$export$4d3dd2158a7387a6; });
$parcel$export(module.exports, "parseCSVData", function () { return $a96d8b9dfeae5591$export$74d96f758e3da088; });
$parcel$export(module.exports, "loadCoinHistory", function () { return $a96d8b9dfeae5591$export$6e24f8f7847f6e82; });
$parcel$export(module.exports, "displayLatestUpdate", function () { return $a96d8b9dfeae5591$export$14c165ee5493aece; });
const $a96d8b9dfeae5591$export$577fd075fbec5f1c = new Map();
const $a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9 = new Map();
let $a96d8b9dfeae5591$var$top_coins_history, $a96d8b9dfeae5591$var$coin_markets, $a96d8b9dfeae5591$var$latest_update;
let $a96d8b9dfeae5591$var$dataVersion = '';
function $a96d8b9dfeae5591$export$93cd470b47132a62(path) {
    return $a96d8b9dfeae5591$var$dataVersion ? `data/${path}?v=${$a96d8b9dfeae5591$var$dataVersion}` : `data/${path}`;
}
async function $a96d8b9dfeae5591$export$4d3dd2158a7387a6() {
    // Always revalidate this small file: it tells us which data version to fetch
    $a96d8b9dfeae5591$var$latest_update = await fetch('data/latest_update.json', {
        cache: 'no-cache'
    }).then((r)=>r.json());
    const updatedAt = new Date($a96d8b9dfeae5591$var$latest_update.lastUpdated).getTime();
    $a96d8b9dfeae5591$var$dataVersion = isNaN(updatedAt) ? '' : String(updatedAt);
    [$a96d8b9dfeae5591$var$top_coins_history, $a96d8b9dfeae5591$var$coin_markets] = await Promise.all([
        fetch($a96d8b9dfeae5591$export$93cd470b47132a62('top_coins_history.csv')).then((r)=>r.text()),
        fetch($a96d8b9dfeae5591$export$93cd470b47132a62('coin_markets.json')).then((r)=>r.json())
    ]);
    // Save coin mapping
    $a96d8b9dfeae5591$var$coin_markets.forEach((coin)=>{
        $a96d8b9dfeae5591$export$577fd075fbec5f1c.set(coin.id, coin);
    });
    // Parse the initial combined history data into the coinsData map
    const rows = $a96d8b9dfeae5591$var$top_coins_history.split('\n').slice(1);
    for (const row of rows){
        const [dateStr, coinId, value] = row.split(',');
        if (!$a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9.has(coinId)) $a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9.set(coinId, []);
        const dataPoint = {
            date: new Date(dateStr),
            name: $a96d8b9dfeae5591$export$577fd075fbec5f1c.get(coinId).symbol.toUpperCase(),
            value: parseFloat(value),
            icon: `/icons/${$a96d8b9dfeae5591$export$577fd075fbec5f1c.get(coinId).imageName}`
        };
        if (dataPoint.date && !isNaN(dataPoint.value)) $a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9.get(coinId).push(dataPoint);
    }
    return {
        top_coins_history: $a96d8b9dfeae5591$var$top_coins_history,
        coin_markets: $a96d8b9dfeae5591$var$coin_markets,
        latest_update: $a96d8b9dfeae5591$var$latest_update,
        coinIdToCoinMap: $a96d8b9dfeae5591$export$577fd075fbec5f1c
    };
}
async function $a96d8b9dfeae5591$export$74d96f758e3da088(csvData, coinId, coinIdToCoinMap) {
    if (!csvData) return [];
    return csvData.split('\n').slice(1) // Skip header
    .map((row)=>{
        const [dateStr, value, open] = row.split(',');
        return {
            date: new Date(dateStr),
            name: coinIdToCoinMap.get(coinId).id.toUpperCase(),
            value: parseFloat(value),
            icon: `/icons/${coinIdToCoinMap.get(coinId).imageName}`
        };
    }).filter((obj)=>!isNaN(obj.value) && obj.date);
}
async function $a96d8b9dfeae5591$export$6e24f8f7847f6e82(coinId) {
    if ($a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9.has(coinId)) return $a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9.get(coinId);
    try {
        const response = await fetch($a96d8b9dfeae5591$export$93cd470b47132a62(`history/${coinId}.csv`), {
            headers: {
                'Content-Type': 'text/csv',
                'Accept': 'text/csv'
            }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await $a96d8b9dfeae5591$export$74d96f758e3da088(await response.text(), coinId, $a96d8b9dfeae5591$export$577fd075fbec5f1c);
        $a96d8b9dfeae5591$export$a79cd7ed1c8ab2e9.set(coinId, data);
        return data;
    } catch (error) {
        console.error(`Error loading history for ${coinId}:`, error);
        return null;
    }
}
function $a96d8b9dfeae5591$export$14c165ee5493aece(latest_update) {
    const lastUpdateSpan = document.querySelector('.last-update');
    if (lastUpdateSpan && latest_update) {
        const date = new Date(latest_update.lastUpdated);
        const formattedDate = date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        lastUpdateSpan.textContent = `Last updated: ${formattedDate}`;
    }
}

});

var $5b8488dadf327a2c$var$aa = Object.defineProperty;
var $5b8488dadf327a2c$var$ye = (t, e)=>{
    for(var r in e)$5b8488dadf327a2c$var$aa(t, r, {
        get: e[r],
        enumerable: !0
    });
};
var $5b8488dadf327a2c$var$xn = {};
$5b8488dadf327a2c$var$ye($5b8488dadf327a2c$var$xn, {
    actionTypes: ()=>$5b8488dadf327a2c$var$Lt,
    changeOptions: ()=>$5b8488dadf327a2c$var$ua,
    defaultOptions: ()=>$5b8488dadf327a2c$export$ba43bf67f3d48107,
    loadOptions: ()=>$5b8488dadf327a2c$var$sa,
    optionsReducer: ()=>$5b8488dadf327a2c$var$vn,
    validateOptions: ()=>$5b8488dadf327a2c$var$gr
});
var $5b8488dadf327a2c$var$Lt = {
    loadOptions: "options/load",
    changeOptions: "options/change"
}, $5b8488dadf327a2c$var$sa = (t)=>({
        type: $5b8488dadf327a2c$var$Lt.loadOptions,
        payload: t
    }), $5b8488dadf327a2c$var$ua = (t)=>({
        type: $5b8488dadf327a2c$var$Lt.changeOptions,
        payload: t
    });
var $5b8488dadf327a2c$var$Dr = {};
$5b8488dadf327a2c$var$ye($5b8488dadf327a2c$var$Dr, {
    actionTypes: ()=>$5b8488dadf327a2c$var$xe,
    containerReducer: ()=>$5b8488dadf327a2c$var$br,
    setContainer: ()=>$5b8488dadf327a2c$var$la
});
var $5b8488dadf327a2c$var$xe = {
    setContainer: "container/set"
}, $5b8488dadf327a2c$var$la = (t)=>({
        type: $5b8488dadf327a2c$var$xe.setContainer,
        payload: t.element
    });
var $5b8488dadf327a2c$var$ca = {
    element: document.body
}, $5b8488dadf327a2c$var$br = (t = $5b8488dadf327a2c$var$ca, e)=>{
    switch(e.type){
        case $5b8488dadf327a2c$var$xe.setContainer:
            return {
                ...t,
                element: e.payload
            };
        default:
            return t;
    }
};
var $5b8488dadf327a2c$var$Ar = {};
$5b8488dadf327a2c$var$ye($5b8488dadf327a2c$var$Ar, {
    actionTypes: ()=>$5b8488dadf327a2c$var$F,
    addDateSlice: ()=>$5b8488dadf327a2c$var$_a,
    addFilter: ()=>$5b8488dadf327a2c$var$pa,
    addSelection: ()=>$5b8488dadf327a2c$var$ya,
    allExceptFilter: ()=>$5b8488dadf327a2c$var$ga,
    clearDateSlices: ()=>$5b8488dadf327a2c$var$ba,
    dataLoaded: ()=>$5b8488dadf327a2c$var$fa,
    dataReducer: ()=>$5b8488dadf327a2c$var$Sr,
    removeFilter: ()=>$5b8488dadf327a2c$var$ha,
    removeSelection: ()=>$5b8488dadf327a2c$var$xa,
    resetFilters: ()=>$5b8488dadf327a2c$var$da,
    resetSelections: ()=>$5b8488dadf327a2c$var$wa,
    toggleFilter: ()=>$5b8488dadf327a2c$var$ma,
    toggleSelection: ()=>$5b8488dadf327a2c$var$va
});
var $5b8488dadf327a2c$var$F = {
    dataLoaded: "data/loaded",
    addFilter: "data/addFilter",
    removeFilter: "data/removeFilter",
    toggleFilter: "data/toggleFilter",
    resetFilters: "data/resetFilters",
    allExceptFilter: "data/allExceptFilter",
    addSelection: "data/addSelection",
    removeSelection: "data/removeSelection",
    toggleSelection: "data/toggleSelection",
    resetSelections: "data/resetSelections",
    addDateSlice: "data/addDateSlice",
    clearDateSlices: "data/clearDateSlices"
}, $5b8488dadf327a2c$var$fa = (t)=>({
        type: $5b8488dadf327a2c$var$F.dataLoaded,
        payload: t
    }), $5b8488dadf327a2c$var$pa = (t)=>({
        type: $5b8488dadf327a2c$var$F.addFilter,
        payload: t
    }), $5b8488dadf327a2c$var$ha = (t)=>({
        type: $5b8488dadf327a2c$var$F.removeFilter,
        payload: t
    }), $5b8488dadf327a2c$var$ma = (t)=>({
        type: $5b8488dadf327a2c$var$F.toggleFilter,
        payload: t
    }), $5b8488dadf327a2c$var$da = ()=>({
        type: $5b8488dadf327a2c$var$F.resetFilters
    }), $5b8488dadf327a2c$var$ga = (t)=>({
        type: $5b8488dadf327a2c$var$F.allExceptFilter,
        payload: t
    }), $5b8488dadf327a2c$var$ya = (t)=>({
        type: $5b8488dadf327a2c$var$F.addSelection,
        payload: t
    }), $5b8488dadf327a2c$var$xa = (t)=>({
        type: $5b8488dadf327a2c$var$F.removeSelection,
        payload: t
    }), $5b8488dadf327a2c$var$va = (t)=>({
        type: $5b8488dadf327a2c$var$F.toggleSelection,
        payload: t
    }), $5b8488dadf327a2c$var$wa = ()=>({
        type: $5b8488dadf327a2c$var$F.resetSelections
    }), $5b8488dadf327a2c$var$_a = (t, e)=>{
    let r = {};
    return r[t] = e, {
        type: $5b8488dadf327a2c$var$F.addDateSlice,
        payload: r,
        triggerRender: !1
    };
}, $5b8488dadf327a2c$var$ba = ()=>({
        type: $5b8488dadf327a2c$var$F.clearDateSlices
    });
var $5b8488dadf327a2c$var$Da = {
    names: [],
    groups: [],
    datesCache: [],
    groupFilter: [],
    selected: [],
    dateSlices: {}
}, $5b8488dadf327a2c$var$Sr = (t = $5b8488dadf327a2c$var$Da, e)=>{
    switch(e.type){
        case $5b8488dadf327a2c$var$F.dataLoaded:
            return {
                ...t,
                names: [
                    ...e.payload.names
                ],
                groups: [
                    ...e.payload.groups
                ],
                datesCache: [
                    ...e.payload.datesCache
                ]
            };
        case $5b8488dadf327a2c$var$F.addFilter:
            return {
                ...t,
                groupFilter: $5b8488dadf327a2c$var$kr(t.groupFilter, e.payload)
            };
        case $5b8488dadf327a2c$var$F.removeFilter:
            return {
                ...t,
                groupFilter: $5b8488dadf327a2c$var$ve(t.groupFilter, e.payload)
            };
        case $5b8488dadf327a2c$var$F.toggleFilter:
            return {
                ...t,
                groupFilter: $5b8488dadf327a2c$var$Sn(t.groupFilter, e.payload)
            };
        case $5b8488dadf327a2c$var$F.resetFilters:
            return {
                ...t,
                groupFilter: []
            };
        case $5b8488dadf327a2c$var$F.allExceptFilter:
            return {
                ...t,
                groupFilter: $5b8488dadf327a2c$var$ve(t.groups, e.payload)
            };
        case $5b8488dadf327a2c$var$F.addSelection:
            return {
                ...t,
                selected: $5b8488dadf327a2c$var$kr(t.selected, e.payload)
            };
        case $5b8488dadf327a2c$var$F.removeSelection:
            return {
                ...t,
                selected: $5b8488dadf327a2c$var$ve(t.selected, e.payload)
            };
        case $5b8488dadf327a2c$var$F.toggleSelection:
            return {
                ...t,
                selected: $5b8488dadf327a2c$var$Sn(t.selected, e.payload)
            };
        case $5b8488dadf327a2c$var$F.resetSelections:
            return {
                ...t,
                selected: []
            };
        case $5b8488dadf327a2c$var$F.addDateSlice:
            return {
                ...t,
                dateSlices: {
                    ...t.dateSlices,
                    ...e.payload
                }
            };
        case $5b8488dadf327a2c$var$F.clearDateSlices:
            return {
                ...t,
                dateSlices: {}
            };
        default:
            return t;
    }
};
function $5b8488dadf327a2c$var$kr(t, e) {
    let r = [
        ...t
    ];
    return r.includes(e) || r.push(e), r;
}
function $5b8488dadf327a2c$var$ve(t, e) {
    return t.filter((r)=>r !== e);
}
function $5b8488dadf327a2c$var$Sn(t, e) {
    return t.includes(e) ? $5b8488dadf327a2c$var$ve(t, e) : $5b8488dadf327a2c$var$kr(t, e);
}
var $5b8488dadf327a2c$var$yn = {};
$5b8488dadf327a2c$var$ye($5b8488dadf327a2c$var$yn, {
    actionTypes: ()=>$5b8488dadf327a2c$var$U,
    changeDates: ()=>$5b8488dadf327a2c$var$Sa,
    createTicker: ()=>$5b8488dadf327a2c$var$gn,
    dec: ()=>$5b8488dadf327a2c$var$Na,
    inc: ()=>$5b8488dadf327a2c$var$Ca,
    initialize: ()=>$5b8488dadf327a2c$var$ka,
    setFirst: ()=>$5b8488dadf327a2c$var$Ma,
    setLast: ()=>$5b8488dadf327a2c$var$Ea,
    setRunning: ()=>$5b8488dadf327a2c$var$Ta,
    tickerReducer: ()=>$5b8488dadf327a2c$var$Tr,
    updateDate: ()=>$5b8488dadf327a2c$var$Aa
});
var $5b8488dadf327a2c$var$U = {
    initialize: "ticker/initialize",
    changeDates: "ticker/changeDates",
    updateDate: "ticker/updateDate",
    setRunning: "ticker/setRunning",
    setFirst: "ticker/setFirst",
    setLast: "ticker/setLast",
    inc: "ticker/inc",
    dec: "ticker/dec"
}, $5b8488dadf327a2c$var$ka = (t)=>({
        type: $5b8488dadf327a2c$var$U.initialize,
        payload: t
    }), $5b8488dadf327a2c$var$Sa = (t)=>({
        type: $5b8488dadf327a2c$var$U.changeDates,
        payload: t
    }), $5b8488dadf327a2c$var$Aa = (t)=>({
        type: $5b8488dadf327a2c$var$U.updateDate,
        payload: t
    }), $5b8488dadf327a2c$var$Ta = (t)=>({
        type: $5b8488dadf327a2c$var$U.setRunning,
        payload: t
    }), $5b8488dadf327a2c$var$Ma = ()=>({
        type: $5b8488dadf327a2c$var$U.setFirst
    }), $5b8488dadf327a2c$var$Ea = ()=>({
        type: $5b8488dadf327a2c$var$U.setLast
    }), $5b8488dadf327a2c$var$Ca = (t = 1)=>({
        type: $5b8488dadf327a2c$var$U.inc,
        payload: t
    }), $5b8488dadf327a2c$var$Na = (t = 1)=>({
        type: $5b8488dadf327a2c$var$U.dec,
        payload: t
    });
var $5b8488dadf327a2c$var$Ra = {
    isRunning: !1,
    currentDate: "",
    isFirstDate: !0,
    isLastDate: !1,
    dates: []
}, $5b8488dadf327a2c$var$Tr = (t = $5b8488dadf327a2c$var$Ra, e)=>{
    switch(e.type){
        case $5b8488dadf327a2c$var$U.initialize:
            {
                let r = e.payload;
                return {
                    ...t,
                    isRunning: !1,
                    currentDate: r[0],
                    isFirstDate: !0,
                    isLastDate: !1,
                    dates: r
                };
            }
        case $5b8488dadf327a2c$var$U.changeDates:
            {
                let r = e.payload, n = r.indexOf(t.currentDate) !== -1 ? t.currentDate : t.currentDate < r[0] ? r[0] : t.currentDate > r[r.length - 1] ? r[r.length - 1] : r[[
                    ...r,
                    t.currentDate
                ].sort().indexOf(t.currentDate)];
                return {
                    ...t,
                    currentDate: n,
                    isFirstDate: n === r[0],
                    isLastDate: n === r[r.length - 1],
                    dates: r
                };
            }
        case $5b8488dadf327a2c$var$U.updateDate:
            {
                let r = e.payload;
                return t.dates.indexOf(r) === -1 ? {
                    ...t
                } : {
                    ...t,
                    currentDate: r,
                    isFirstDate: r === t.dates[0],
                    isLastDate: r === t.dates[t.dates.length - 1]
                };
            }
        case $5b8488dadf327a2c$var$U.setRunning:
            return {
                ...t,
                isRunning: e.payload
            };
        case $5b8488dadf327a2c$var$U.setFirst:
            return {
                ...t,
                currentDate: t.dates[0],
                isFirstDate: !0,
                isLastDate: !1
            };
        case $5b8488dadf327a2c$var$U.setLast:
            return {
                ...t,
                currentDate: t.dates[t.dates.length - 1],
                isFirstDate: !1,
                isLastDate: !0
            };
        case $5b8488dadf327a2c$var$U.inc:
            {
                let r = t.dates.indexOf(t.currentDate), n = t.dates.length - 1, o = e.payload, i = r + o > n ? t.dates[n] : t.dates[r + o];
                return {
                    ...t,
                    currentDate: i,
                    isFirstDate: i === t.dates[0],
                    isLastDate: i === t.dates[n]
                };
            }
        case $5b8488dadf327a2c$var$U.dec:
            {
                let r = t.dates.indexOf(t.currentDate), n = e.payload, o = r - n < 0 ? t.dates[0] : t.dates[r - n];
                return {
                    ...t,
                    currentDate: o,
                    isFirstDate: o === t.dates[0],
                    isLastDate: o === t.dates[t.dates.length - 1]
                };
            }
        default:
            return t;
    }
};
function $5b8488dadf327a2c$var$vt(t, e) {
    return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function $5b8488dadf327a2c$var$Mr(t, e) {
    return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function $5b8488dadf327a2c$var$we(t) {
    let e, r, n;
    t.length !== 2 ? (e = $5b8488dadf327a2c$var$vt, r = (s, l)=>$5b8488dadf327a2c$var$vt(t(s), l), n = (s, l)=>t(s) - l) : (e = t === $5b8488dadf327a2c$var$vt || t === $5b8488dadf327a2c$var$Mr ? t : $5b8488dadf327a2c$var$Fa, r = t, n = t);
    function o(s, l, u = 0, c = s.length) {
        if (u < c) {
            if (e(l, l) !== 0) return c;
            do {
                let f = u + c >>> 1;
                r(s[f], l) < 0 ? u = f + 1 : c = f;
            }while (u < c);
        }
        return u;
    }
    function i(s, l, u = 0, c = s.length) {
        if (u < c) {
            if (e(l, l) !== 0) return c;
            do {
                let f = u + c >>> 1;
                r(s[f], l) <= 0 ? u = f + 1 : c = f;
            }while (u < c);
        }
        return u;
    }
    function a(s, l, u = 0, c = s.length) {
        let f = o(s, l, u, c - 1);
        return f > u && n(s[f - 1], l) > -n(s[f], l) ? f - 1 : f;
    }
    return {
        left: o,
        center: a,
        right: i
    };
}
function $5b8488dadf327a2c$var$Fa() {
    return 0;
}
function $5b8488dadf327a2c$var$Er(t) {
    return t === null ? NaN : +t;
}
var $5b8488dadf327a2c$var$An = $5b8488dadf327a2c$var$we($5b8488dadf327a2c$var$vt), $5b8488dadf327a2c$var$Tn = $5b8488dadf327a2c$var$An.right, $5b8488dadf327a2c$var$Oa = $5b8488dadf327a2c$var$An.left, $5b8488dadf327a2c$var$Ia = $5b8488dadf327a2c$var$we($5b8488dadf327a2c$var$Er).center, $5b8488dadf327a2c$var$Cr = $5b8488dadf327a2c$var$Tn;
var $5b8488dadf327a2c$var$La = Math.sqrt(50), $5b8488dadf327a2c$var$Pa = Math.sqrt(10), $5b8488dadf327a2c$var$za = Math.sqrt(2);
function $5b8488dadf327a2c$var$_e(t, e, r) {
    let n = (e - t) / Math.max(0, r), o = Math.floor(Math.log10(n)), i = n / Math.pow(10, o), a = i >= $5b8488dadf327a2c$var$La ? 10 : i >= $5b8488dadf327a2c$var$Pa ? 5 : i >= $5b8488dadf327a2c$var$za ? 2 : 1, s, l, u;
    return o < 0 ? (u = Math.pow(10, -o) / a, s = Math.round(t * u), l = Math.round(e * u), s / u < t && ++s, l / u > e && --l, u = -u) : (u = Math.pow(10, o) * a, s = Math.round(t / u), l = Math.round(e / u), s * u < t && ++s, l * u > e && --l), l < s && .5 <= r && r < 2 ? $5b8488dadf327a2c$var$_e(t, e, r * 2) : [
        s,
        l,
        u
    ];
}
function $5b8488dadf327a2c$var$be(t, e, r) {
    if (e = +e, t = +t, r = +r, !(r > 0)) return [];
    if (t === e) return [
        t
    ];
    let n = e < t, [o, i, a] = n ? $5b8488dadf327a2c$var$_e(e, t, r) : $5b8488dadf327a2c$var$_e(t, e, r);
    if (!(i >= o)) return [];
    let s = i - o + 1, l = new Array(s);
    if (n) {
        if (a < 0) for(let u = 0; u < s; ++u)l[u] = (i - u) / -a;
        else for(let u = 0; u < s; ++u)l[u] = (i - u) * a;
    } else if (a < 0) for(let u = 0; u < s; ++u)l[u] = (o + u) / -a;
    else for(let u = 0; u < s; ++u)l[u] = (o + u) * a;
    return l;
}
function $5b8488dadf327a2c$var$Kt(t, e, r) {
    return e = +e, t = +t, r = +r, $5b8488dadf327a2c$var$_e(t, e, r)[2];
}
function $5b8488dadf327a2c$var$Nr(t, e, r) {
    e = +e, t = +t, r = +r;
    let n = e < t, o = n ? $5b8488dadf327a2c$var$Kt(e, t, r) : $5b8488dadf327a2c$var$Kt(t, e, r);
    return (n ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
function $5b8488dadf327a2c$var$wt(t, e) {
    let r;
    if (e === void 0) for (let n of t)n != null && (r < n || r === void 0 && n >= n) && (r = n);
    else {
        let n = -1;
        for (let o of t)(o = e(o, ++n, t)) != null && (r < o || r === void 0 && o >= o) && (r = o);
    }
    return r;
}
function $5b8488dadf327a2c$var$Mn(t) {
    return t;
}
var $5b8488dadf327a2c$var$ke = 1, $5b8488dadf327a2c$var$Rr = 2, $5b8488dadf327a2c$var$En = 3, $5b8488dadf327a2c$var$De = 4, $5b8488dadf327a2c$var$Cn = 1e-6;
function $5b8488dadf327a2c$var$Ha(t) {
    return "translate(" + t + ",0)";
}
function $5b8488dadf327a2c$var$$a(t) {
    return "translate(0," + t + ")";
}
function $5b8488dadf327a2c$var$Ba(t) {
    return (e)=>+t(e);
}
function $5b8488dadf327a2c$var$Va(t, e) {
    return e = Math.max(0, t.bandwidth() - e * 2) / 2, t.round() && (e = Math.round(e)), (r)=>+t(r) + e;
}
function $5b8488dadf327a2c$var$Ya() {
    return !this.__axis;
}
function $5b8488dadf327a2c$var$Ua(t, e) {
    var r = [], n = null, o = null, i = 6, a = 6, s = 3, l = typeof window < "u" && window.devicePixelRatio > 1 ? 0 : .5, u = t === $5b8488dadf327a2c$var$ke || t === $5b8488dadf327a2c$var$De ? -1 : 1, c = t === $5b8488dadf327a2c$var$De || t === $5b8488dadf327a2c$var$Rr ? "x" : "y", f = t === $5b8488dadf327a2c$var$ke || t === $5b8488dadf327a2c$var$En ? $5b8488dadf327a2c$var$Ha : $5b8488dadf327a2c$var$$a;
    function p(h) {
        var m = n ?? (e.ticks ? e.ticks.apply(e, r) : e.domain()), g = o ?? (e.tickFormat ? e.tickFormat.apply(e, r) : $5b8488dadf327a2c$var$Mn), x = Math.max(i, 0) + s, b = e.range(), D = +b[0] + l, k = +b[b.length - 1] + l, S = (e.bandwidth ? $5b8488dadf327a2c$var$Va : $5b8488dadf327a2c$var$Ba)(e.copy(), l), d = h.selection ? h.selection() : h, w = d.selectAll(".domain").data([
            null
        ]), E = d.selectAll(".tick").data(m, e).order(), R = E.exit(), I = E.enter().append("g").attr("class", "tick"), H = E.select("line"), _ = E.select("text");
        w = w.merge(w.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), E = E.merge(I), H = H.merge(I.append("line").attr("stroke", "currentColor").attr(c + "2", u * i)), _ = _.merge(I.append("text").attr("fill", "currentColor").attr(c, u * x).attr("dy", t === $5b8488dadf327a2c$var$ke ? "0em" : t === $5b8488dadf327a2c$var$En ? "0.71em" : "0.32em")), h !== d && (w = w.transition(h), E = E.transition(h), H = H.transition(h), _ = _.transition(h), R = R.transition(h).attr("opacity", $5b8488dadf327a2c$var$Cn).attr("transform", function(C) {
            return isFinite(C = S(C)) ? f(C + l) : this.getAttribute("transform");
        }), I.attr("opacity", $5b8488dadf327a2c$var$Cn).attr("transform", function(C) {
            var A = this.parentNode.__axis;
            return f((A && isFinite(A = A(C)) ? A : S(C)) + l);
        })), R.remove(), w.attr("d", t === $5b8488dadf327a2c$var$De || t === $5b8488dadf327a2c$var$Rr ? a ? "M" + u * a + "," + D + "H" + l + "V" + k + "H" + u * a : "M" + l + "," + D + "V" + k : a ? "M" + D + "," + u * a + "V" + l + "H" + k + "V" + u * a : "M" + D + "," + l + "H" + k), E.attr("opacity", 1).attr("transform", function(C) {
            return f(S(C) + l);
        }), H.attr(c + "2", u * i), _.attr(c, u * x).text(g), d.filter($5b8488dadf327a2c$var$Ya).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === $5b8488dadf327a2c$var$Rr ? "start" : t === $5b8488dadf327a2c$var$De ? "end" : "middle"), d.each(function() {
            this.__axis = S;
        });
    }
    return p.scale = function(h) {
        return arguments.length ? (e = h, p) : e;
    }, p.ticks = function() {
        return r = Array.from(arguments), p;
    }, p.tickArguments = function(h) {
        return arguments.length ? (r = h == null ? [] : Array.from(h), p) : r.slice();
    }, p.tickValues = function(h) {
        return arguments.length ? (n = h == null ? null : Array.from(h), p) : n && n.slice();
    }, p.tickFormat = function(h) {
        return arguments.length ? (o = h, p) : o;
    }, p.tickSize = function(h) {
        return arguments.length ? (i = a = +h, p) : i;
    }, p.tickSizeInner = function(h) {
        return arguments.length ? (i = +h, p) : i;
    }, p.tickSizeOuter = function(h) {
        return arguments.length ? (a = +h, p) : a;
    }, p.tickPadding = function(h) {
        return arguments.length ? (s = +h, p) : s;
    }, p.offset = function(h) {
        return arguments.length ? (l = +h, p) : l;
    }, p;
}
function $5b8488dadf327a2c$var$Se(t) {
    return $5b8488dadf327a2c$var$Ua($5b8488dadf327a2c$var$ke, t);
}
var $5b8488dadf327a2c$var$qa = {
    value: ()=>{}
};
function $5b8488dadf327a2c$var$Rn() {
    for(var t = 0, e = arguments.length, r = {}, n; t < e; ++t){
        if (!(n = arguments[t] + "") || n in r || /[\s.]/.test(n)) throw new Error("illegal type: " + n);
        r[n] = [];
    }
    return new $5b8488dadf327a2c$var$Ae(r);
}
function $5b8488dadf327a2c$var$Ae(t) {
    this._ = t;
}
function $5b8488dadf327a2c$var$Wa(t, e) {
    return t.trim().split(/^|\s+/).map(function(r) {
        var n = "", o = r.indexOf(".");
        if (o >= 0 && (n = r.slice(o + 1), r = r.slice(0, o)), r && !e.hasOwnProperty(r)) throw new Error("unknown type: " + r);
        return {
            type: r,
            name: n
        };
    });
}
$5b8488dadf327a2c$var$Ae.prototype = $5b8488dadf327a2c$var$Rn.prototype = {
    constructor: $5b8488dadf327a2c$var$Ae,
    on: function(t, e) {
        var r = this._, n = $5b8488dadf327a2c$var$Wa(t + "", r), o, i = -1, a = n.length;
        if (arguments.length < 2) {
            for(; ++i < a;)if ((o = (t = n[i]).type) && (o = $5b8488dadf327a2c$var$Xa(r[o], t.name))) return o;
            return;
        }
        if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
        for(; ++i < a;)if (o = (t = n[i]).type) r[o] = $5b8488dadf327a2c$var$Nn(r[o], t.name, e);
        else if (e == null) for(o in r)r[o] = $5b8488dadf327a2c$var$Nn(r[o], t.name, null);
        return this;
    },
    copy: function() {
        var t = {}, e = this._;
        for(var r in e)t[r] = e[r].slice();
        return new $5b8488dadf327a2c$var$Ae(t);
    },
    call: function(t, e) {
        if ((o = arguments.length - 2) > 0) for(var r = new Array(o), n = 0, o, i; n < o; ++n)r[n] = arguments[n + 2];
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        for(i = this._[t], n = 0, o = i.length; n < o; ++n)i[n].value.apply(e, r);
    },
    apply: function(t, e, r) {
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        for(var n = this._[t], o = 0, i = n.length; o < i; ++o)n[o].value.apply(e, r);
    }
};
function $5b8488dadf327a2c$var$Xa(t, e) {
    for(var r = 0, n = t.length, o; r < n; ++r)if ((o = t[r]).name === e) return o.value;
}
function $5b8488dadf327a2c$var$Nn(t, e, r) {
    for(var n = 0, o = t.length; n < o; ++n)if (t[n].name === e) {
        t[n] = $5b8488dadf327a2c$var$qa, t = t.slice(0, n).concat(t.slice(n + 1));
        break;
    }
    return r != null && t.push({
        name: e,
        value: r
    }), t;
}
var $5b8488dadf327a2c$var$Fr = $5b8488dadf327a2c$var$Rn;
var $5b8488dadf327a2c$var$Te = "http://www.w3.org/1999/xhtml", $5b8488dadf327a2c$var$Or = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $5b8488dadf327a2c$var$Te,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};
function $5b8488dadf327a2c$var$ct(t) {
    var e = t += "", r = e.indexOf(":");
    return r >= 0 && (e = t.slice(0, r)) !== "xmlns" && (t = t.slice(r + 1)), $5b8488dadf327a2c$var$Or.hasOwnProperty(e) ? {
        space: $5b8488dadf327a2c$var$Or[e],
        local: t
    } : t;
}
function $5b8488dadf327a2c$var$ja(t) {
    return function() {
        var e = this.ownerDocument, r = this.namespaceURI;
        return r === $5b8488dadf327a2c$var$Te && e.documentElement.namespaceURI === $5b8488dadf327a2c$var$Te ? e.createElement(t) : e.createElementNS(r, t);
    };
}
function $5b8488dadf327a2c$var$Ga(t) {
    return function() {
        return this.ownerDocument.createElementNS(t.space, t.local);
    };
}
function $5b8488dadf327a2c$var$Me(t) {
    var e = $5b8488dadf327a2c$var$ct(t);
    return (e.local ? $5b8488dadf327a2c$var$Ga : $5b8488dadf327a2c$var$ja)(e);
}
function $5b8488dadf327a2c$var$Ka() {}
function $5b8488dadf327a2c$var$_t(t) {
    return t == null ? $5b8488dadf327a2c$var$Ka : function() {
        return this.querySelector(t);
    };
}
function $5b8488dadf327a2c$var$Fn(t) {
    typeof t != "function" && (t = $5b8488dadf327a2c$var$_t(t));
    for(var e = this._groups, r = e.length, n = new Array(r), o = 0; o < r; ++o)for(var i = e[o], a = i.length, s = n[o] = new Array(a), l, u, c = 0; c < a; ++c)(l = i[c]) && (u = t.call(l, l.__data__, c, i)) && ("__data__" in l && (u.__data__ = l.__data__), s[c] = u);
    return new $5b8488dadf327a2c$var$P(n, this._parents);
}
function $5b8488dadf327a2c$var$Ir(t) {
    return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function $5b8488dadf327a2c$var$Za() {
    return [];
}
function $5b8488dadf327a2c$var$Zt(t) {
    return t == null ? $5b8488dadf327a2c$var$Za : function() {
        return this.querySelectorAll(t);
    };
}
function $5b8488dadf327a2c$var$Qa(t) {
    return function() {
        return $5b8488dadf327a2c$var$Ir(t.apply(this, arguments));
    };
}
function $5b8488dadf327a2c$var$On(t) {
    typeof t == "function" ? t = $5b8488dadf327a2c$var$Qa(t) : t = $5b8488dadf327a2c$var$Zt(t);
    for(var e = this._groups, r = e.length, n = [], o = [], i = 0; i < r; ++i)for(var a = e[i], s = a.length, l, u = 0; u < s; ++u)(l = a[u]) && (n.push(t.call(l, l.__data__, u, a)), o.push(l));
    return new $5b8488dadf327a2c$var$P(n, o);
}
function $5b8488dadf327a2c$var$Qt(t) {
    return function() {
        return this.matches(t);
    };
}
function $5b8488dadf327a2c$var$Ee(t) {
    return function(e) {
        return e.matches(t);
    };
}
var $5b8488dadf327a2c$var$Ja = Array.prototype.find;
function $5b8488dadf327a2c$var$ts(t) {
    return function() {
        return $5b8488dadf327a2c$var$Ja.call(this.children, t);
    };
}
function $5b8488dadf327a2c$var$es() {
    return this.firstElementChild;
}
function $5b8488dadf327a2c$var$In(t) {
    return this.select(t == null ? $5b8488dadf327a2c$var$es : $5b8488dadf327a2c$var$ts(typeof t == "function" ? t : $5b8488dadf327a2c$var$Ee(t)));
}
var $5b8488dadf327a2c$var$rs = Array.prototype.filter;
function $5b8488dadf327a2c$var$ns() {
    return Array.from(this.children);
}
function $5b8488dadf327a2c$var$os(t) {
    return function() {
        return $5b8488dadf327a2c$var$rs.call(this.children, t);
    };
}
function $5b8488dadf327a2c$var$Ln(t) {
    return this.selectAll(t == null ? $5b8488dadf327a2c$var$ns : $5b8488dadf327a2c$var$os(typeof t == "function" ? t : $5b8488dadf327a2c$var$Ee(t)));
}
function $5b8488dadf327a2c$var$Pn(t) {
    typeof t != "function" && (t = $5b8488dadf327a2c$var$Qt(t));
    for(var e = this._groups, r = e.length, n = new Array(r), o = 0; o < r; ++o)for(var i = e[o], a = i.length, s = n[o] = [], l, u = 0; u < a; ++u)(l = i[u]) && t.call(l, l.__data__, u, i) && s.push(l);
    return new $5b8488dadf327a2c$var$P(n, this._parents);
}
function $5b8488dadf327a2c$var$Ce(t) {
    return new Array(t.length);
}
function $5b8488dadf327a2c$var$zn() {
    return new $5b8488dadf327a2c$var$P(this._enter || this._groups.map($5b8488dadf327a2c$var$Ce), this._parents);
}
function $5b8488dadf327a2c$var$Jt(t, e) {
    this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
$5b8488dadf327a2c$var$Jt.prototype = {
    constructor: $5b8488dadf327a2c$var$Jt,
    appendChild: function(t) {
        return this._parent.insertBefore(t, this._next);
    },
    insertBefore: function(t, e) {
        return this._parent.insertBefore(t, e);
    },
    querySelector: function(t) {
        return this._parent.querySelector(t);
    },
    querySelectorAll: function(t) {
        return this._parent.querySelectorAll(t);
    }
};
function $5b8488dadf327a2c$var$Hn(t) {
    return function() {
        return t;
    };
}
function $5b8488dadf327a2c$var$is(t, e, r, n, o, i) {
    for(var a = 0, s, l = e.length, u = i.length; a < u; ++a)(s = e[a]) ? (s.__data__ = i[a], n[a] = s) : r[a] = new $5b8488dadf327a2c$var$Jt(t, i[a]);
    for(; a < l; ++a)(s = e[a]) && (o[a] = s);
}
function $5b8488dadf327a2c$var$as(t, e, r, n, o, i, a) {
    var s, l, u = new Map, c = e.length, f = i.length, p = new Array(c), h;
    for(s = 0; s < c; ++s)(l = e[s]) && (p[s] = h = a.call(l, l.__data__, s, e) + "", u.has(h) ? o[s] = l : u.set(h, l));
    for(s = 0; s < f; ++s)h = a.call(t, i[s], s, i) + "", (l = u.get(h)) ? (n[s] = l, l.__data__ = i[s], u.delete(h)) : r[s] = new $5b8488dadf327a2c$var$Jt(t, i[s]);
    for(s = 0; s < c; ++s)(l = e[s]) && u.get(p[s]) === l && (o[s] = l);
}
function $5b8488dadf327a2c$var$ss(t) {
    return t.__data__;
}
function $5b8488dadf327a2c$var$$n(t, e) {
    if (!arguments.length) return Array.from(this, $5b8488dadf327a2c$var$ss);
    var r = e ? $5b8488dadf327a2c$var$as : $5b8488dadf327a2c$var$is, n = this._parents, o = this._groups;
    typeof t != "function" && (t = $5b8488dadf327a2c$var$Hn(t));
    for(var i = o.length, a = new Array(i), s = new Array(i), l = new Array(i), u = 0; u < i; ++u){
        var c = n[u], f = o[u], p = f.length, h = $5b8488dadf327a2c$var$us(t.call(c, c && c.__data__, u, n)), m = h.length, g = s[u] = new Array(m), x = a[u] = new Array(m), b = l[u] = new Array(p);
        r(c, f, g, x, b, h, e);
        for(var D = 0, k = 0, S, d; D < m; ++D)if (S = g[D]) {
            for(D >= k && (k = D + 1); !(d = x[k]) && ++k < m;);
            S._next = d || null;
        }
    }
    return a = new $5b8488dadf327a2c$var$P(a, n), a._enter = s, a._exit = l, a;
}
function $5b8488dadf327a2c$var$us(t) {
    return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function $5b8488dadf327a2c$var$Bn() {
    return new $5b8488dadf327a2c$var$P(this._exit || this._groups.map($5b8488dadf327a2c$var$Ce), this._parents);
}
function $5b8488dadf327a2c$var$Vn(t, e, r) {
    var n = this.enter(), o = this, i = this.exit();
    return typeof t == "function" ? (n = t(n), n && (n = n.selection())) : n = n.append(t + ""), e != null && (o = e(o), o && (o = o.selection())), r == null ? i.remove() : r(i), n && o ? n.merge(o).order() : o;
}
function $5b8488dadf327a2c$var$Yn(t) {
    for(var e = t.selection ? t.selection() : t, r = this._groups, n = e._groups, o = r.length, i = n.length, a = Math.min(o, i), s = new Array(o), l = 0; l < a; ++l)for(var u = r[l], c = n[l], f = u.length, p = s[l] = new Array(f), h, m = 0; m < f; ++m)(h = u[m] || c[m]) && (p[m] = h);
    for(; l < o; ++l)s[l] = r[l];
    return new $5b8488dadf327a2c$var$P(s, this._parents);
}
function $5b8488dadf327a2c$var$Un() {
    for(var t = this._groups, e = -1, r = t.length; ++e < r;)for(var n = t[e], o = n.length - 1, i = n[o], a; --o >= 0;)(a = n[o]) && (i && a.compareDocumentPosition(i) ^ 4 && i.parentNode.insertBefore(a, i), i = a);
    return this;
}
function $5b8488dadf327a2c$var$qn(t) {
    t || (t = $5b8488dadf327a2c$var$ls);
    function e(f, p) {
        return f && p ? t(f.__data__, p.__data__) : !f - !p;
    }
    for(var r = this._groups, n = r.length, o = new Array(n), i = 0; i < n; ++i){
        for(var a = r[i], s = a.length, l = o[i] = new Array(s), u, c = 0; c < s; ++c)(u = a[c]) && (l[c] = u);
        l.sort(e);
    }
    return new $5b8488dadf327a2c$var$P(o, this._parents).order();
}
function $5b8488dadf327a2c$var$ls(t, e) {
    return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function $5b8488dadf327a2c$var$Wn() {
    var t = arguments[0];
    return arguments[0] = this, t.apply(null, arguments), this;
}
function $5b8488dadf327a2c$var$Xn() {
    return Array.from(this);
}
function $5b8488dadf327a2c$var$jn() {
    for(var t = this._groups, e = 0, r = t.length; e < r; ++e)for(var n = t[e], o = 0, i = n.length; o < i; ++o){
        var a = n[o];
        if (a) return a;
    }
    return null;
}
function $5b8488dadf327a2c$var$Gn() {
    let t = 0;
    for (let e of this)++t;
    return t;
}
function $5b8488dadf327a2c$var$Kn() {
    return !this.node();
}
function $5b8488dadf327a2c$var$Zn(t) {
    for(var e = this._groups, r = 0, n = e.length; r < n; ++r)for(var o = e[r], i = 0, a = o.length, s; i < a; ++i)(s = o[i]) && t.call(s, s.__data__, i, o);
    return this;
}
function $5b8488dadf327a2c$var$cs(t) {
    return function() {
        this.removeAttribute(t);
    };
}
function $5b8488dadf327a2c$var$fs(t) {
    return function() {
        this.removeAttributeNS(t.space, t.local);
    };
}
function $5b8488dadf327a2c$var$ps(t, e) {
    return function() {
        this.setAttribute(t, e);
    };
}
function $5b8488dadf327a2c$var$hs(t, e) {
    return function() {
        this.setAttributeNS(t.space, t.local, e);
    };
}
function $5b8488dadf327a2c$var$ms(t, e) {
    return function() {
        var r = e.apply(this, arguments);
        r == null ? this.removeAttribute(t) : this.setAttribute(t, r);
    };
}
function $5b8488dadf327a2c$var$ds(t, e) {
    return function() {
        var r = e.apply(this, arguments);
        r == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, r);
    };
}
function $5b8488dadf327a2c$var$Qn(t, e) {
    var r = $5b8488dadf327a2c$var$ct(t);
    if (arguments.length < 2) {
        var n = this.node();
        return r.local ? n.getAttributeNS(r.space, r.local) : n.getAttribute(r);
    }
    return this.each((e == null ? r.local ? $5b8488dadf327a2c$var$fs : $5b8488dadf327a2c$var$cs : typeof e == "function" ? r.local ? $5b8488dadf327a2c$var$ds : $5b8488dadf327a2c$var$ms : r.local ? $5b8488dadf327a2c$var$hs : $5b8488dadf327a2c$var$ps)(r, e));
}
function $5b8488dadf327a2c$var$Ne(t) {
    return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function $5b8488dadf327a2c$var$gs(t) {
    return function() {
        this.style.removeProperty(t);
    };
}
function $5b8488dadf327a2c$var$ys(t, e, r) {
    return function() {
        this.style.setProperty(t, e, r);
    };
}
function $5b8488dadf327a2c$var$xs(t, e, r) {
    return function() {
        var n = e.apply(this, arguments);
        n == null ? this.style.removeProperty(t) : this.style.setProperty(t, n, r);
    };
}
function $5b8488dadf327a2c$var$Jn(t, e, r) {
    return arguments.length > 1 ? this.each((e == null ? $5b8488dadf327a2c$var$gs : typeof e == "function" ? $5b8488dadf327a2c$var$xs : $5b8488dadf327a2c$var$ys)(t, e, r ?? "")) : $5b8488dadf327a2c$var$ht(this.node(), t);
}
function $5b8488dadf327a2c$var$ht(t, e) {
    return t.style.getPropertyValue(e) || $5b8488dadf327a2c$var$Ne(t).getComputedStyle(t, null).getPropertyValue(e);
}
function $5b8488dadf327a2c$var$vs(t) {
    return function() {
        delete this[t];
    };
}
function $5b8488dadf327a2c$var$ws(t, e) {
    return function() {
        this[t] = e;
    };
}
function $5b8488dadf327a2c$var$_s(t, e) {
    return function() {
        var r = e.apply(this, arguments);
        r == null ? delete this[t] : this[t] = r;
    };
}
function $5b8488dadf327a2c$var$to(t, e) {
    return arguments.length > 1 ? this.each((e == null ? $5b8488dadf327a2c$var$vs : typeof e == "function" ? $5b8488dadf327a2c$var$_s : $5b8488dadf327a2c$var$ws)(t, e)) : this.node()[t];
}
function $5b8488dadf327a2c$var$eo(t) {
    return t.trim().split(/^|\s+/);
}
function $5b8488dadf327a2c$var$Lr(t) {
    return t.classList || new $5b8488dadf327a2c$var$ro(t);
}
function $5b8488dadf327a2c$var$ro(t) {
    this._node = t, this._names = $5b8488dadf327a2c$var$eo(t.getAttribute("class") || "");
}
$5b8488dadf327a2c$var$ro.prototype = {
    add: function(t) {
        var e = this._names.indexOf(t);
        e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
    },
    remove: function(t) {
        var e = this._names.indexOf(t);
        e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
    },
    contains: function(t) {
        return this._names.indexOf(t) >= 0;
    }
};
function $5b8488dadf327a2c$var$no(t, e) {
    for(var r = $5b8488dadf327a2c$var$Lr(t), n = -1, o = e.length; ++n < o;)r.add(e[n]);
}
function $5b8488dadf327a2c$var$oo(t, e) {
    for(var r = $5b8488dadf327a2c$var$Lr(t), n = -1, o = e.length; ++n < o;)r.remove(e[n]);
}
function $5b8488dadf327a2c$var$bs(t) {
    return function() {
        $5b8488dadf327a2c$var$no(this, t);
    };
}
function $5b8488dadf327a2c$var$Ds(t) {
    return function() {
        $5b8488dadf327a2c$var$oo(this, t);
    };
}
function $5b8488dadf327a2c$var$ks(t, e) {
    return function() {
        (e.apply(this, arguments) ? $5b8488dadf327a2c$var$no : $5b8488dadf327a2c$var$oo)(this, t);
    };
}
function $5b8488dadf327a2c$var$io(t, e) {
    var r = $5b8488dadf327a2c$var$eo(t + "");
    if (arguments.length < 2) {
        for(var n = $5b8488dadf327a2c$var$Lr(this.node()), o = -1, i = r.length; ++o < i;)if (!n.contains(r[o])) return !1;
        return !0;
    }
    return this.each((typeof e == "function" ? $5b8488dadf327a2c$var$ks : e ? $5b8488dadf327a2c$var$bs : $5b8488dadf327a2c$var$Ds)(r, e));
}
function $5b8488dadf327a2c$var$Ss() {
    this.textContent = "";
}
function $5b8488dadf327a2c$var$As(t) {
    return function() {
        this.textContent = t;
    };
}
function $5b8488dadf327a2c$var$Ts(t) {
    return function() {
        var e = t.apply(this, arguments);
        this.textContent = e ?? "";
    };
}
function $5b8488dadf327a2c$var$ao(t) {
    return arguments.length ? this.each(t == null ? $5b8488dadf327a2c$var$Ss : (typeof t == "function" ? $5b8488dadf327a2c$var$Ts : $5b8488dadf327a2c$var$As)(t)) : this.node().textContent;
}
function $5b8488dadf327a2c$var$Ms() {
    this.innerHTML = "";
}
function $5b8488dadf327a2c$var$Es(t) {
    return function() {
        this.innerHTML = t;
    };
}
function $5b8488dadf327a2c$var$Cs(t) {
    return function() {
        var e = t.apply(this, arguments);
        this.innerHTML = e ?? "";
    };
}
function $5b8488dadf327a2c$var$so(t) {
    return arguments.length ? this.each(t == null ? $5b8488dadf327a2c$var$Ms : (typeof t == "function" ? $5b8488dadf327a2c$var$Cs : $5b8488dadf327a2c$var$Es)(t)) : this.node().innerHTML;
}
function $5b8488dadf327a2c$var$Ns() {
    this.nextSibling && this.parentNode.appendChild(this);
}
function $5b8488dadf327a2c$var$uo() {
    return this.each($5b8488dadf327a2c$var$Ns);
}
function $5b8488dadf327a2c$var$Rs() {
    this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $5b8488dadf327a2c$var$lo() {
    return this.each($5b8488dadf327a2c$var$Rs);
}
function $5b8488dadf327a2c$var$co(t) {
    var e = typeof t == "function" ? t : $5b8488dadf327a2c$var$Me(t);
    return this.select(function() {
        return this.appendChild(e.apply(this, arguments));
    });
}
function $5b8488dadf327a2c$var$Fs() {
    return null;
}
function $5b8488dadf327a2c$var$fo(t, e) {
    var r = typeof t == "function" ? t : $5b8488dadf327a2c$var$Me(t), n = e == null ? $5b8488dadf327a2c$var$Fs : typeof e == "function" ? e : $5b8488dadf327a2c$var$_t(e);
    return this.select(function() {
        return this.insertBefore(r.apply(this, arguments), n.apply(this, arguments) || null);
    });
}
function $5b8488dadf327a2c$var$Os() {
    var t = this.parentNode;
    t && t.removeChild(this);
}
function $5b8488dadf327a2c$var$po() {
    return this.each($5b8488dadf327a2c$var$Os);
}
function $5b8488dadf327a2c$var$Is() {
    var t = this.cloneNode(!1), e = this.parentNode;
    return e ? e.insertBefore(t, this.nextSibling) : t;
}
function $5b8488dadf327a2c$var$Ls() {
    var t = this.cloneNode(!0), e = this.parentNode;
    return e ? e.insertBefore(t, this.nextSibling) : t;
}
function $5b8488dadf327a2c$var$ho(t) {
    return this.select(t ? $5b8488dadf327a2c$var$Ls : $5b8488dadf327a2c$var$Is);
}
function $5b8488dadf327a2c$var$mo(t) {
    return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function $5b8488dadf327a2c$var$Ps(t) {
    return function(e) {
        t.call(this, e, this.__data__);
    };
}
function $5b8488dadf327a2c$var$zs(t) {
    return t.trim().split(/^|\s+/).map(function(e) {
        var r = "", n = e.indexOf(".");
        return n >= 0 && (r = e.slice(n + 1), e = e.slice(0, n)), {
            type: e,
            name: r
        };
    });
}
function $5b8488dadf327a2c$var$Hs(t) {
    return function() {
        var e = this.__on;
        if (e) {
            for(var r = 0, n = -1, o = e.length, i; r < o; ++r)i = e[r], (!t.type || i.type === t.type) && i.name === t.name ? this.removeEventListener(i.type, i.listener, i.options) : e[++n] = i;
            ++n ? e.length = n : delete this.__on;
        }
    };
}
function $5b8488dadf327a2c$var$$s(t, e, r) {
    return function() {
        var n = this.__on, o, i = $5b8488dadf327a2c$var$Ps(e);
        if (n) {
            for(var a = 0, s = n.length; a < s; ++a)if ((o = n[a]).type === t.type && o.name === t.name) {
                this.removeEventListener(o.type, o.listener, o.options), this.addEventListener(o.type, o.listener = i, o.options = r), o.value = e;
                return;
            }
        }
        this.addEventListener(t.type, i, r), o = {
            type: t.type,
            name: t.name,
            value: e,
            listener: i,
            options: r
        }, n ? n.push(o) : this.__on = [
            o
        ];
    };
}
function $5b8488dadf327a2c$var$go(t, e, r) {
    var n = $5b8488dadf327a2c$var$zs(t + ""), o, i = n.length, a;
    if (arguments.length < 2) {
        var s = this.node().__on;
        if (s) {
            for(var l = 0, u = s.length, c; l < u; ++l)for(o = 0, c = s[l]; o < i; ++o)if ((a = n[o]).type === c.type && a.name === c.name) return c.value;
        }
        return;
    }
    for(s = e ? $5b8488dadf327a2c$var$$s : $5b8488dadf327a2c$var$Hs, o = 0; o < i; ++o)this.each(s(n[o], e, r));
    return this;
}
function $5b8488dadf327a2c$var$yo(t, e, r) {
    var n = $5b8488dadf327a2c$var$Ne(t), o = n.CustomEvent;
    typeof o == "function" ? o = new o(e, r) : (o = n.document.createEvent("Event"), r ? (o.initEvent(e, r.bubbles, r.cancelable), o.detail = r.detail) : o.initEvent(e, !1, !1)), t.dispatchEvent(o);
}
function $5b8488dadf327a2c$var$Bs(t, e) {
    return function() {
        return $5b8488dadf327a2c$var$yo(this, t, e);
    };
}
function $5b8488dadf327a2c$var$Vs(t, e) {
    return function() {
        return $5b8488dadf327a2c$var$yo(this, t, e.apply(this, arguments));
    };
}
function $5b8488dadf327a2c$var$xo(t, e) {
    return this.each((typeof e == "function" ? $5b8488dadf327a2c$var$Vs : $5b8488dadf327a2c$var$Bs)(t, e));
}
function* $5b8488dadf327a2c$var$vo() {
    for(var t = this._groups, e = 0, r = t.length; e < r; ++e)for(var n = t[e], o = 0, i = n.length, a; o < i; ++o)(a = n[o]) && (yield a);
}
var $5b8488dadf327a2c$var$Pr = [
    null
];
function $5b8488dadf327a2c$var$P(t, e) {
    this._groups = t, this._parents = e;
}
function $5b8488dadf327a2c$var$wo() {
    return new $5b8488dadf327a2c$var$P([
        [
            document.documentElement
        ]
    ], $5b8488dadf327a2c$var$Pr);
}
function $5b8488dadf327a2c$var$Ys() {
    return this;
}
$5b8488dadf327a2c$var$P.prototype = $5b8488dadf327a2c$var$wo.prototype = {
    constructor: $5b8488dadf327a2c$var$P,
    select: $5b8488dadf327a2c$var$Fn,
    selectAll: $5b8488dadf327a2c$var$On,
    selectChild: $5b8488dadf327a2c$var$In,
    selectChildren: $5b8488dadf327a2c$var$Ln,
    filter: $5b8488dadf327a2c$var$Pn,
    data: $5b8488dadf327a2c$var$$n,
    enter: $5b8488dadf327a2c$var$zn,
    exit: $5b8488dadf327a2c$var$Bn,
    join: $5b8488dadf327a2c$var$Vn,
    merge: $5b8488dadf327a2c$var$Yn,
    selection: $5b8488dadf327a2c$var$Ys,
    order: $5b8488dadf327a2c$var$Un,
    sort: $5b8488dadf327a2c$var$qn,
    call: $5b8488dadf327a2c$var$Wn,
    nodes: $5b8488dadf327a2c$var$Xn,
    node: $5b8488dadf327a2c$var$jn,
    size: $5b8488dadf327a2c$var$Gn,
    empty: $5b8488dadf327a2c$var$Kn,
    each: $5b8488dadf327a2c$var$Zn,
    attr: $5b8488dadf327a2c$var$Qn,
    style: $5b8488dadf327a2c$var$Jn,
    property: $5b8488dadf327a2c$var$to,
    classed: $5b8488dadf327a2c$var$io,
    text: $5b8488dadf327a2c$var$ao,
    html: $5b8488dadf327a2c$var$so,
    raise: $5b8488dadf327a2c$var$uo,
    lower: $5b8488dadf327a2c$var$lo,
    append: $5b8488dadf327a2c$var$co,
    insert: $5b8488dadf327a2c$var$fo,
    remove: $5b8488dadf327a2c$var$po,
    clone: $5b8488dadf327a2c$var$ho,
    datum: $5b8488dadf327a2c$var$mo,
    on: $5b8488dadf327a2c$var$go,
    dispatch: $5b8488dadf327a2c$var$xo,
    [Symbol.iterator]: $5b8488dadf327a2c$var$vo
};
var $5b8488dadf327a2c$var$ft = $5b8488dadf327a2c$var$wo;
function $5b8488dadf327a2c$var$j(t) {
    return typeof t == "string" ? new $5b8488dadf327a2c$var$P([
        [
            document.querySelector(t)
        ]
    ], [
        document.documentElement
    ]) : new $5b8488dadf327a2c$var$P([
        [
            t
        ]
    ], $5b8488dadf327a2c$var$Pr);
}
function $5b8488dadf327a2c$var$Re(t, e, r) {
    t.prototype = e.prototype = r, r.constructor = t;
}
function $5b8488dadf327a2c$var$zr(t, e) {
    var r = Object.create(t.prototype);
    for(var n in e)r[n] = e[n];
    return r;
}
function $5b8488dadf327a2c$var$re() {}
var $5b8488dadf327a2c$var$te = .7, $5b8488dadf327a2c$var$Ie = 1 / $5b8488dadf327a2c$var$te, $5b8488dadf327a2c$var$Pt = "\\s*([+-]?\\d+)\\s*", $5b8488dadf327a2c$var$ee = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", $5b8488dadf327a2c$var$at = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $5b8488dadf327a2c$var$Us = /^#([0-9a-f]{3,8})$/, $5b8488dadf327a2c$var$qs = new RegExp(`^rgb\\(${$5b8488dadf327a2c$var$Pt},${$5b8488dadf327a2c$var$Pt},${$5b8488dadf327a2c$var$Pt}\\)$`), $5b8488dadf327a2c$var$Ws = new RegExp(`^rgb\\(${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$at}\\)$`), $5b8488dadf327a2c$var$Xs = new RegExp(`^rgba\\(${$5b8488dadf327a2c$var$Pt},${$5b8488dadf327a2c$var$Pt},${$5b8488dadf327a2c$var$Pt},${$5b8488dadf327a2c$var$ee}\\)$`), $5b8488dadf327a2c$var$js = new RegExp(`^rgba\\(${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$ee}\\)$`), $5b8488dadf327a2c$var$Gs = new RegExp(`^hsl\\(${$5b8488dadf327a2c$var$ee},${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$at}\\)$`), $5b8488dadf327a2c$var$Ks = new RegExp(`^hsla\\(${$5b8488dadf327a2c$var$ee},${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$at},${$5b8488dadf327a2c$var$ee}\\)$`), $5b8488dadf327a2c$var$_o = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
};
$5b8488dadf327a2c$var$Re($5b8488dadf327a2c$var$re, $5b8488dadf327a2c$var$rt, {
    copy (t) {
        return Object.assign(new this.constructor, this, t);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: $5b8488dadf327a2c$var$bo,
    formatHex: $5b8488dadf327a2c$var$bo,
    formatHex8: $5b8488dadf327a2c$var$Zs,
    formatHsl: $5b8488dadf327a2c$var$Qs,
    formatRgb: $5b8488dadf327a2c$var$Do,
    toString: $5b8488dadf327a2c$var$Do
});
function $5b8488dadf327a2c$var$bo() {
    return this.rgb().formatHex();
}
function $5b8488dadf327a2c$var$Zs() {
    return this.rgb().formatHex8();
}
function $5b8488dadf327a2c$var$Qs() {
    return $5b8488dadf327a2c$var$Eo(this).formatHsl();
}
function $5b8488dadf327a2c$var$Do() {
    return this.rgb().formatRgb();
}
function $5b8488dadf327a2c$var$rt(t) {
    var e, r;
    return t = (t + "").trim().toLowerCase(), (e = $5b8488dadf327a2c$var$Us.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), r === 6 ? $5b8488dadf327a2c$var$ko(e) : r === 3 ? new $5b8488dadf327a2c$var$Z(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : r === 8 ? $5b8488dadf327a2c$var$Fe(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : r === 4 ? $5b8488dadf327a2c$var$Fe(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = $5b8488dadf327a2c$var$qs.exec(t)) ? new $5b8488dadf327a2c$var$Z(e[1], e[2], e[3], 1) : (e = $5b8488dadf327a2c$var$Ws.exec(t)) ? new $5b8488dadf327a2c$var$Z(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = $5b8488dadf327a2c$var$Xs.exec(t)) ? $5b8488dadf327a2c$var$Fe(e[1], e[2], e[3], e[4]) : (e = $5b8488dadf327a2c$var$js.exec(t)) ? $5b8488dadf327a2c$var$Fe(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = $5b8488dadf327a2c$var$Gs.exec(t)) ? $5b8488dadf327a2c$var$To(e[1], e[2] / 100, e[3] / 100, 1) : (e = $5b8488dadf327a2c$var$Ks.exec(t)) ? $5b8488dadf327a2c$var$To(e[1], e[2] / 100, e[3] / 100, e[4]) : $5b8488dadf327a2c$var$_o.hasOwnProperty(t) ? $5b8488dadf327a2c$var$ko($5b8488dadf327a2c$var$_o[t]) : t === "transparent" ? new $5b8488dadf327a2c$var$Z(NaN, NaN, NaN, 0) : null;
}
function $5b8488dadf327a2c$var$ko(t) {
    return new $5b8488dadf327a2c$var$Z(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function $5b8488dadf327a2c$var$Fe(t, e, r, n) {
    return n <= 0 && (t = e = r = NaN), new $5b8488dadf327a2c$var$Z(t, e, r, n);
}
function $5b8488dadf327a2c$var$Js(t) {
    return t instanceof $5b8488dadf327a2c$var$re || (t = $5b8488dadf327a2c$var$rt(t)), t ? (t = t.rgb(), new $5b8488dadf327a2c$var$Z(t.r, t.g, t.b, t.opacity)) : new $5b8488dadf327a2c$var$Z;
}
function $5b8488dadf327a2c$var$zt(t, e, r, n) {
    return arguments.length === 1 ? $5b8488dadf327a2c$var$Js(t) : new $5b8488dadf327a2c$var$Z(t, e, r, n ?? 1);
}
function $5b8488dadf327a2c$var$Z(t, e, r, n) {
    this.r = +t, this.g = +e, this.b = +r, this.opacity = +n;
}
$5b8488dadf327a2c$var$Re($5b8488dadf327a2c$var$Z, $5b8488dadf327a2c$var$zt, $5b8488dadf327a2c$var$zr($5b8488dadf327a2c$var$re, {
    brighter (t) {
        return t = t == null ? $5b8488dadf327a2c$var$Ie : Math.pow($5b8488dadf327a2c$var$Ie, t), new $5b8488dadf327a2c$var$Z(this.r * t, this.g * t, this.b * t, this.opacity);
    },
    darker (t) {
        return t = t == null ? $5b8488dadf327a2c$var$te : Math.pow($5b8488dadf327a2c$var$te, t), new $5b8488dadf327a2c$var$Z(this.r * t, this.g * t, this.b * t, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new $5b8488dadf327a2c$var$Z($5b8488dadf327a2c$var$Dt(this.r), $5b8488dadf327a2c$var$Dt(this.g), $5b8488dadf327a2c$var$Dt(this.b), $5b8488dadf327a2c$var$Le(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $5b8488dadf327a2c$var$So,
    formatHex: $5b8488dadf327a2c$var$So,
    formatHex8: $5b8488dadf327a2c$var$tu,
    formatRgb: $5b8488dadf327a2c$var$Ao,
    toString: $5b8488dadf327a2c$var$Ao
}));
function $5b8488dadf327a2c$var$So() {
    return `#${$5b8488dadf327a2c$var$bt(this.r)}${$5b8488dadf327a2c$var$bt(this.g)}${$5b8488dadf327a2c$var$bt(this.b)}`;
}
function $5b8488dadf327a2c$var$tu() {
    return `#${$5b8488dadf327a2c$var$bt(this.r)}${$5b8488dadf327a2c$var$bt(this.g)}${$5b8488dadf327a2c$var$bt(this.b)}${$5b8488dadf327a2c$var$bt((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function $5b8488dadf327a2c$var$Ao() {
    let t = $5b8488dadf327a2c$var$Le(this.opacity);
    return `${t === 1 ? "rgb(" : "rgba("}${$5b8488dadf327a2c$var$Dt(this.r)}, ${$5b8488dadf327a2c$var$Dt(this.g)}, ${$5b8488dadf327a2c$var$Dt(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function $5b8488dadf327a2c$var$Le(t) {
    return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function $5b8488dadf327a2c$var$Dt(t) {
    return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function $5b8488dadf327a2c$var$bt(t) {
    return t = $5b8488dadf327a2c$var$Dt(t), (t < 16 ? "0" : "") + t.toString(16);
}
function $5b8488dadf327a2c$var$To(t, e, r, n) {
    return n <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new $5b8488dadf327a2c$var$et(t, e, r, n);
}
function $5b8488dadf327a2c$var$Eo(t) {
    if (t instanceof $5b8488dadf327a2c$var$et) return new $5b8488dadf327a2c$var$et(t.h, t.s, t.l, t.opacity);
    if (t instanceof $5b8488dadf327a2c$var$re || (t = $5b8488dadf327a2c$var$rt(t)), !t) return new $5b8488dadf327a2c$var$et;
    if (t instanceof $5b8488dadf327a2c$var$et) return t;
    t = t.rgb();
    var e = t.r / 255, r = t.g / 255, n = t.b / 255, o = Math.min(e, r, n), i = Math.max(e, r, n), a = NaN, s = i - o, l = (i + o) / 2;
    return s ? (e === i ? a = (r - n) / s + (r < n) * 6 : r === i ? a = (n - e) / s + 2 : a = (e - r) / s + 4, s /= l < .5 ? i + o : 2 - i - o, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new $5b8488dadf327a2c$var$et(a, s, l, t.opacity);
}
function $5b8488dadf327a2c$var$ne(t, e, r, n) {
    return arguments.length === 1 ? $5b8488dadf327a2c$var$Eo(t) : new $5b8488dadf327a2c$var$et(t, e, r, n ?? 1);
}
function $5b8488dadf327a2c$var$et(t, e, r, n) {
    this.h = +t, this.s = +e, this.l = +r, this.opacity = +n;
}
$5b8488dadf327a2c$var$Re($5b8488dadf327a2c$var$et, $5b8488dadf327a2c$var$ne, $5b8488dadf327a2c$var$zr($5b8488dadf327a2c$var$re, {
    brighter (t) {
        return t = t == null ? $5b8488dadf327a2c$var$Ie : Math.pow($5b8488dadf327a2c$var$Ie, t), new $5b8488dadf327a2c$var$et(this.h, this.s, this.l * t, this.opacity);
    },
    darker (t) {
        return t = t == null ? $5b8488dadf327a2c$var$te : Math.pow($5b8488dadf327a2c$var$te, t), new $5b8488dadf327a2c$var$et(this.h, this.s, this.l * t, this.opacity);
    },
    rgb () {
        var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < .5 ? r : 1 - r) * e, o = 2 * r - n;
        return new $5b8488dadf327a2c$var$Z($5b8488dadf327a2c$var$Hr(t >= 240 ? t - 240 : t + 120, o, n), $5b8488dadf327a2c$var$Hr(t, o, n), $5b8488dadf327a2c$var$Hr(t < 120 ? t + 240 : t - 120, o, n), this.opacity);
    },
    clamp () {
        return new $5b8488dadf327a2c$var$et($5b8488dadf327a2c$var$Mo(this.h), $5b8488dadf327a2c$var$Oe(this.s), $5b8488dadf327a2c$var$Oe(this.l), $5b8488dadf327a2c$var$Le(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        let t = $5b8488dadf327a2c$var$Le(this.opacity);
        return `${t === 1 ? "hsl(" : "hsla("}${$5b8488dadf327a2c$var$Mo(this.h)}, ${$5b8488dadf327a2c$var$Oe(this.s) * 100}%, ${$5b8488dadf327a2c$var$Oe(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
    }
}));
function $5b8488dadf327a2c$var$Mo(t) {
    return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function $5b8488dadf327a2c$var$Oe(t) {
    return Math.max(0, Math.min(1, t || 0));
}
function $5b8488dadf327a2c$var$Hr(t, e, r) {
    return (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e) * 255;
}
function $5b8488dadf327a2c$var$$r(t, e, r, n, o) {
    var i = t * t, a = i * t;
    return ((1 - 3 * t + 3 * i - a) * e + (4 - 6 * i + 3 * a) * r + (1 + 3 * t + 3 * i - 3 * a) * n + a * o) / 6;
}
function $5b8488dadf327a2c$var$Co(t) {
    var e = t.length - 1;
    return function(r) {
        var n = r <= 0 ? r = 0 : r >= 1 ? (r = 1, e - 1) : Math.floor(r * e), o = t[n], i = t[n + 1], a = n > 0 ? t[n - 1] : 2 * o - i, s = n < e - 1 ? t[n + 2] : 2 * i - o;
        return $5b8488dadf327a2c$var$$r((r - n / e) * e, a, o, i, s);
    };
}
function $5b8488dadf327a2c$var$No(t) {
    var e = t.length;
    return function(r) {
        var n = Math.floor(((r %= 1) < 0 ? ++r : r) * e), o = t[(n + e - 1) % e], i = t[n % e], a = t[(n + 1) % e], s = t[(n + 2) % e];
        return $5b8488dadf327a2c$var$$r((r - n / e) * e, o, i, a, s);
    };
}
var $5b8488dadf327a2c$var$oe = (t)=>()=>t;
function $5b8488dadf327a2c$var$eu(t, e) {
    return function(r) {
        return t + r * e;
    };
}
function $5b8488dadf327a2c$var$ru(t, e, r) {
    return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function(n) {
        return Math.pow(t + n * e, r);
    };
}
function $5b8488dadf327a2c$var$Ro(t) {
    return (t = +t) == 1 ? $5b8488dadf327a2c$var$Pe : function(e, r) {
        return r - e ? $5b8488dadf327a2c$var$ru(e, r, t) : $5b8488dadf327a2c$var$oe(isNaN(e) ? r : e);
    };
}
function $5b8488dadf327a2c$var$Pe(t, e) {
    var r = e - t;
    return r ? $5b8488dadf327a2c$var$eu(t, r) : $5b8488dadf327a2c$var$oe(isNaN(t) ? e : t);
}
var $5b8488dadf327a2c$var$kt = function t(e) {
    var r = $5b8488dadf327a2c$var$Ro(e);
    function n(o, i) {
        var a = r((o = $5b8488dadf327a2c$var$zt(o)).r, (i = $5b8488dadf327a2c$var$zt(i)).r), s = r(o.g, i.g), l = r(o.b, i.b), u = $5b8488dadf327a2c$var$Pe(o.opacity, i.opacity);
        return function(c) {
            return o.r = a(c), o.g = s(c), o.b = l(c), o.opacity = u(c), o + "";
        };
    }
    return n.gamma = t, n;
}(1);
function $5b8488dadf327a2c$var$Fo(t) {
    return function(e) {
        var r = e.length, n = new Array(r), o = new Array(r), i = new Array(r), a, s;
        for(a = 0; a < r; ++a)s = $5b8488dadf327a2c$var$zt(e[a]), n[a] = s.r || 0, o[a] = s.g || 0, i[a] = s.b || 0;
        return n = t(n), o = t(o), i = t(i), s.opacity = 1, function(l) {
            return s.r = n(l), s.g = o(l), s.b = i(l), s + "";
        };
    };
}
var $5b8488dadf327a2c$var$nu = $5b8488dadf327a2c$var$Fo($5b8488dadf327a2c$var$Co), $5b8488dadf327a2c$var$ou = $5b8488dadf327a2c$var$Fo($5b8488dadf327a2c$var$No);
function $5b8488dadf327a2c$var$Oo(t, e) {
    e || (e = []);
    var r = t ? Math.min(e.length, t.length) : 0, n = e.slice(), o;
    return function(i) {
        for(o = 0; o < r; ++o)n[o] = t[o] * (1 - i) + e[o] * i;
        return n;
    };
}
function $5b8488dadf327a2c$var$Io(t) {
    return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function $5b8488dadf327a2c$var$Lo(t, e) {
    var r = e ? e.length : 0, n = t ? Math.min(r, t.length) : 0, o = new Array(n), i = new Array(r), a;
    for(a = 0; a < n; ++a)o[a] = $5b8488dadf327a2c$var$st(t[a], e[a]);
    for(; a < r; ++a)i[a] = e[a];
    return function(s) {
        for(a = 0; a < n; ++a)i[a] = o[a](s);
        return i;
    };
}
function $5b8488dadf327a2c$var$Po(t, e) {
    var r = new Date;
    return t = +t, e = +e, function(n) {
        return r.setTime(t * (1 - n) + e * n), r;
    };
}
function $5b8488dadf327a2c$var$q(t, e) {
    return t = +t, e = +e, function(r) {
        return t * (1 - r) + e * r;
    };
}
function $5b8488dadf327a2c$var$zo(t, e) {
    var r = {}, n = {}, o;
    (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
    for(o in e)o in t ? r[o] = $5b8488dadf327a2c$var$st(t[o], e[o]) : n[o] = e[o];
    return function(i) {
        for(o in r)n[o] = r[o](i);
        return n;
    };
}
var $5b8488dadf327a2c$var$Vr = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $5b8488dadf327a2c$var$Br = new RegExp($5b8488dadf327a2c$var$Vr.source, "g");
function $5b8488dadf327a2c$var$iu(t) {
    return function() {
        return t;
    };
}
function $5b8488dadf327a2c$var$au(t) {
    return function(e) {
        return t(e) + "";
    };
}
function $5b8488dadf327a2c$var$ie(t, e) {
    var r = $5b8488dadf327a2c$var$Vr.lastIndex = $5b8488dadf327a2c$var$Br.lastIndex = 0, n, o, i, a = -1, s = [], l = [];
    for(t = t + "", e = e + ""; (n = $5b8488dadf327a2c$var$Vr.exec(t)) && (o = $5b8488dadf327a2c$var$Br.exec(e));)(i = o.index) > r && (i = e.slice(r, i), s[a] ? s[a] += i : s[++a] = i), (n = n[0]) === (o = o[0]) ? s[a] ? s[a] += o : s[++a] = o : (s[++a] = null, l.push({
        i: a,
        x: $5b8488dadf327a2c$var$q(n, o)
    })), r = $5b8488dadf327a2c$var$Br.lastIndex;
    return r < e.length && (i = e.slice(r), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? l[0] ? $5b8488dadf327a2c$var$au(l[0].x) : $5b8488dadf327a2c$var$iu(e) : (e = l.length, function(u) {
        for(var c = 0, f; c < e; ++c)s[(f = l[c]).i] = f.x(u);
        return s.join("");
    });
}
function $5b8488dadf327a2c$var$st(t, e) {
    var r = typeof e, n;
    return e == null || r === "boolean" ? $5b8488dadf327a2c$var$oe(e) : (r === "number" ? $5b8488dadf327a2c$var$q : r === "string" ? (n = $5b8488dadf327a2c$var$rt(e)) ? (e = n, $5b8488dadf327a2c$var$kt) : $5b8488dadf327a2c$var$ie : e instanceof $5b8488dadf327a2c$var$rt ? $5b8488dadf327a2c$var$kt : e instanceof Date ? $5b8488dadf327a2c$var$Po : $5b8488dadf327a2c$var$Io(e) ? $5b8488dadf327a2c$var$Oo : Array.isArray(e) ? $5b8488dadf327a2c$var$Lo : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? $5b8488dadf327a2c$var$zo : $5b8488dadf327a2c$var$q)(t, e);
}
function $5b8488dadf327a2c$var$ze(t, e) {
    return t = +t, e = +e, function(r) {
        return Math.round(t * (1 - r) + e * r);
    };
}
var $5b8488dadf327a2c$var$Ho = 180 / Math.PI, $5b8488dadf327a2c$var$He = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $5b8488dadf327a2c$var$Yr(t, e, r, n, o, i) {
    var a, s, l;
    return (a = Math.sqrt(t * t + e * e)) && (t /= a, e /= a), (l = t * r + e * n) && (r -= t * l, n -= e * l), (s = Math.sqrt(r * r + n * n)) && (r /= s, n /= s, l /= s), t * n < e * r && (t = -t, e = -e, l = -l, a = -a), {
        translateX: o,
        translateY: i,
        rotate: Math.atan2(e, t) * $5b8488dadf327a2c$var$Ho,
        skewX: Math.atan(l) * $5b8488dadf327a2c$var$Ho,
        scaleX: a,
        scaleY: s
    };
}
var $5b8488dadf327a2c$var$$e;
function $5b8488dadf327a2c$var$$o(t) {
    let e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
    return e.isIdentity ? $5b8488dadf327a2c$var$He : $5b8488dadf327a2c$var$Yr(e.a, e.b, e.c, e.d, e.e, e.f);
}
function $5b8488dadf327a2c$var$Bo(t) {
    return t == null ? $5b8488dadf327a2c$var$He : ($5b8488dadf327a2c$var$$e || ($5b8488dadf327a2c$var$$e = document.createElementNS("http://www.w3.org/2000/svg", "g")), $5b8488dadf327a2c$var$$e.setAttribute("transform", t), (t = $5b8488dadf327a2c$var$$e.transform.baseVal.consolidate()) ? (t = t.matrix, $5b8488dadf327a2c$var$Yr(t.a, t.b, t.c, t.d, t.e, t.f)) : $5b8488dadf327a2c$var$He);
}
function $5b8488dadf327a2c$var$Vo(t, e, r, n) {
    function o(u) {
        return u.length ? u.pop() + " " : "";
    }
    function i(u, c, f, p, h, m) {
        if (u !== f || c !== p) {
            var g = h.push("translate(", null, e, null, r);
            m.push({
                i: g - 4,
                x: $5b8488dadf327a2c$var$q(u, f)
            }, {
                i: g - 2,
                x: $5b8488dadf327a2c$var$q(c, p)
            });
        } else (f || p) && h.push("translate(" + f + e + p + r);
    }
    function a(u, c, f, p) {
        u !== c ? (u - c > 180 ? c += 360 : c - u > 180 && (u += 360), p.push({
            i: f.push(o(f) + "rotate(", null, n) - 2,
            x: $5b8488dadf327a2c$var$q(u, c)
        })) : c && f.push(o(f) + "rotate(" + c + n);
    }
    function s(u, c, f, p) {
        u !== c ? p.push({
            i: f.push(o(f) + "skewX(", null, n) - 2,
            x: $5b8488dadf327a2c$var$q(u, c)
        }) : c && f.push(o(f) + "skewX(" + c + n);
    }
    function l(u, c, f, p, h, m) {
        if (u !== f || c !== p) {
            var g = h.push(o(h) + "scale(", null, ",", null, ")");
            m.push({
                i: g - 4,
                x: $5b8488dadf327a2c$var$q(u, f)
            }, {
                i: g - 2,
                x: $5b8488dadf327a2c$var$q(c, p)
            });
        } else (f !== 1 || p !== 1) && h.push(o(h) + "scale(" + f + "," + p + ")");
    }
    return function(u, c) {
        var f = [], p = [];
        return u = t(u), c = t(c), i(u.translateX, u.translateY, c.translateX, c.translateY, f, p), a(u.rotate, c.rotate, f, p), s(u.skewX, c.skewX, f, p), l(u.scaleX, u.scaleY, c.scaleX, c.scaleY, f, p), u = c = null, function(h) {
            for(var m = -1, g = p.length, x; ++m < g;)f[(x = p[m]).i] = x.x(h);
            return f.join("");
        };
    };
}
var $5b8488dadf327a2c$var$Ur = $5b8488dadf327a2c$var$Vo($5b8488dadf327a2c$var$$o, "px, ", "px)", "deg)"), $5b8488dadf327a2c$var$qr = $5b8488dadf327a2c$var$Vo($5b8488dadf327a2c$var$Bo, ", ", ")", ")");
var $5b8488dadf327a2c$var$Ht = 0, $5b8488dadf327a2c$var$se = 0, $5b8488dadf327a2c$var$ae = 0, $5b8488dadf327a2c$var$Uo = 1e3, $5b8488dadf327a2c$var$Be, $5b8488dadf327a2c$var$ue, $5b8488dadf327a2c$var$Ve = 0, $5b8488dadf327a2c$var$St = 0, $5b8488dadf327a2c$var$Ye = 0, $5b8488dadf327a2c$var$le = typeof performance == "object" && performance.now ? performance : Date, $5b8488dadf327a2c$var$qo = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
    setTimeout(t, 17);
};
function $5b8488dadf327a2c$var$Tt() {
    return $5b8488dadf327a2c$var$St || ($5b8488dadf327a2c$var$qo($5b8488dadf327a2c$var$su), $5b8488dadf327a2c$var$St = $5b8488dadf327a2c$var$le.now() + $5b8488dadf327a2c$var$Ye);
}
function $5b8488dadf327a2c$var$su() {
    $5b8488dadf327a2c$var$St = 0;
}
function $5b8488dadf327a2c$var$At() {
    this._call = this._time = this._next = null;
}
$5b8488dadf327a2c$var$At.prototype = $5b8488dadf327a2c$var$Ue.prototype = {
    constructor: $5b8488dadf327a2c$var$At,
    restart: function(t, e, r) {
        if (typeof t != "function") throw new TypeError("callback is not a function");
        r = (r == null ? $5b8488dadf327a2c$var$Tt() : +r) + (e == null ? 0 : +e), !this._next && $5b8488dadf327a2c$var$ue !== this && ($5b8488dadf327a2c$var$ue ? $5b8488dadf327a2c$var$ue._next = this : $5b8488dadf327a2c$var$Be = this, $5b8488dadf327a2c$var$ue = this), this._call = t, this._time = r, $5b8488dadf327a2c$var$Wr();
    },
    stop: function() {
        this._call && (this._call = null, this._time = 1 / 0, $5b8488dadf327a2c$var$Wr());
    }
};
function $5b8488dadf327a2c$var$Ue(t, e, r) {
    var n = new $5b8488dadf327a2c$var$At;
    return n.restart(t, e, r), n;
}
function $5b8488dadf327a2c$var$Wo() {
    $5b8488dadf327a2c$var$Tt(), ++$5b8488dadf327a2c$var$Ht;
    for(var t = $5b8488dadf327a2c$var$Be, e; t;)(e = $5b8488dadf327a2c$var$St - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
    --$5b8488dadf327a2c$var$Ht;
}
function $5b8488dadf327a2c$var$Yo() {
    $5b8488dadf327a2c$var$St = ($5b8488dadf327a2c$var$Ve = $5b8488dadf327a2c$var$le.now()) + $5b8488dadf327a2c$var$Ye, $5b8488dadf327a2c$var$Ht = $5b8488dadf327a2c$var$se = 0;
    try {
        $5b8488dadf327a2c$var$Wo();
    } finally{
        $5b8488dadf327a2c$var$Ht = 0, $5b8488dadf327a2c$var$lu(), $5b8488dadf327a2c$var$St = 0;
    }
}
function $5b8488dadf327a2c$var$uu() {
    var t = $5b8488dadf327a2c$var$le.now(), e = t - $5b8488dadf327a2c$var$Ve;
    e > $5b8488dadf327a2c$var$Uo && ($5b8488dadf327a2c$var$Ye -= e, $5b8488dadf327a2c$var$Ve = t);
}
function $5b8488dadf327a2c$var$lu() {
    for(var t, e = $5b8488dadf327a2c$var$Be, r, n = 1 / 0; e;)e._call ? (n > e._time && (n = e._time), t = e, e = e._next) : (r = e._next, e._next = null, e = t ? t._next = r : $5b8488dadf327a2c$var$Be = r);
    $5b8488dadf327a2c$var$ue = t, $5b8488dadf327a2c$var$Wr(n);
}
function $5b8488dadf327a2c$var$Wr(t) {
    if (!$5b8488dadf327a2c$var$Ht) {
        $5b8488dadf327a2c$var$se && ($5b8488dadf327a2c$var$se = clearTimeout($5b8488dadf327a2c$var$se));
        var e = t - $5b8488dadf327a2c$var$St;
        e > 24 ? (t < 1 / 0 && ($5b8488dadf327a2c$var$se = setTimeout($5b8488dadf327a2c$var$Yo, t - $5b8488dadf327a2c$var$le.now() - $5b8488dadf327a2c$var$Ye)), $5b8488dadf327a2c$var$ae && ($5b8488dadf327a2c$var$ae = clearInterval($5b8488dadf327a2c$var$ae))) : ($5b8488dadf327a2c$var$ae || ($5b8488dadf327a2c$var$Ve = $5b8488dadf327a2c$var$le.now(), $5b8488dadf327a2c$var$ae = setInterval($5b8488dadf327a2c$var$uu, $5b8488dadf327a2c$var$Uo)), $5b8488dadf327a2c$var$Ht = 1, $5b8488dadf327a2c$var$qo($5b8488dadf327a2c$var$Yo));
    }
}
function $5b8488dadf327a2c$var$qe(t, e, r) {
    var n = new $5b8488dadf327a2c$var$At;
    return e = e == null ? 0 : +e, n.restart((o)=>{
        n.stop(), t(o + e);
    }, e, r), n;
}
function $5b8488dadf327a2c$var$We(t, e, r) {
    var n = new $5b8488dadf327a2c$var$At, o = e;
    return e == null ? (n.restart(t, e, r), n) : (n._restart = n.restart, n.restart = function(i, a, s) {
        a = +a, s = s == null ? $5b8488dadf327a2c$var$Tt() : +s, n._restart(function l(u) {
            u += o, n._restart(l, o += a, s), i(u);
        }, a, s);
    }, n.restart(t, e, r), n);
}
var $5b8488dadf327a2c$var$cu = $5b8488dadf327a2c$var$Fr("start", "end", "cancel", "interrupt"), $5b8488dadf327a2c$var$fu = [], $5b8488dadf327a2c$var$Go = 0, $5b8488dadf327a2c$var$Xo = 1, $5b8488dadf327a2c$var$je = 2, $5b8488dadf327a2c$var$Xe = 3, $5b8488dadf327a2c$var$jo = 4, $5b8488dadf327a2c$var$Ge = 5, $5b8488dadf327a2c$var$ce = 6;
function $5b8488dadf327a2c$var$mt(t, e, r, n, o, i) {
    var a = t.__transition;
    if (!a) t.__transition = {};
    else if (r in a) return;
    $5b8488dadf327a2c$var$pu(t, r, {
        name: e,
        index: n,
        group: o,
        on: $5b8488dadf327a2c$var$cu,
        tween: $5b8488dadf327a2c$var$fu,
        time: i.time,
        delay: i.delay,
        duration: i.duration,
        ease: i.ease,
        timer: null,
        state: $5b8488dadf327a2c$var$Go
    });
}
function $5b8488dadf327a2c$var$fe(t, e) {
    var r = $5b8488dadf327a2c$var$V(t, e);
    if (r.state > $5b8488dadf327a2c$var$Go) throw new Error("too late; already scheduled");
    return r;
}
function $5b8488dadf327a2c$var$W(t, e) {
    var r = $5b8488dadf327a2c$var$V(t, e);
    if (r.state > $5b8488dadf327a2c$var$Xe) throw new Error("too late; already running");
    return r;
}
function $5b8488dadf327a2c$var$V(t, e) {
    var r = t.__transition;
    if (!r || !(r = r[e])) throw new Error("transition not found");
    return r;
}
function $5b8488dadf327a2c$var$pu(t, e, r) {
    var n = t.__transition, o;
    n[e] = r, r.timer = $5b8488dadf327a2c$var$Ue(i, 0, r.time);
    function i(u) {
        r.state = $5b8488dadf327a2c$var$Xo, r.timer.restart(a, r.delay, r.time), r.delay <= u && a(u - r.delay);
    }
    function a(u) {
        var c, f, p, h;
        if (r.state !== $5b8488dadf327a2c$var$Xo) return l();
        for(c in n)if (h = n[c], h.name === r.name) {
            if (h.state === $5b8488dadf327a2c$var$Xe) return $5b8488dadf327a2c$var$qe(a);
            h.state === $5b8488dadf327a2c$var$jo ? (h.state = $5b8488dadf327a2c$var$ce, h.timer.stop(), h.on.call("interrupt", t, t.__data__, h.index, h.group), delete n[c]) : +c < e && (h.state = $5b8488dadf327a2c$var$ce, h.timer.stop(), h.on.call("cancel", t, t.__data__, h.index, h.group), delete n[c]);
        }
        if ($5b8488dadf327a2c$var$qe(function() {
            r.state === $5b8488dadf327a2c$var$Xe && (r.state = $5b8488dadf327a2c$var$jo, r.timer.restart(s, r.delay, r.time), s(u));
        }), r.state = $5b8488dadf327a2c$var$je, r.on.call("start", t, t.__data__, r.index, r.group), r.state === $5b8488dadf327a2c$var$je) {
            for(r.state = $5b8488dadf327a2c$var$Xe, o = new Array(p = r.tween.length), c = 0, f = -1; c < p; ++c)(h = r.tween[c].value.call(t, t.__data__, r.index, r.group)) && (o[++f] = h);
            o.length = f + 1;
        }
    }
    function s(u) {
        for(var c = u < r.duration ? r.ease.call(null, u / r.duration) : (r.timer.restart(l), r.state = $5b8488dadf327a2c$var$Ge, 1), f = -1, p = o.length; ++f < p;)o[f].call(t, c);
        r.state === $5b8488dadf327a2c$var$Ge && (r.on.call("end", t, t.__data__, r.index, r.group), l());
    }
    function l() {
        r.state = $5b8488dadf327a2c$var$ce, r.timer.stop(), delete n[e];
        for(var u in n)return;
        delete t.__transition;
    }
}
function $5b8488dadf327a2c$var$Ke(t, e) {
    var r = t.__transition, n, o, i = !0, a;
    if (r) {
        e = e == null ? null : e + "";
        for(a in r){
            if ((n = r[a]).name !== e) {
                i = !1;
                continue;
            }
            o = n.state > $5b8488dadf327a2c$var$je && n.state < $5b8488dadf327a2c$var$Ge, n.state = $5b8488dadf327a2c$var$ce, n.timer.stop(), n.on.call(o ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete r[a];
        }
        i && delete t.__transition;
    }
}
function $5b8488dadf327a2c$var$Ko(t) {
    return this.each(function() {
        $5b8488dadf327a2c$var$Ke(this, t);
    });
}
function $5b8488dadf327a2c$var$hu(t, e) {
    var r, n;
    return function() {
        var o = $5b8488dadf327a2c$var$W(this, t), i = o.tween;
        if (i !== r) {
            n = r = i;
            for(var a = 0, s = n.length; a < s; ++a)if (n[a].name === e) {
                n = n.slice(), n.splice(a, 1);
                break;
            }
        }
        o.tween = n;
    };
}
function $5b8488dadf327a2c$var$mu(t, e, r) {
    var n, o;
    if (typeof r != "function") throw new Error;
    return function() {
        var i = $5b8488dadf327a2c$var$W(this, t), a = i.tween;
        if (a !== n) {
            o = (n = a).slice();
            for(var s = {
                name: e,
                value: r
            }, l = 0, u = o.length; l < u; ++l)if (o[l].name === e) {
                o[l] = s;
                break;
            }
            l === u && o.push(s);
        }
        i.tween = o;
    };
}
function $5b8488dadf327a2c$var$Zo(t, e) {
    var r = this._id;
    if (t += "", arguments.length < 2) {
        for(var n = $5b8488dadf327a2c$var$V(this.node(), r).tween, o = 0, i = n.length, a; o < i; ++o)if ((a = n[o]).name === t) return a.value;
        return null;
    }
    return this.each((e == null ? $5b8488dadf327a2c$var$hu : $5b8488dadf327a2c$var$mu)(r, t, e));
}
function $5b8488dadf327a2c$var$$t(t, e, r) {
    var n = t._id;
    return t.each(function() {
        var o = $5b8488dadf327a2c$var$W(this, n);
        (o.value || (o.value = {}))[e] = r.apply(this, arguments);
    }), function(o) {
        return $5b8488dadf327a2c$var$V(o, n).value[e];
    };
}
function $5b8488dadf327a2c$var$Ze(t, e) {
    var r;
    return (typeof e == "number" ? $5b8488dadf327a2c$var$q : e instanceof $5b8488dadf327a2c$var$rt ? $5b8488dadf327a2c$var$kt : (r = $5b8488dadf327a2c$var$rt(e)) ? (e = r, $5b8488dadf327a2c$var$kt) : $5b8488dadf327a2c$var$ie)(t, e);
}
function $5b8488dadf327a2c$var$du(t) {
    return function() {
        this.removeAttribute(t);
    };
}
function $5b8488dadf327a2c$var$gu(t) {
    return function() {
        this.removeAttributeNS(t.space, t.local);
    };
}
function $5b8488dadf327a2c$var$yu(t, e, r) {
    var n, o = r + "", i;
    return function() {
        var a = this.getAttribute(t);
        return a === o ? null : a === n ? i : i = e(n = a, r);
    };
}
function $5b8488dadf327a2c$var$xu(t, e, r) {
    var n, o = r + "", i;
    return function() {
        var a = this.getAttributeNS(t.space, t.local);
        return a === o ? null : a === n ? i : i = e(n = a, r);
    };
}
function $5b8488dadf327a2c$var$vu(t, e, r) {
    var n, o, i;
    return function() {
        var a, s = r(this), l;
        return s == null ? void this.removeAttribute(t) : (a = this.getAttribute(t), l = s + "", a === l ? null : a === n && l === o ? i : (o = l, i = e(n = a, s)));
    };
}
function $5b8488dadf327a2c$var$wu(t, e, r) {
    var n, o, i;
    return function() {
        var a, s = r(this), l;
        return s == null ? void this.removeAttributeNS(t.space, t.local) : (a = this.getAttributeNS(t.space, t.local), l = s + "", a === l ? null : a === n && l === o ? i : (o = l, i = e(n = a, s)));
    };
}
function $5b8488dadf327a2c$var$Qo(t, e) {
    var r = $5b8488dadf327a2c$var$ct(t), n = r === "transform" ? $5b8488dadf327a2c$var$qr : $5b8488dadf327a2c$var$Ze;
    return this.attrTween(t, typeof e == "function" ? (r.local ? $5b8488dadf327a2c$var$wu : $5b8488dadf327a2c$var$vu)(r, n, $5b8488dadf327a2c$var$$t(this, "attr." + t, e)) : e == null ? (r.local ? $5b8488dadf327a2c$var$gu : $5b8488dadf327a2c$var$du)(r) : (r.local ? $5b8488dadf327a2c$var$xu : $5b8488dadf327a2c$var$yu)(r, n, e));
}
function $5b8488dadf327a2c$var$_u(t, e) {
    return function(r) {
        this.setAttribute(t, e.call(this, r));
    };
}
function $5b8488dadf327a2c$var$bu(t, e) {
    return function(r) {
        this.setAttributeNS(t.space, t.local, e.call(this, r));
    };
}
function $5b8488dadf327a2c$var$Du(t, e) {
    var r, n;
    function o() {
        var i = e.apply(this, arguments);
        return i !== n && (r = (n = i) && $5b8488dadf327a2c$var$bu(t, i)), r;
    }
    return o._value = e, o;
}
function $5b8488dadf327a2c$var$ku(t, e) {
    var r, n;
    function o() {
        var i = e.apply(this, arguments);
        return i !== n && (r = (n = i) && $5b8488dadf327a2c$var$_u(t, i)), r;
    }
    return o._value = e, o;
}
function $5b8488dadf327a2c$var$Jo(t, e) {
    var r = "attr." + t;
    if (arguments.length < 2) return (r = this.tween(r)) && r._value;
    if (e == null) return this.tween(r, null);
    if (typeof e != "function") throw new Error;
    var n = $5b8488dadf327a2c$var$ct(t);
    return this.tween(r, (n.local ? $5b8488dadf327a2c$var$Du : $5b8488dadf327a2c$var$ku)(n, e));
}
function $5b8488dadf327a2c$var$Su(t, e) {
    return function() {
        $5b8488dadf327a2c$var$fe(this, t).delay = +e.apply(this, arguments);
    };
}
function $5b8488dadf327a2c$var$Au(t, e) {
    return e = +e, function() {
        $5b8488dadf327a2c$var$fe(this, t).delay = e;
    };
}
function $5b8488dadf327a2c$var$ti(t) {
    var e = this._id;
    return arguments.length ? this.each((typeof t == "function" ? $5b8488dadf327a2c$var$Su : $5b8488dadf327a2c$var$Au)(e, t)) : $5b8488dadf327a2c$var$V(this.node(), e).delay;
}
function $5b8488dadf327a2c$var$Tu(t, e) {
    return function() {
        $5b8488dadf327a2c$var$W(this, t).duration = +e.apply(this, arguments);
    };
}
function $5b8488dadf327a2c$var$Mu(t, e) {
    return e = +e, function() {
        $5b8488dadf327a2c$var$W(this, t).duration = e;
    };
}
function $5b8488dadf327a2c$var$ei(t) {
    var e = this._id;
    return arguments.length ? this.each((typeof t == "function" ? $5b8488dadf327a2c$var$Tu : $5b8488dadf327a2c$var$Mu)(e, t)) : $5b8488dadf327a2c$var$V(this.node(), e).duration;
}
function $5b8488dadf327a2c$var$Eu(t, e) {
    if (typeof e != "function") throw new Error;
    return function() {
        $5b8488dadf327a2c$var$W(this, t).ease = e;
    };
}
function $5b8488dadf327a2c$var$ri(t) {
    var e = this._id;
    return arguments.length ? this.each($5b8488dadf327a2c$var$Eu(e, t)) : $5b8488dadf327a2c$var$V(this.node(), e).ease;
}
function $5b8488dadf327a2c$var$Cu(t, e) {
    return function() {
        var r = e.apply(this, arguments);
        if (typeof r != "function") throw new Error;
        $5b8488dadf327a2c$var$W(this, t).ease = r;
    };
}
function $5b8488dadf327a2c$var$ni(t) {
    if (typeof t != "function") throw new Error;
    return this.each($5b8488dadf327a2c$var$Cu(this._id, t));
}
function $5b8488dadf327a2c$var$oi(t) {
    typeof t != "function" && (t = $5b8488dadf327a2c$var$Qt(t));
    for(var e = this._groups, r = e.length, n = new Array(r), o = 0; o < r; ++o)for(var i = e[o], a = i.length, s = n[o] = [], l, u = 0; u < a; ++u)(l = i[u]) && t.call(l, l.__data__, u, i) && s.push(l);
    return new $5b8488dadf327a2c$var$K(n, this._parents, this._name, this._id);
}
function $5b8488dadf327a2c$var$ii(t) {
    if (t._id !== this._id) throw new Error;
    for(var e = this._groups, r = t._groups, n = e.length, o = r.length, i = Math.min(n, o), a = new Array(n), s = 0; s < i; ++s)for(var l = e[s], u = r[s], c = l.length, f = a[s] = new Array(c), p, h = 0; h < c; ++h)(p = l[h] || u[h]) && (f[h] = p);
    for(; s < n; ++s)a[s] = e[s];
    return new $5b8488dadf327a2c$var$K(a, this._parents, this._name, this._id);
}
function $5b8488dadf327a2c$var$Nu(t) {
    return (t + "").trim().split(/^|\s+/).every(function(e) {
        var r = e.indexOf(".");
        return r >= 0 && (e = e.slice(0, r)), !e || e === "start";
    });
}
function $5b8488dadf327a2c$var$Ru(t, e, r) {
    var n, o, i = $5b8488dadf327a2c$var$Nu(e) ? $5b8488dadf327a2c$var$fe : $5b8488dadf327a2c$var$W;
    return function() {
        var a = i(this, t), s = a.on;
        s !== n && (o = (n = s).copy()).on(e, r), a.on = o;
    };
}
function $5b8488dadf327a2c$var$ai(t, e) {
    var r = this._id;
    return arguments.length < 2 ? $5b8488dadf327a2c$var$V(this.node(), r).on.on(t) : this.each($5b8488dadf327a2c$var$Ru(r, t, e));
}
function $5b8488dadf327a2c$var$Fu(t) {
    return function() {
        var e = this.parentNode;
        for(var r in this.__transition)if (+r !== t) return;
        e && e.removeChild(this);
    };
}
function $5b8488dadf327a2c$var$si() {
    return this.on("end.remove", $5b8488dadf327a2c$var$Fu(this._id));
}
function $5b8488dadf327a2c$var$ui(t) {
    var e = this._name, r = this._id;
    typeof t != "function" && (t = $5b8488dadf327a2c$var$_t(t));
    for(var n = this._groups, o = n.length, i = new Array(o), a = 0; a < o; ++a)for(var s = n[a], l = s.length, u = i[a] = new Array(l), c, f, p = 0; p < l; ++p)(c = s[p]) && (f = t.call(c, c.__data__, p, s)) && ("__data__" in c && (f.__data__ = c.__data__), u[p] = f, $5b8488dadf327a2c$var$mt(u[p], e, r, p, u, $5b8488dadf327a2c$var$V(c, r)));
    return new $5b8488dadf327a2c$var$K(i, this._parents, e, r);
}
function $5b8488dadf327a2c$var$li(t) {
    var e = this._name, r = this._id;
    typeof t != "function" && (t = $5b8488dadf327a2c$var$Zt(t));
    for(var n = this._groups, o = n.length, i = [], a = [], s = 0; s < o; ++s)for(var l = n[s], u = l.length, c, f = 0; f < u; ++f)if (c = l[f]) {
        for(var p = t.call(c, c.__data__, f, l), h, m = $5b8488dadf327a2c$var$V(c, r), g = 0, x = p.length; g < x; ++g)(h = p[g]) && $5b8488dadf327a2c$var$mt(h, e, r, g, p, m);
        i.push(p), a.push(c);
    }
    return new $5b8488dadf327a2c$var$K(i, a, e, r);
}
var $5b8488dadf327a2c$var$Ou = $5b8488dadf327a2c$var$ft.prototype.constructor;
function $5b8488dadf327a2c$var$ci() {
    return new $5b8488dadf327a2c$var$Ou(this._groups, this._parents);
}
function $5b8488dadf327a2c$var$Iu(t, e) {
    var r, n, o;
    return function() {
        var i = $5b8488dadf327a2c$var$ht(this, t), a = (this.style.removeProperty(t), $5b8488dadf327a2c$var$ht(this, t));
        return i === a ? null : i === r && a === n ? o : o = e(r = i, n = a);
    };
}
function $5b8488dadf327a2c$var$fi(t) {
    return function() {
        this.style.removeProperty(t);
    };
}
function $5b8488dadf327a2c$var$Lu(t, e, r) {
    var n, o = r + "", i;
    return function() {
        var a = $5b8488dadf327a2c$var$ht(this, t);
        return a === o ? null : a === n ? i : i = e(n = a, r);
    };
}
function $5b8488dadf327a2c$var$Pu(t, e, r) {
    var n, o, i;
    return function() {
        var a = $5b8488dadf327a2c$var$ht(this, t), s = r(this), l = s + "";
        return s == null && (l = s = (this.style.removeProperty(t), $5b8488dadf327a2c$var$ht(this, t))), a === l ? null : a === n && l === o ? i : (o = l, i = e(n = a, s));
    };
}
function $5b8488dadf327a2c$var$zu(t, e) {
    var r, n, o, i = "style." + e, a = "end." + i, s;
    return function() {
        var l = $5b8488dadf327a2c$var$W(this, t), u = l.on, c = l.value[i] == null ? s || (s = $5b8488dadf327a2c$var$fi(e)) : void 0;
        (u !== r || o !== c) && (n = (r = u).copy()).on(a, o = c), l.on = n;
    };
}
function $5b8488dadf327a2c$var$pi(t, e, r) {
    var n = (t += "") == "transform" ? $5b8488dadf327a2c$var$Ur : $5b8488dadf327a2c$var$Ze;
    return e == null ? this.styleTween(t, $5b8488dadf327a2c$var$Iu(t, n)).on("end.style." + t, $5b8488dadf327a2c$var$fi(t)) : typeof e == "function" ? this.styleTween(t, $5b8488dadf327a2c$var$Pu(t, n, $5b8488dadf327a2c$var$$t(this, "style." + t, e))).each($5b8488dadf327a2c$var$zu(this._id, t)) : this.styleTween(t, $5b8488dadf327a2c$var$Lu(t, n, e), r).on("end.style." + t, null);
}
function $5b8488dadf327a2c$var$Hu(t, e, r) {
    return function(n) {
        this.style.setProperty(t, e.call(this, n), r);
    };
}
function $5b8488dadf327a2c$var$$u(t, e, r) {
    var n, o;
    function i() {
        var a = e.apply(this, arguments);
        return a !== o && (n = (o = a) && $5b8488dadf327a2c$var$Hu(t, a, r)), n;
    }
    return i._value = e, i;
}
function $5b8488dadf327a2c$var$hi(t, e, r) {
    var n = "style." + (t += "");
    if (arguments.length < 2) return (n = this.tween(n)) && n._value;
    if (e == null) return this.tween(n, null);
    if (typeof e != "function") throw new Error;
    return this.tween(n, $5b8488dadf327a2c$var$$u(t, e, r ?? ""));
}
function $5b8488dadf327a2c$var$Bu(t) {
    return function() {
        this.textContent = t;
    };
}
function $5b8488dadf327a2c$var$Vu(t) {
    return function() {
        var e = t(this);
        this.textContent = e ?? "";
    };
}
function $5b8488dadf327a2c$var$mi(t) {
    return this.tween("text", typeof t == "function" ? $5b8488dadf327a2c$var$Vu($5b8488dadf327a2c$var$$t(this, "text", t)) : $5b8488dadf327a2c$var$Bu(t == null ? "" : t + ""));
}
function $5b8488dadf327a2c$var$Yu(t) {
    return function(e) {
        this.textContent = t.call(this, e);
    };
}
function $5b8488dadf327a2c$var$Uu(t) {
    var e, r;
    function n() {
        var o = t.apply(this, arguments);
        return o !== r && (e = (r = o) && $5b8488dadf327a2c$var$Yu(o)), e;
    }
    return n._value = t, n;
}
function $5b8488dadf327a2c$var$di(t) {
    var e = "text";
    if (arguments.length < 1) return (e = this.tween(e)) && e._value;
    if (t == null) return this.tween(e, null);
    if (typeof t != "function") throw new Error;
    return this.tween(e, $5b8488dadf327a2c$var$Uu(t));
}
function $5b8488dadf327a2c$var$gi() {
    for(var t = this._name, e = this._id, r = $5b8488dadf327a2c$var$Qe(), n = this._groups, o = n.length, i = 0; i < o; ++i)for(var a = n[i], s = a.length, l, u = 0; u < s; ++u)if (l = a[u]) {
        var c = $5b8488dadf327a2c$var$V(l, e);
        $5b8488dadf327a2c$var$mt(l, t, r, u, a, {
            time: c.time + c.delay + c.duration,
            delay: 0,
            duration: c.duration,
            ease: c.ease
        });
    }
    return new $5b8488dadf327a2c$var$K(n, this._parents, t, r);
}
function $5b8488dadf327a2c$var$yi() {
    var t, e, r = this, n = r._id, o = r.size();
    return new Promise(function(i, a) {
        var s = {
            value: a
        }, l = {
            value: function() {
                --o === 0 && i();
            }
        };
        r.each(function() {
            var u = $5b8488dadf327a2c$var$W(this, n), c = u.on;
            c !== t && (e = (t = c).copy(), e._.cancel.push(s), e._.interrupt.push(s), e._.end.push(l)), u.on = e;
        }), o === 0 && i();
    });
}
var $5b8488dadf327a2c$var$qu = 0;
function $5b8488dadf327a2c$var$K(t, e, r, n) {
    this._groups = t, this._parents = e, this._name = r, this._id = n;
}
function $5b8488dadf327a2c$var$xi(t) {
    return $5b8488dadf327a2c$var$ft().transition(t);
}
function $5b8488dadf327a2c$var$Qe() {
    return ++$5b8488dadf327a2c$var$qu;
}
var $5b8488dadf327a2c$var$pt = $5b8488dadf327a2c$var$ft.prototype;
$5b8488dadf327a2c$var$K.prototype = $5b8488dadf327a2c$var$xi.prototype = {
    constructor: $5b8488dadf327a2c$var$K,
    select: $5b8488dadf327a2c$var$ui,
    selectAll: $5b8488dadf327a2c$var$li,
    selectChild: $5b8488dadf327a2c$var$pt.selectChild,
    selectChildren: $5b8488dadf327a2c$var$pt.selectChildren,
    filter: $5b8488dadf327a2c$var$oi,
    merge: $5b8488dadf327a2c$var$ii,
    selection: $5b8488dadf327a2c$var$ci,
    transition: $5b8488dadf327a2c$var$gi,
    call: $5b8488dadf327a2c$var$pt.call,
    nodes: $5b8488dadf327a2c$var$pt.nodes,
    node: $5b8488dadf327a2c$var$pt.node,
    size: $5b8488dadf327a2c$var$pt.size,
    empty: $5b8488dadf327a2c$var$pt.empty,
    each: $5b8488dadf327a2c$var$pt.each,
    on: $5b8488dadf327a2c$var$ai,
    attr: $5b8488dadf327a2c$var$Qo,
    attrTween: $5b8488dadf327a2c$var$Jo,
    style: $5b8488dadf327a2c$var$pi,
    styleTween: $5b8488dadf327a2c$var$hi,
    text: $5b8488dadf327a2c$var$mi,
    textTween: $5b8488dadf327a2c$var$di,
    remove: $5b8488dadf327a2c$var$si,
    tween: $5b8488dadf327a2c$var$Zo,
    delay: $5b8488dadf327a2c$var$ti,
    duration: $5b8488dadf327a2c$var$ei,
    ease: $5b8488dadf327a2c$var$ri,
    easeVarying: $5b8488dadf327a2c$var$ni,
    end: $5b8488dadf327a2c$var$yi,
    [Symbol.iterator]: $5b8488dadf327a2c$var$pt[Symbol.iterator]
};
var $5b8488dadf327a2c$var$X = (t)=>+t;
function $5b8488dadf327a2c$var$Je(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var $5b8488dadf327a2c$var$Wu = {
    time: null,
    delay: 0,
    duration: 250,
    ease: $5b8488dadf327a2c$var$Je
};
function $5b8488dadf327a2c$var$Xu(t, e) {
    for(var r; !(r = t.__transition) || !(r = r[e]);)if (!(t = t.parentNode)) throw new Error(`transition ${e} not found`);
    return r;
}
function $5b8488dadf327a2c$var$vi(t) {
    var e, r;
    t instanceof $5b8488dadf327a2c$var$K ? (e = t._id, t = t._name) : (e = $5b8488dadf327a2c$var$Qe(), (r = $5b8488dadf327a2c$var$Wu).time = $5b8488dadf327a2c$var$Tt(), t = t == null ? null : t + "");
    for(var n = this._groups, o = n.length, i = 0; i < o; ++i)for(var a = n[i], s = a.length, l, u = 0; u < s; ++u)(l = a[u]) && $5b8488dadf327a2c$var$mt(l, t, e, u, a, r || $5b8488dadf327a2c$var$Xu(l, e));
    return new $5b8488dadf327a2c$var$K(n, this._parents, t, e);
}
$5b8488dadf327a2c$var$ft.prototype.interrupt = $5b8488dadf327a2c$var$Ko;
$5b8488dadf327a2c$var$ft.prototype.transition = $5b8488dadf327a2c$var$vi;
var { abs: $5b8488dadf327a2c$var$Jd, max: $5b8488dadf327a2c$var$tg, min: $5b8488dadf327a2c$var$eg } = Math;
function $5b8488dadf327a2c$var$wi(t) {
    return [
        +t[0],
        +t[1]
    ];
}
function $5b8488dadf327a2c$var$ju(t) {
    return [
        $5b8488dadf327a2c$var$wi(t[0]),
        $5b8488dadf327a2c$var$wi(t[1])
    ];
}
var $5b8488dadf327a2c$var$rg = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5b8488dadf327a2c$var$Xr),
    input: function(t, e) {
        return t == null ? null : [
            [
                +t[0],
                e[0][1]
            ],
            [
                +t[1],
                e[1][1]
            ]
        ];
    },
    output: function(t) {
        return t && [
            t[0][0],
            t[1][0]
        ];
    }
}, $5b8488dadf327a2c$var$ng = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5b8488dadf327a2c$var$Xr),
    input: function(t, e) {
        return t == null ? null : [
            [
                e[0][0],
                +t[0]
            ],
            [
                e[1][0],
                +t[1]
            ]
        ];
    },
    output: function(t) {
        return t && [
            t[0][1],
            t[1][1]
        ];
    }
}, $5b8488dadf327a2c$var$og = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5b8488dadf327a2c$var$Xr),
    input: function(t) {
        return t == null ? null : $5b8488dadf327a2c$var$ju(t);
    },
    output: function(t) {
        return t;
    }
};
function $5b8488dadf327a2c$var$Xr(t) {
    return {
        type: t
    };
}
var $5b8488dadf327a2c$var$_i = {}, $5b8488dadf327a2c$var$jr = {}, $5b8488dadf327a2c$var$Gr = 34, $5b8488dadf327a2c$var$pe = 10, $5b8488dadf327a2c$var$Kr = 13;
function $5b8488dadf327a2c$var$Di(t) {
    return new Function("d", "return {" + t.map(function(e, r) {
        return JSON.stringify(e) + ": d[" + r + '] || ""';
    }).join(",") + "}");
}
function $5b8488dadf327a2c$var$Gu(t, e) {
    var r = $5b8488dadf327a2c$var$Di(t);
    return function(n, o) {
        return e(r(n), o, t);
    };
}
function $5b8488dadf327a2c$var$bi(t) {
    var e = Object.create(null), r = [];
    return t.forEach(function(n) {
        for(var o in n)o in e || r.push(e[o] = o);
    }), r;
}
function $5b8488dadf327a2c$var$Q(t, e) {
    var r = t + "", n = r.length;
    return n < e ? new Array(e - n + 1).join(0) + r : r;
}
function $5b8488dadf327a2c$var$Ku(t) {
    return t < 0 ? "-" + $5b8488dadf327a2c$var$Q(-t, 6) : t > 9999 ? "+" + $5b8488dadf327a2c$var$Q(t, 6) : $5b8488dadf327a2c$var$Q(t, 4);
}
function $5b8488dadf327a2c$var$Zu(t) {
    var e = t.getUTCHours(), r = t.getUTCMinutes(), n = t.getUTCSeconds(), o = t.getUTCMilliseconds();
    return isNaN(t) ? "Invalid Date" : $5b8488dadf327a2c$var$Ku(t.getUTCFullYear(), 4) + "-" + $5b8488dadf327a2c$var$Q(t.getUTCMonth() + 1, 2) + "-" + $5b8488dadf327a2c$var$Q(t.getUTCDate(), 2) + (o ? "T" + $5b8488dadf327a2c$var$Q(e, 2) + ":" + $5b8488dadf327a2c$var$Q(r, 2) + ":" + $5b8488dadf327a2c$var$Q(n, 2) + "." + $5b8488dadf327a2c$var$Q(o, 3) + "Z" : n ? "T" + $5b8488dadf327a2c$var$Q(e, 2) + ":" + $5b8488dadf327a2c$var$Q(r, 2) + ":" + $5b8488dadf327a2c$var$Q(n, 2) + "Z" : r || e ? "T" + $5b8488dadf327a2c$var$Q(e, 2) + ":" + $5b8488dadf327a2c$var$Q(r, 2) + "Z" : "");
}
function $5b8488dadf327a2c$var$he(t) {
    var e = new RegExp('["' + t + `
\r]`), r = t.charCodeAt(0);
    function n(f, p) {
        var h, m, g = o(f, function(x, b) {
            if (h) return h(x, b - 1);
            m = x, h = p ? $5b8488dadf327a2c$var$Gu(x, p) : $5b8488dadf327a2c$var$Di(x);
        });
        return g.columns = m || [], g;
    }
    function o(f, p) {
        var h = [], m = f.length, g = 0, x = 0, b, D = m <= 0, k = !1;
        f.charCodeAt(m - 1) === $5b8488dadf327a2c$var$pe && --m, f.charCodeAt(m - 1) === $5b8488dadf327a2c$var$Kr && --m;
        function S() {
            if (D) return $5b8488dadf327a2c$var$jr;
            if (k) return k = !1, $5b8488dadf327a2c$var$_i;
            var w, E = g, R;
            if (f.charCodeAt(E) === $5b8488dadf327a2c$var$Gr) {
                for(; g++ < m && f.charCodeAt(g) !== $5b8488dadf327a2c$var$Gr || f.charCodeAt(++g) === $5b8488dadf327a2c$var$Gr;);
                return (w = g) >= m ? D = !0 : (R = f.charCodeAt(g++)) === $5b8488dadf327a2c$var$pe ? k = !0 : R === $5b8488dadf327a2c$var$Kr && (k = !0, f.charCodeAt(g) === $5b8488dadf327a2c$var$pe && ++g), f.slice(E + 1, w - 1).replace(/""/g, '"');
            }
            for(; g < m;){
                if ((R = f.charCodeAt(w = g++)) === $5b8488dadf327a2c$var$pe) k = !0;
                else if (R === $5b8488dadf327a2c$var$Kr) k = !0, f.charCodeAt(g) === $5b8488dadf327a2c$var$pe && ++g;
                else if (R !== r) continue;
                return f.slice(E, w);
            }
            return D = !0, f.slice(E, m);
        }
        for(; (b = S()) !== $5b8488dadf327a2c$var$jr;){
            for(var d = []; b !== $5b8488dadf327a2c$var$_i && b !== $5b8488dadf327a2c$var$jr;)d.push(b), b = S();
            p && (d = p(d, x++)) == null || h.push(d);
        }
        return h;
    }
    function i(f, p) {
        return f.map(function(h) {
            return p.map(function(m) {
                return c(h[m]);
            }).join(t);
        });
    }
    function a(f, p) {
        return p == null && (p = $5b8488dadf327a2c$var$bi(f)), [
            p.map(c).join(t)
        ].concat(i(f, p)).join(`
`);
    }
    function s(f, p) {
        return p == null && (p = $5b8488dadf327a2c$var$bi(f)), i(f, p).join(`
`);
    }
    function l(f) {
        return f.map(u).join(`
`);
    }
    function u(f) {
        return f.map(c).join(t);
    }
    function c(f) {
        return f == null ? "" : f instanceof Date ? $5b8488dadf327a2c$var$Zu(f) : e.test(f += "") ? '"' + f.replace(/"/g, '""') + '"' : f;
    }
    return {
        parse: n,
        parseRows: o,
        format: a,
        formatBody: s,
        formatRows: l,
        formatRow: u,
        formatValue: c
    };
}
var $5b8488dadf327a2c$var$Mt = $5b8488dadf327a2c$var$he(","), $5b8488dadf327a2c$var$Zr = $5b8488dadf327a2c$var$Mt.parse, $5b8488dadf327a2c$var$Qu = $5b8488dadf327a2c$var$Mt.parseRows, $5b8488dadf327a2c$var$Ju = $5b8488dadf327a2c$var$Mt.format, $5b8488dadf327a2c$var$tl = $5b8488dadf327a2c$var$Mt.formatBody, $5b8488dadf327a2c$var$el = $5b8488dadf327a2c$var$Mt.formatRows, $5b8488dadf327a2c$var$rl = $5b8488dadf327a2c$var$Mt.formatRow, $5b8488dadf327a2c$var$nl = $5b8488dadf327a2c$var$Mt.formatValue;
var $5b8488dadf327a2c$var$Et = $5b8488dadf327a2c$var$he("	"), $5b8488dadf327a2c$var$Qr = $5b8488dadf327a2c$var$Et.parse, $5b8488dadf327a2c$var$ol = $5b8488dadf327a2c$var$Et.parseRows, $5b8488dadf327a2c$var$il = $5b8488dadf327a2c$var$Et.format, $5b8488dadf327a2c$var$al = $5b8488dadf327a2c$var$Et.formatBody, $5b8488dadf327a2c$var$sl = $5b8488dadf327a2c$var$Et.formatRows, $5b8488dadf327a2c$var$ul = $5b8488dadf327a2c$var$Et.formatRow, $5b8488dadf327a2c$var$ll = $5b8488dadf327a2c$var$Et.formatValue;
function $5b8488dadf327a2c$var$cl(t) {
    if (!t.ok) throw new Error(t.status + " " + t.statusText);
    return t.text();
}
function $5b8488dadf327a2c$var$tr(t, e) {
    return fetch(t, e).then($5b8488dadf327a2c$var$cl);
}
function $5b8488dadf327a2c$var$ki(t) {
    return function(e, r, n) {
        return arguments.length === 2 && typeof r == "function" && (n = r, r = void 0), $5b8488dadf327a2c$var$tr(e, r).then(function(o) {
            return t(o, n);
        });
    };
}
var $5b8488dadf327a2c$var$er = $5b8488dadf327a2c$var$ki($5b8488dadf327a2c$var$Zr), $5b8488dadf327a2c$var$rr = $5b8488dadf327a2c$var$ki($5b8488dadf327a2c$var$Qr);
function $5b8488dadf327a2c$var$fl(t) {
    if (!t.ok) throw new Error(t.status + " " + t.statusText);
    if (!(t.status === 204 || t.status === 205)) return t.json();
}
function $5b8488dadf327a2c$var$nr(t, e) {
    return fetch(t, e).then($5b8488dadf327a2c$var$fl);
}
function $5b8488dadf327a2c$var$Jr(t) {
    return (e, r)=>$5b8488dadf327a2c$var$tr(e, r).then((n)=>new DOMParser().parseFromString(n, t));
}
var $5b8488dadf327a2c$var$or = $5b8488dadf327a2c$var$Jr("application/xml"), $5b8488dadf327a2c$var$pl = $5b8488dadf327a2c$var$Jr("text/html"), $5b8488dadf327a2c$var$hl = $5b8488dadf327a2c$var$Jr("image/svg+xml");
function $5b8488dadf327a2c$var$Si(t) {
    return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function $5b8488dadf327a2c$var$Ct(t, e) {
    if ((r = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
    var r, n = t.slice(0, r);
    return [
        n.length > 1 ? n[0] + n.slice(2) : n,
        +t.slice(r + 1)
    ];
}
function $5b8488dadf327a2c$var$ut(t) {
    return t = $5b8488dadf327a2c$var$Ct(Math.abs(t)), t ? t[1] : NaN;
}
function $5b8488dadf327a2c$var$Ai(t, e) {
    return function(r, n) {
        for(var o = r.length, i = [], a = 0, s = t[0], l = 0; o > 0 && s > 0 && (l + s + 1 > n && (s = Math.max(1, n - l)), i.push(r.substring(o -= s, o + s)), !((l += s + 1) > n));)s = t[a = (a + 1) % t.length];
        return i.reverse().join(e);
    };
}
function $5b8488dadf327a2c$var$Ti(t) {
    return function(e) {
        return e.replace(/[0-9]/g, function(r) {
            return t[+r];
        });
    };
}
var $5b8488dadf327a2c$var$ml = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $5b8488dadf327a2c$var$dt(t) {
    if (!(e = $5b8488dadf327a2c$var$ml.exec(t))) throw new Error("invalid format: " + t);
    var e;
    return new $5b8488dadf327a2c$var$ir({
        fill: e[1],
        align: e[2],
        sign: e[3],
        symbol: e[4],
        zero: e[5],
        width: e[6],
        comma: e[7],
        precision: e[8] && e[8].slice(1),
        trim: e[9],
        type: e[10]
    });
}
$5b8488dadf327a2c$var$dt.prototype = $5b8488dadf327a2c$var$ir.prototype;
function $5b8488dadf327a2c$var$ir(t) {
    this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
$5b8488dadf327a2c$var$ir.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function $5b8488dadf327a2c$var$Mi(t) {
    t: for(var e = t.length, r = 1, n = -1, o; r < e; ++r)switch(t[r]){
        case ".":
            n = o = r;
            break;
        case "0":
            n === 0 && (n = r), o = r;
            break;
        default:
            if (!+t[r]) break t;
            n > 0 && (n = 0);
            break;
    }
    return n > 0 ? t.slice(0, n) + t.slice(o + 1) : t;
}
var $5b8488dadf327a2c$var$tn;
function $5b8488dadf327a2c$var$Ei(t, e) {
    var r = $5b8488dadf327a2c$var$Ct(t, e);
    if (!r) return t + "";
    var n = r[0], o = r[1], i = o - ($5b8488dadf327a2c$var$tn = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, a = n.length;
    return i === a ? n : i > a ? n + new Array(i - a + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + $5b8488dadf327a2c$var$Ct(t, Math.max(0, e + i - 1))[0];
}
function $5b8488dadf327a2c$var$en(t, e) {
    var r = $5b8488dadf327a2c$var$Ct(t, e);
    if (!r) return t + "";
    var n = r[0], o = r[1];
    return o < 0 ? "0." + new Array(-o).join("0") + n : n.length > o + 1 ? n.slice(0, o + 1) + "." + n.slice(o + 1) : n + new Array(o - n.length + 2).join("0");
}
var $5b8488dadf327a2c$var$rn = {
    "%": (t, e)=>(t * 100).toFixed(e),
    b: (t)=>Math.round(t).toString(2),
    c: (t)=>t + "",
    d: $5b8488dadf327a2c$var$Si,
    e: (t, e)=>t.toExponential(e),
    f: (t, e)=>t.toFixed(e),
    g: (t, e)=>t.toPrecision(e),
    o: (t)=>Math.round(t).toString(8),
    p: (t, e)=>$5b8488dadf327a2c$var$en(t * 100, e),
    r: $5b8488dadf327a2c$var$en,
    s: $5b8488dadf327a2c$var$Ei,
    X: (t)=>Math.round(t).toString(16).toUpperCase(),
    x: (t)=>Math.round(t).toString(16)
};
function $5b8488dadf327a2c$var$nn(t) {
    return t;
}
var $5b8488dadf327a2c$var$Ci = Array.prototype.map, $5b8488dadf327a2c$var$Ni = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xB5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $5b8488dadf327a2c$var$Ri(t) {
    var e = t.grouping === void 0 || t.thousands === void 0 ? $5b8488dadf327a2c$var$nn : $5b8488dadf327a2c$var$Ai($5b8488dadf327a2c$var$Ci.call(t.grouping, Number), t.thousands + ""), r = t.currency === void 0 ? "" : t.currency[0] + "", n = t.currency === void 0 ? "" : t.currency[1] + "", o = t.decimal === void 0 ? "." : t.decimal + "", i = t.numerals === void 0 ? $5b8488dadf327a2c$var$nn : $5b8488dadf327a2c$var$Ti($5b8488dadf327a2c$var$Ci.call(t.numerals, String)), a = t.percent === void 0 ? "%" : t.percent + "", s = t.minus === void 0 ? "\u2212" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
    function u(f) {
        f = $5b8488dadf327a2c$var$dt(f);
        var p = f.fill, h = f.align, m = f.sign, g = f.symbol, x = f.zero, b = f.width, D = f.comma, k = f.precision, S = f.trim, d = f.type;
        d === "n" ? (D = !0, d = "g") : $5b8488dadf327a2c$var$rn[d] || (k === void 0 && (k = 12), S = !0, d = "g"), (x || p === "0" && h === "=") && (x = !0, p = "0", h = "=");
        var w = g === "$" ? r : g === "#" && /[boxX]/.test(d) ? "0" + d.toLowerCase() : "", E = g === "$" ? n : /[%p]/.test(d) ? a : "", R = $5b8488dadf327a2c$var$rn[d], I = /[defgprs%]/.test(d);
        k = k === void 0 ? 6 : /[gprs]/.test(d) ? Math.max(1, Math.min(21, k)) : Math.max(0, Math.min(20, k));
        function H(_) {
            var C = w, A = E, L, O, z;
            if (d === "c") A = R(_) + A, _ = "";
            else {
                _ = +_;
                var $ = _ < 0 || 1 / _ < 0;
                if (_ = isNaN(_) ? l : R(Math.abs(_), k), S && (_ = $5b8488dadf327a2c$var$Mi(_)), $ && +_ == 0 && m !== "+" && ($ = !1), C = ($ ? m === "(" ? m : s : m === "-" || m === "(" ? "" : m) + C, A = (d === "s" ? $5b8488dadf327a2c$var$Ni[8 + $5b8488dadf327a2c$var$tn / 3] : "") + A + ($ && m === "(" ? ")" : ""), I) {
                    for(L = -1, O = _.length; ++L < O;)if (z = _.charCodeAt(L), 48 > z || z > 57) {
                        A = (z === 46 ? o + _.slice(L + 1) : _.slice(L)) + A, _ = _.slice(0, L);
                        break;
                    }
                }
            }
            D && !x && (_ = e(_, 1 / 0));
            var G = C.length + _.length + A.length, y = G < b ? new Array(b - G + 1).join(p) : "";
            switch(D && x && (_ = e(y + _, y.length ? b - A.length : 1 / 0), y = ""), h){
                case "<":
                    _ = C + _ + A + y;
                    break;
                case "=":
                    _ = C + y + _ + A;
                    break;
                case "^":
                    _ = y.slice(0, G = y.length >> 1) + C + _ + A + y.slice(G);
                    break;
                default:
                    _ = y + C + _ + A;
                    break;
            }
            return i(_);
        }
        return H.toString = function() {
            return f + "";
        }, H;
    }
    function c(f, p) {
        var h = u((f = $5b8488dadf327a2c$var$dt(f), f.type = "f", f)), m = Math.max(-8, Math.min(8, Math.floor($5b8488dadf327a2c$var$ut(p) / 3))) * 3, g = Math.pow(10, -m), x = $5b8488dadf327a2c$var$Ni[8 + m / 3];
        return function(b) {
            return h(g * b) + x;
        };
    }
    return {
        format: u,
        formatPrefix: c
    };
}
var $5b8488dadf327a2c$var$ar, $5b8488dadf327a2c$var$nt, $5b8488dadf327a2c$var$sr;
$5b8488dadf327a2c$var$on({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $5b8488dadf327a2c$var$on(t) {
    return $5b8488dadf327a2c$var$ar = $5b8488dadf327a2c$var$Ri(t), $5b8488dadf327a2c$var$nt = $5b8488dadf327a2c$var$ar.format, $5b8488dadf327a2c$var$sr = $5b8488dadf327a2c$var$ar.formatPrefix, $5b8488dadf327a2c$var$ar;
}
function $5b8488dadf327a2c$var$an(t) {
    return Math.max(0, -$5b8488dadf327a2c$var$ut(Math.abs(t)));
}
function $5b8488dadf327a2c$var$sn(t, e) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor($5b8488dadf327a2c$var$ut(e) / 3))) * 3 - $5b8488dadf327a2c$var$ut(Math.abs(t)));
}
function $5b8488dadf327a2c$var$un(t, e) {
    return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, $5b8488dadf327a2c$var$ut(e) - $5b8488dadf327a2c$var$ut(t)) + 1;
}
function $5b8488dadf327a2c$var$Fi(t, e) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(t);
            break;
        default:
            this.range(e).domain(t);
            break;
    }
    return this;
}
function $5b8488dadf327a2c$var$ln(t) {
    return function() {
        return t;
    };
}
function $5b8488dadf327a2c$var$cn(t) {
    return +t;
}
var $5b8488dadf327a2c$var$Oi = [
    0,
    1
];
function $5b8488dadf327a2c$var$Bt(t) {
    return t;
}
function $5b8488dadf327a2c$var$fn(t, e) {
    return (e -= t = +t) ? function(r) {
        return (r - t) / e;
    } : $5b8488dadf327a2c$var$ln(isNaN(e) ? NaN : .5);
}
function $5b8488dadf327a2c$var$dl(t, e) {
    var r;
    return t > e && (r = t, t = e, e = r), function(n) {
        return Math.max(t, Math.min(e, n));
    };
}
function $5b8488dadf327a2c$var$gl(t, e, r) {
    var n = t[0], o = t[1], i = e[0], a = e[1];
    return o < n ? (n = $5b8488dadf327a2c$var$fn(o, n), i = r(a, i)) : (n = $5b8488dadf327a2c$var$fn(n, o), i = r(i, a)), function(s) {
        return i(n(s));
    };
}
function $5b8488dadf327a2c$var$yl(t, e, r) {
    var n = Math.min(t.length, e.length) - 1, o = new Array(n), i = new Array(n), a = -1;
    for(t[n] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++a < n;)o[a] = $5b8488dadf327a2c$var$fn(t[a], t[a + 1]), i[a] = r(e[a], e[a + 1]);
    return function(s) {
        var l = $5b8488dadf327a2c$var$Cr(t, s, 1, n) - 1;
        return i[l](o[l](s));
    };
}
function $5b8488dadf327a2c$var$Ii(t, e) {
    return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function $5b8488dadf327a2c$var$xl() {
    var t = $5b8488dadf327a2c$var$Oi, e = $5b8488dadf327a2c$var$Oi, r = $5b8488dadf327a2c$var$st, n, o, i, a = $5b8488dadf327a2c$var$Bt, s, l, u;
    function c() {
        var p = Math.min(t.length, e.length);
        return a !== $5b8488dadf327a2c$var$Bt && (a = $5b8488dadf327a2c$var$dl(t[0], t[p - 1])), s = p > 2 ? $5b8488dadf327a2c$var$yl : $5b8488dadf327a2c$var$gl, l = u = null, f;
    }
    function f(p) {
        return p == null || isNaN(p = +p) ? i : (l || (l = s(t.map(n), e, r)))(n(a(p)));
    }
    return f.invert = function(p) {
        return a(o((u || (u = s(e, t.map(n), $5b8488dadf327a2c$var$q)))(p)));
    }, f.domain = function(p) {
        return arguments.length ? (t = Array.from(p, $5b8488dadf327a2c$var$cn), c()) : t.slice();
    }, f.range = function(p) {
        return arguments.length ? (e = Array.from(p), c()) : e.slice();
    }, f.rangeRound = function(p) {
        return e = Array.from(p), r = $5b8488dadf327a2c$var$ze, c();
    }, f.clamp = function(p) {
        return arguments.length ? (a = p ? !0 : $5b8488dadf327a2c$var$Bt, c()) : a !== $5b8488dadf327a2c$var$Bt;
    }, f.interpolate = function(p) {
        return arguments.length ? (r = p, c()) : r;
    }, f.unknown = function(p) {
        return arguments.length ? (i = p, f) : i;
    }, function(p, h) {
        return n = p, o = h, c();
    };
}
function $5b8488dadf327a2c$var$pn() {
    return $5b8488dadf327a2c$var$xl()($5b8488dadf327a2c$var$Bt, $5b8488dadf327a2c$var$Bt);
}
function $5b8488dadf327a2c$var$hn(t, e, r, n) {
    var o = $5b8488dadf327a2c$var$Nr(t, e, r), i;
    switch(n = $5b8488dadf327a2c$var$dt(n ?? ",f"), n.type){
        case "s":
            var a = Math.max(Math.abs(t), Math.abs(e));
            return n.precision == null && !isNaN(i = $5b8488dadf327a2c$var$sn(o, a)) && (n.precision = i), $5b8488dadf327a2c$var$sr(n, a);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            n.precision == null && !isNaN(i = $5b8488dadf327a2c$var$un(o, Math.max(Math.abs(t), Math.abs(e)))) && (n.precision = i - (n.type === "e"));
            break;
        case "f":
        case "%":
            n.precision == null && !isNaN(i = $5b8488dadf327a2c$var$an(o)) && (n.precision = i - (n.type === "%") * 2);
            break;
    }
    return $5b8488dadf327a2c$var$nt(n);
}
function $5b8488dadf327a2c$var$vl(t) {
    var e = t.domain;
    return t.ticks = function(r) {
        var n = e();
        return $5b8488dadf327a2c$var$be(n[0], n[n.length - 1], r ?? 10);
    }, t.tickFormat = function(r, n) {
        var o = e();
        return $5b8488dadf327a2c$var$hn(o[0], o[o.length - 1], r ?? 10, n);
    }, t.nice = function(r) {
        r == null && (r = 10);
        var n = e(), o = 0, i = n.length - 1, a = n[o], s = n[i], l, u, c = 10;
        for(s < a && (u = a, a = s, s = u, u = o, o = i, i = u); c-- > 0;){
            if (u = $5b8488dadf327a2c$var$Kt(a, s, r), u === l) return n[o] = a, n[i] = s, e(n);
            if (u > 0) a = Math.floor(a / u) * u, s = Math.ceil(s / u) * u;
            else if (u < 0) a = Math.ceil(a * u) / u, s = Math.floor(s * u) / u;
            else break;
            l = u;
        }
        return t;
    }, t;
}
function $5b8488dadf327a2c$var$Nt() {
    var t = $5b8488dadf327a2c$var$pn();
    return t.copy = function() {
        return $5b8488dadf327a2c$var$Ii(t, $5b8488dadf327a2c$var$Nt());
    }, $5b8488dadf327a2c$var$Fi.apply(t, arguments), $5b8488dadf327a2c$var$vl(t);
}
function $5b8488dadf327a2c$var$gt(t, e, r) {
    this.k = t, this.x = e, this.y = r;
}
$5b8488dadf327a2c$var$gt.prototype = {
    constructor: $5b8488dadf327a2c$var$gt,
    scale: function(t) {
        return t === 1 ? this : new $5b8488dadf327a2c$var$gt(this.k * t, this.x, this.y);
    },
    translate: function(t, e) {
        return t === 0 & e === 0 ? this : new $5b8488dadf327a2c$var$gt(this.k, this.x + this.k * t, this.y + this.k * e);
    },
    apply: function(t) {
        return [
            t[0] * this.k + this.x,
            t[1] * this.k + this.y
        ];
    },
    applyX: function(t) {
        return t * this.k + this.x;
    },
    applyY: function(t) {
        return t * this.k + this.y;
    },
    invert: function(t) {
        return [
            (t[0] - this.x) / this.k,
            (t[1] - this.y) / this.k
        ];
    },
    invertX: function(t) {
        return (t - this.x) / this.k;
    },
    invertY: function(t) {
        return (t - this.y) / this.k;
    },
    rescaleX: function(t) {
        return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
    },
    rescaleY: function(t) {
        return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $5b8488dadf327a2c$var$mn = new $5b8488dadf327a2c$var$gt(1, 0, 0);
$5b8488dadf327a2c$var$dn.prototype = $5b8488dadf327a2c$var$gt.prototype;
function $5b8488dadf327a2c$var$dn(t) {
    for(; !t.__zoom;)if (!(t = t.parentNode)) return $5b8488dadf327a2c$var$mn;
    return t.__zoom;
}
function $5b8488dadf327a2c$var$gn(t) {
    let e;
    function r() {
        let u = !0;
        e = $5b8488dadf327a2c$var$We(c, t.getState().options.tickDuration), t.dispatch($5b8488dadf327a2c$var$T.ticker.setRunning(!0));
        function c(f) {
            t.getState().ticker.isLastDate ? t.getState().options.loop || u ? i() : n() : t.dispatch($5b8488dadf327a2c$var$T.ticker.inc()), u = !1;
        }
    }
    function n() {
        e && e.stop(), t.dispatch($5b8488dadf327a2c$var$T.ticker.setRunning(!1));
    }
    function o() {
        n(), t.dispatch($5b8488dadf327a2c$var$T.ticker.setFirst());
    }
    function i() {
        t.dispatch($5b8488dadf327a2c$var$T.ticker.setFirst());
    }
    function a() {
        n(), t.dispatch($5b8488dadf327a2c$var$T.ticker.setLast()), t.dispatch($5b8488dadf327a2c$var$T.ticker.setLast());
    }
    function s() {
        t.getState().ticker.isLastDate ? (o(), r()) : t.getState().ticker.isRunning ? n() : r();
    }
    function l(u) {
        t.dispatch($5b8488dadf327a2c$var$T.ticker.updateDate(u));
    }
    return {
        start: r,
        stop: n,
        skipBack: o,
        loop: i,
        skipForward: a,
        toggle: s,
        goToDate: l
    };
}
var $5b8488dadf327a2c$var$T = {
    container: $5b8488dadf327a2c$var$Dr,
    data: $5b8488dadf327a2c$var$Ar,
    options: $5b8488dadf327a2c$var$xn,
    ticker: $5b8488dadf327a2c$var$yn
};
var $5b8488dadf327a2c$var$ur = (t, e)=>({
        container: $5b8488dadf327a2c$var$br(t.container, e),
        data: $5b8488dadf327a2c$var$Sr(t.data, e),
        options: $5b8488dadf327a2c$var$vn(t.options, e),
        ticker: $5b8488dadf327a2c$var$Tr(t.ticker, e),
        triggerRender: e.triggerRender ?? !0
    });
function $5b8488dadf327a2c$var$Li(t = $5b8488dadf327a2c$var$ur, e) {
    let r = {};
    e && (r = e);
    function n(u) {
        return r = t(r, u), s(), u;
    }
    function o() {
        return r;
    }
    let i = [];
    function a(u) {
        return i.push(u), {
            unsubscribe: ()=>{
                i.splice(i.indexOf(u), 1);
            }
        };
    }
    function s() {
        i.forEach((u)=>{
            u();
        });
    }
    function l() {
        i.length = 0;
    }
    return {
        getState: o,
        dispatch: n,
        subscribe: a,
        unsubscribeAll: l
    };
}
function $5b8488dadf327a2c$export$1686aec5678ceb1c(t, e = "auto") {
    let r = [
        "json",
        "csv",
        "tsv",
        "xml"
    ], n = (a)=>r.includes(a), o = ()=>{
        let a = e.toLowerCase();
        if (n(a)) return a;
        let s = t.split(".").pop()?.toLowerCase() || "";
        return n(s) ? s : "json";
    }, i = ()=>{
        throw new Error(`Failed to load data as ${e.toUpperCase()} from ${t}`);
    };
    switch(o()){
        case "json":
            return $5b8488dadf327a2c$var$nr(t).catch(i);
        case "csv":
            return $5b8488dadf327a2c$var$er(t).catch(i);
        case "tsv":
            return $5b8488dadf327a2c$var$rr(t).catch(i);
        case "xml":
            return $5b8488dadf327a2c$var$or(t).catch(i);
        default:
            throw new Error(`Unsupported data type: ${e}`);
    }
}
var $5b8488dadf327a2c$var$Pi = '"use strict";(()=>{var Sn={value:()=>{}};function Ae(){for(var t=0,e=arguments.length,r={},n;t<e;++t){if(!(n=arguments[t]+"")||n in r||/[\\s.]/.test(n))throw new Error("illegal type: "+n);r[n]=[]}return new bt(r)}function bt(t){this._=t}function kn(t,e){return t.trim().split(/^|\\s+/).map(function(r){var n="",o=r.indexOf(".");if(o>=0&&(n=r.slice(o+1),r=r.slice(0,o)),r&&!e.hasOwnProperty(r))throw new Error("unknown type: "+r);return{type:r,name:n}})}bt.prototype=Ae.prototype={constructor:bt,on:function(t,e){var r=this._,n=kn(t+"",r),o,i=-1,a=n.length;if(arguments.length<2){for(;++i<a;)if((o=(t=n[i]).type)&&(o=Nn(r[o],t.name)))return o;return}if(e!=null&&typeof e!="function")throw new Error("invalid callback: "+e);for(;++i<a;)if(o=(t=n[i]).type)r[o]=Ee(r[o],t.name,e);else if(e==null)for(o in r)r[o]=Ee(r[o],t.name,null);return this},copy:function(){var t={},e=this._;for(var r in e)t[r]=e[r].slice();return new bt(t)},call:function(t,e){if((o=arguments.length-2)>0)for(var r=new Array(o),n=0,o,i;n<o;++n)r[n]=arguments[n+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(i=this._[t],n=0,o=i.length;n<o;++n)i[n].value.apply(e,r)},apply:function(t,e,r){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var n=this._[t],o=0,i=n.length;o<i;++o)n[o].value.apply(e,r)}};function Nn(t,e){for(var r=0,n=t.length,o;r<n;++r)if((o=t[r]).name===e)return o.value}function Ee(t,e,r){for(var n=0,o=t.length;n<o;++n)if(t[n].name===e){t[n]=Sn,t=t.slice(0,n).concat(t.slice(n+1));break}return r!=null&&t.push({name:e,value:r}),t}var te=Ae;var Dt="http://www.w3.org/1999/xhtml",ee={svg:"http://www.w3.org/2000/svg",xhtml:Dt,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"};function I(t){var e=t+="",r=e.indexOf(":");return r>=0&&(e=t.slice(0,r))!=="xmlns"&&(t=t.slice(r+1)),ee.hasOwnProperty(e)?{space:ee[e],local:t}:t}function In(t){return function(){var e=this.ownerDocument,r=this.namespaceURI;return r===Dt&&e.documentElement.namespaceURI===Dt?e.createElement(t):e.createElementNS(r,t)}}function On(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}function Tt(t){var e=I(t);return(e.local?On:In)(e)}function Fn(){}function $(t){return t==null?Fn:function(){return this.querySelector(t)}}function Se(t){typeof t!="function"&&(t=$(t));for(var e=this._groups,r=e.length,n=new Array(r),o=0;o<r;++o)for(var i=e[o],a=i.length,s=n[o]=new Array(a),u,f,l=0;l<a;++l)(u=i[l])&&(f=t.call(u,u.__data__,l,i))&&("__data__"in u&&(f.__data__=u.__data__),s[l]=f);return new g(n,this._parents)}function re(t){return t==null?[]:Array.isArray(t)?t:Array.from(t)}function Rn(){return[]}function tt(t){return t==null?Rn:function(){return this.querySelectorAll(t)}}function zn(t){return function(){return re(t.apply(this,arguments))}}function ke(t){typeof t=="function"?t=zn(t):t=tt(t);for(var e=this._groups,r=e.length,n=[],o=[],i=0;i<r;++i)for(var a=e[i],s=a.length,u,f=0;f<s;++f)(u=a[f])&&(n.push(t.call(u,u.__data__,f,a)),o.push(u));return new g(n,o)}function et(t){return function(){return this.matches(t)}}function Mt(t){return function(e){return e.matches(t)}}var Yn=Array.prototype.find;function Pn(t){return function(){return Yn.call(this.children,t)}}function Un(){return this.firstElementChild}function Ne(t){return this.select(t==null?Un:Pn(typeof t=="function"?t:Mt(t)))}var $n=Array.prototype.filter;function Hn(){return Array.from(this.children)}function Ln(t){return function(){return $n.call(this.children,t)}}function Ie(t){return this.selectAll(t==null?Hn:Ln(typeof t=="function"?t:Mt(t)))}function Oe(t){typeof t!="function"&&(t=et(t));for(var e=this._groups,r=e.length,n=new Array(r),o=0;o<r;++o)for(var i=e[o],a=i.length,s=n[o]=[],u,f=0;f<a;++f)(u=i[f])&&t.call(u,u.__data__,f,i)&&s.push(u);return new g(n,this._parents)}function Ct(t){return new Array(t.length)}function Fe(){return new g(this._enter||this._groups.map(Ct),this._parents)}function rt(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}rt.prototype={constructor:rt,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function Re(t){return function(){return t}}function Bn(t,e,r,n,o,i){for(var a=0,s,u=e.length,f=i.length;a<f;++a)(s=e[a])?(s.__data__=i[a],n[a]=s):r[a]=new rt(t,i[a]);for(;a<u;++a)(s=e[a])&&(o[a]=s)}function Wn(t,e,r,n,o,i,a){var s,u,f=new Map,l=e.length,c=i.length,h=new Array(l),p;for(s=0;s<l;++s)(u=e[s])&&(h[s]=p=a.call(u,u.__data__,s,e)+"",f.has(p)?o[s]=u:f.set(p,u));for(s=0;s<c;++s)p=a.call(t,i[s],s,i)+"",(u=f.get(p))?(n[s]=u,u.__data__=i[s],f.delete(p)):r[s]=new rt(t,i[s]);for(s=0;s<l;++s)(u=e[s])&&f.get(h[s])===u&&(o[s]=u)}function Vn(t){return t.__data__}function ze(t,e){if(!arguments.length)return Array.from(this,Vn);var r=e?Wn:Bn,n=this._parents,o=this._groups;typeof t!="function"&&(t=Re(t));for(var i=o.length,a=new Array(i),s=new Array(i),u=new Array(i),f=0;f<i;++f){var l=n[f],c=o[f],h=c.length,p=Xn(t.call(l,l&&l.__data__,f,n)),m=p.length,d=s[f]=new Array(m),v=a[f]=new Array(m),T=u[f]=new Array(h);r(l,c,d,v,T,p,e);for(var E=0,M=0,Q,U;E<m;++E)if(Q=d[E]){for(E>=M&&(M=E+1);!(U=v[M])&&++M<m;);Q._next=U||null}}return a=new g(a,n),a._enter=s,a._exit=u,a}function Xn(t){return typeof t=="object"&&"length"in t?t:Array.from(t)}function Ye(){return new g(this._exit||this._groups.map(Ct),this._parents)}function Pe(t,e,r){var n=this.enter(),o=this,i=this.exit();return typeof t=="function"?(n=t(n),n&&(n=n.selection())):n=n.append(t+""),e!=null&&(o=e(o),o&&(o=o.selection())),r==null?i.remove():r(i),n&&o?n.merge(o).order():o}function Ue(t){for(var e=t.selection?t.selection():t,r=this._groups,n=e._groups,o=r.length,i=n.length,a=Math.min(o,i),s=new Array(o),u=0;u<a;++u)for(var f=r[u],l=n[u],c=f.length,h=s[u]=new Array(c),p,m=0;m<c;++m)(p=f[m]||l[m])&&(h[m]=p);for(;u<o;++u)s[u]=r[u];return new g(s,this._parents)}function $e(){for(var t=this._groups,e=-1,r=t.length;++e<r;)for(var n=t[e],o=n.length-1,i=n[o],a;--o>=0;)(a=n[o])&&(i&&a.compareDocumentPosition(i)^4&&i.parentNode.insertBefore(a,i),i=a);return this}function He(t){t||(t=qn);function e(c,h){return c&&h?t(c.__data__,h.__data__):!c-!h}for(var r=this._groups,n=r.length,o=new Array(n),i=0;i<n;++i){for(var a=r[i],s=a.length,u=o[i]=new Array(s),f,l=0;l<s;++l)(f=a[l])&&(u[l]=f);u.sort(e)}return new g(o,this._parents).order()}function qn(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}function Le(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}function Be(){return Array.from(this)}function We(){for(var t=this._groups,e=0,r=t.length;e<r;++e)for(var n=t[e],o=0,i=n.length;o<i;++o){var a=n[o];if(a)return a}return null}function Ve(){let t=0;for(let e of this)++t;return t}function Xe(){return!this.node()}function qe(t){for(var e=this._groups,r=0,n=e.length;r<n;++r)for(var o=e[r],i=0,a=o.length,s;i<a;++i)(s=o[i])&&t.call(s,s.__data__,i,o);return this}function Gn(t){return function(){this.removeAttribute(t)}}function Kn(t){return function(){this.removeAttributeNS(t.space,t.local)}}function Zn(t,e){return function(){this.setAttribute(t,e)}}function Jn(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function Qn(t,e){return function(){var r=e.apply(this,arguments);r==null?this.removeAttribute(t):this.setAttribute(t,r)}}function jn(t,e){return function(){var r=e.apply(this,arguments);r==null?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,r)}}function Ge(t,e){var r=I(t);if(arguments.length<2){var n=this.node();return r.local?n.getAttributeNS(r.space,r.local):n.getAttribute(r)}return this.each((e==null?r.local?Kn:Gn:typeof e=="function"?r.local?jn:Qn:r.local?Jn:Zn)(r,e))}function Et(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}function to(t){return function(){this.style.removeProperty(t)}}function eo(t,e,r){return function(){this.style.setProperty(t,e,r)}}function ro(t,e,r){return function(){var n=e.apply(this,arguments);n==null?this.style.removeProperty(t):this.style.setProperty(t,n,r)}}function Ke(t,e,r){return arguments.length>1?this.each((e==null?to:typeof e=="function"?ro:eo)(t,e,r??"")):R(this.node(),t)}function R(t,e){return t.style.getPropertyValue(e)||Et(t).getComputedStyle(t,null).getPropertyValue(e)}function no(t){return function(){delete this[t]}}function oo(t,e){return function(){this[t]=e}}function io(t,e){return function(){var r=e.apply(this,arguments);r==null?delete this[t]:this[t]=r}}function Ze(t,e){return arguments.length>1?this.each((e==null?no:typeof e=="function"?io:oo)(t,e)):this.node()[t]}function Je(t){return t.trim().split(/^|\\s+/)}function ne(t){return t.classList||new Qe(t)}function Qe(t){this._node=t,this._names=Je(t.getAttribute("class")||"")}Qe.prototype={add:function(t){var e=this._names.indexOf(t);e<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function je(t,e){for(var r=ne(t),n=-1,o=e.length;++n<o;)r.add(e[n])}function tr(t,e){for(var r=ne(t),n=-1,o=e.length;++n<o;)r.remove(e[n])}function ao(t){return function(){je(this,t)}}function so(t){return function(){tr(this,t)}}function uo(t,e){return function(){(e.apply(this,arguments)?je:tr)(this,t)}}function er(t,e){var r=Je(t+"");if(arguments.length<2){for(var n=ne(this.node()),o=-1,i=r.length;++o<i;)if(!n.contains(r[o]))return!1;return!0}return this.each((typeof e=="function"?uo:e?ao:so)(r,e))}function fo(){this.textContent=""}function lo(t){return function(){this.textContent=t}}function co(t){return function(){var e=t.apply(this,arguments);this.textContent=e??""}}function rr(t){return arguments.length?this.each(t==null?fo:(typeof t=="function"?co:lo)(t)):this.node().textContent}function ho(){this.innerHTML=""}function po(t){return function(){this.innerHTML=t}}function mo(t){return function(){var e=t.apply(this,arguments);this.innerHTML=e??""}}function nr(t){return arguments.length?this.each(t==null?ho:(typeof t=="function"?mo:po)(t)):this.node().innerHTML}function go(){this.nextSibling&&this.parentNode.appendChild(this)}function or(){return this.each(go)}function xo(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}function ir(){return this.each(xo)}function ar(t){var e=typeof t=="function"?t:Tt(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}function yo(){return null}function sr(t,e){var r=typeof t=="function"?t:Tt(t),n=e==null?yo:typeof e=="function"?e:$(e);return this.select(function(){return this.insertBefore(r.apply(this,arguments),n.apply(this,arguments)||null)})}function vo(){var t=this.parentNode;t&&t.removeChild(this)}function ur(){return this.each(vo)}function wo(){var t=this.cloneNode(!1),e=this.parentNode;return e?e.insertBefore(t,this.nextSibling):t}function _o(){var t=this.cloneNode(!0),e=this.parentNode;return e?e.insertBefore(t,this.nextSibling):t}function fr(t){return this.select(t?_o:wo)}function lr(t){return arguments.length?this.property("__data__",t):this.node().__data__}function bo(t){return function(e){t.call(this,e,this.__data__)}}function Do(t){return t.trim().split(/^|\\s+/).map(function(e){var r="",n=e.indexOf(".");return n>=0&&(r=e.slice(n+1),e=e.slice(0,n)),{type:e,name:r}})}function To(t){return function(){var e=this.__on;if(e){for(var r=0,n=-1,o=e.length,i;r<o;++r)i=e[r],(!t.type||i.type===t.type)&&i.name===t.name?this.removeEventListener(i.type,i.listener,i.options):e[++n]=i;++n?e.length=n:delete this.__on}}}function Mo(t,e,r){return function(){var n=this.__on,o,i=bo(e);if(n){for(var a=0,s=n.length;a<s;++a)if((o=n[a]).type===t.type&&o.name===t.name){this.removeEventListener(o.type,o.listener,o.options),this.addEventListener(o.type,o.listener=i,o.options=r),o.value=e;return}}this.addEventListener(t.type,i,r),o={type:t.type,name:t.name,value:e,listener:i,options:r},n?n.push(o):this.__on=[o]}}function cr(t,e,r){var n=Do(t+""),o,i=n.length,a;if(arguments.length<2){var s=this.node().__on;if(s){for(var u=0,f=s.length,l;u<f;++u)for(o=0,l=s[u];o<i;++o)if((a=n[o]).type===l.type&&a.name===l.name)return l.value}return}for(s=e?Mo:To,o=0;o<i;++o)this.each(s(n[o],e,r));return this}function hr(t,e,r){var n=Et(t),o=n.CustomEvent;typeof o=="function"?o=new o(e,r):(o=n.document.createEvent("Event"),r?(o.initEvent(e,r.bubbles,r.cancelable),o.detail=r.detail):o.initEvent(e,!1,!1)),t.dispatchEvent(o)}function Co(t,e){return function(){return hr(this,t,e)}}function Eo(t,e){return function(){return hr(this,t,e.apply(this,arguments))}}function pr(t,e){return this.each((typeof e=="function"?Eo:Co)(t,e))}function*mr(){for(var t=this._groups,e=0,r=t.length;e<r;++e)for(var n=t[e],o=0,i=n.length,a;o<i;++o)(a=n[o])&&(yield a)}var Ao=[null];function g(t,e){this._groups=t,this._parents=e}function dr(){return new g([[document.documentElement]],Ao)}function So(){return this}g.prototype=dr.prototype={constructor:g,select:Se,selectAll:ke,selectChild:Ne,selectChildren:Ie,filter:Oe,data:ze,enter:Fe,exit:Ye,join:Pe,merge:Ue,selection:So,order:$e,sort:He,call:Le,nodes:Be,node:We,size:Ve,empty:Xe,each:qe,attr:Ge,style:Ke,property:Ze,classed:er,text:rr,html:nr,raise:or,lower:ir,append:ar,insert:sr,remove:ur,clone:fr,datum:lr,on:cr,dispatch:pr,[Symbol.iterator]:mr};var O=dr;function At(t,e,r){t.prototype=e.prototype=r,r.constructor=t}function oe(t,e){var r=Object.create(t.prototype);for(var n in e)r[n]=e[n];return r}function it(){}var nt=.7,Nt=1/nt,q="\\\\s*([+-]?\\\\d+)\\\\s*",ot="\\\\s*([+-]?(?:\\\\d*\\\\.)?\\\\d+(?:[eE][+-]?\\\\d+)?)\\\\s*",k="\\\\s*([+-]?(?:\\\\d*\\\\.)?\\\\d+(?:[eE][+-]?\\\\d+)?)%\\\\s*",ko=/^#([0-9a-f]{3,8})$/,No=new RegExp(`^rgb\\\\(${q},${q},${q}\\\\)$`),Io=new RegExp(`^rgb\\\\(${k},${k},${k}\\\\)$`),Oo=new RegExp(`^rgba\\\\(${q},${q},${q},${ot}\\\\)$`),Fo=new RegExp(`^rgba\\\\(${k},${k},${k},${ot}\\\\)$`),Ro=new RegExp(`^hsl\\\\(${ot},${k},${k}\\\\)$`),zo=new RegExp(`^hsla\\\\(${ot},${k},${k},${ot}\\\\)$`),gr={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};At(it,S,{copy(t){return Object.assign(new this.constructor,this,t)},displayable(){return this.rgb().displayable()},hex:xr,formatHex:xr,formatHex8:Yo,formatHsl:Po,formatRgb:yr,toString:yr});function xr(){return this.rgb().formatHex()}function Yo(){return this.rgb().formatHex8()}function Po(){return Tr(this).formatHsl()}function yr(){return this.rgb().formatRgb()}function S(t){var e,r;return t=(t+"").trim().toLowerCase(),(e=ko.exec(t))?(r=e[1].length,e=parseInt(e[1],16),r===6?vr(e):r===3?new b(e>>8&15|e>>4&240,e>>4&15|e&240,(e&15)<<4|e&15,1):r===8?St(e>>24&255,e>>16&255,e>>8&255,(e&255)/255):r===4?St(e>>12&15|e>>8&240,e>>8&15|e>>4&240,e>>4&15|e&240,((e&15)<<4|e&15)/255):null):(e=No.exec(t))?new b(e[1],e[2],e[3],1):(e=Io.exec(t))?new b(e[1]*255/100,e[2]*255/100,e[3]*255/100,1):(e=Oo.exec(t))?St(e[1],e[2],e[3],e[4]):(e=Fo.exec(t))?St(e[1]*255/100,e[2]*255/100,e[3]*255/100,e[4]):(e=Ro.exec(t))?br(e[1],e[2]/100,e[3]/100,1):(e=zo.exec(t))?br(e[1],e[2]/100,e[3]/100,e[4]):gr.hasOwnProperty(t)?vr(gr[t]):t==="transparent"?new b(NaN,NaN,NaN,0):null}function vr(t){return new b(t>>16&255,t>>8&255,t&255,1)}function St(t,e,r,n){return n<=0&&(t=e=r=NaN),new b(t,e,r,n)}function Uo(t){return t instanceof it||(t=S(t)),t?(t=t.rgb(),new b(t.r,t.g,t.b,t.opacity)):new b}function G(t,e,r,n){return arguments.length===1?Uo(t):new b(t,e,r,n??1)}function b(t,e,r,n){this.r=+t,this.g=+e,this.b=+r,this.opacity=+n}At(b,G,oe(it,{brighter(t){return t=t==null?Nt:Math.pow(Nt,t),new b(this.r*t,this.g*t,this.b*t,this.opacity)},darker(t){return t=t==null?nt:Math.pow(nt,t),new b(this.r*t,this.g*t,this.b*t,this.opacity)},rgb(){return this},clamp(){return new b(L(this.r),L(this.g),L(this.b),It(this.opacity))},displayable(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:wr,formatHex:wr,formatHex8:$o,formatRgb:_r,toString:_r}));function wr(){return`#${H(this.r)}${H(this.g)}${H(this.b)}`}function $o(){return`#${H(this.r)}${H(this.g)}${H(this.b)}${H((isNaN(this.opacity)?1:this.opacity)*255)}`}function _r(){let t=It(this.opacity);return`${t===1?"rgb(":"rgba("}${L(this.r)}, ${L(this.g)}, ${L(this.b)}${t===1?")":`, ${t})`}`}function It(t){return isNaN(t)?1:Math.max(0,Math.min(1,t))}function L(t){return Math.max(0,Math.min(255,Math.round(t)||0))}function H(t){return t=L(t),(t<16?"0":"")+t.toString(16)}function br(t,e,r,n){return n<=0?t=e=r=NaN:r<=0||r>=1?t=e=NaN:e<=0&&(t=NaN),new A(t,e,r,n)}function Tr(t){if(t instanceof A)return new A(t.h,t.s,t.l,t.opacity);if(t instanceof it||(t=S(t)),!t)return new A;if(t instanceof A)return t;t=t.rgb();var e=t.r/255,r=t.g/255,n=t.b/255,o=Math.min(e,r,n),i=Math.max(e,r,n),a=NaN,s=i-o,u=(i+o)/2;return s?(e===i?a=(r-n)/s+(r<n)*6:r===i?a=(n-e)/s+2:a=(e-r)/s+4,s/=u<.5?i+o:2-i-o,a*=60):s=u>0&&u<1?0:a,new A(a,s,u,t.opacity)}function Ot(t,e,r,n){return arguments.length===1?Tr(t):new A(t,e,r,n??1)}function A(t,e,r,n){this.h=+t,this.s=+e,this.l=+r,this.opacity=+n}At(A,Ot,oe(it,{brighter(t){return t=t==null?Nt:Math.pow(Nt,t),new A(this.h,this.s,this.l*t,this.opacity)},darker(t){return t=t==null?nt:Math.pow(nt,t),new A(this.h,this.s,this.l*t,this.opacity)},rgb(){var t=this.h%360+(this.h<0)*360,e=isNaN(t)||isNaN(this.s)?0:this.s,r=this.l,n=r+(r<.5?r:1-r)*e,o=2*r-n;return new b(ie(t>=240?t-240:t+120,o,n),ie(t,o,n),ie(t<120?t+240:t-120,o,n),this.opacity)},clamp(){return new A(Dr(this.h),kt(this.s),kt(this.l),It(this.opacity))},displayable(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl(){let t=It(this.opacity);return`${t===1?"hsl(":"hsla("}${Dr(this.h)}, ${kt(this.s)*100}%, ${kt(this.l)*100}%${t===1?")":`, ${t})`}`}}));function Dr(t){return t=(t||0)%360,t<0?t+360:t}function kt(t){return Math.max(0,Math.min(1,t||0))}function ie(t,e,r){return(t<60?e+(r-e)*t/60:t<180?r:t<240?e+(r-e)*(240-t)/60:e)*255}function ae(t,e,r,n,o){var i=t*t,a=i*t;return((1-3*t+3*i-a)*e+(4-6*i+3*a)*r+(1+3*t+3*i-3*a)*n+a*o)/6}function Mr(t){var e=t.length-1;return function(r){var n=r<=0?r=0:r>=1?(r=1,e-1):Math.floor(r*e),o=t[n],i=t[n+1],a=n>0?t[n-1]:2*o-i,s=n<e-1?t[n+2]:2*i-o;return ae((r-n/e)*e,a,o,i,s)}}function Cr(t){var e=t.length;return function(r){var n=Math.floor(((r%=1)<0?++r:r)*e),o=t[(n+e-1)%e],i=t[n%e],a=t[(n+1)%e],s=t[(n+2)%e];return ae((r-n/e)*e,o,i,a,s)}}var at=t=>()=>t;function Ho(t,e){return function(r){return t+r*e}}function Lo(t,e,r){return t=Math.pow(t,r),e=Math.pow(e,r)-t,r=1/r,function(n){return Math.pow(t+n*e,r)}}function Er(t){return(t=+t)==1?Ft:function(e,r){return r-e?Lo(e,r,t):at(isNaN(e)?r:e)}}function Ft(t,e){var r=e-t;return r?Ho(t,r):at(isNaN(t)?e:t)}var B=function t(e){var r=Er(e);function n(o,i){var a=r((o=G(o)).r,(i=G(i)).r),s=r(o.g,i.g),u=r(o.b,i.b),f=Ft(o.opacity,i.opacity);return function(l){return o.r=a(l),o.g=s(l),o.b=u(l),o.opacity=f(l),o+""}}return n.gamma=t,n}(1);function Ar(t){return function(e){var r=e.length,n=new Array(r),o=new Array(r),i=new Array(r),a,s;for(a=0;a<r;++a)s=G(e[a]),n[a]=s.r||0,o[a]=s.g||0,i[a]=s.b||0;return n=t(n),o=t(o),i=t(i),s.opacity=1,function(u){return s.r=n(u),s.g=o(u),s.b=i(u),s+""}}}var Bo=Ar(Mr),Wo=Ar(Cr);function Sr(t,e){e||(e=[]);var r=t?Math.min(e.length,t.length):0,n=e.slice(),o;return function(i){for(o=0;o<r;++o)n[o]=t[o]*(1-i)+e[o]*i;return n}}function kr(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}function Nr(t,e){var r=e?e.length:0,n=t?Math.min(r,t.length):0,o=new Array(n),i=new Array(r),a;for(a=0;a<n;++a)o[a]=z(t[a],e[a]);for(;a<r;++a)i[a]=e[a];return function(s){for(a=0;a<n;++a)i[a]=o[a](s);return i}}function Ir(t,e){var r=new Date;return t=+t,e=+e,function(n){return r.setTime(t*(1-n)+e*n),r}}function w(t,e){return t=+t,e=+e,function(r){return t*(1-r)+e*r}}function Or(t,e){var r={},n={},o;(t===null||typeof t!="object")&&(t={}),(e===null||typeof e!="object")&&(e={});for(o in e)o in t?r[o]=z(t[o],e[o]):n[o]=e[o];return function(i){for(o in r)n[o]=r[o](i);return n}}var ue=/[-+]?(?:\\d+\\.?\\d*|\\.?\\d+)(?:[eE][-+]?\\d+)?/g,se=new RegExp(ue.source,"g");function Vo(t){return function(){return t}}function Xo(t){return function(e){return t(e)+""}}function st(t,e){var r=ue.lastIndex=se.lastIndex=0,n,o,i,a=-1,s=[],u=[];for(t=t+"",e=e+"";(n=ue.exec(t))&&(o=se.exec(e));)(i=o.index)>r&&(i=e.slice(r,i),s[a]?s[a]+=i:s[++a]=i),(n=n[0])===(o=o[0])?s[a]?s[a]+=o:s[++a]=o:(s[++a]=null,u.push({i:a,x:w(n,o)})),r=se.lastIndex;return r<e.length&&(i=e.slice(r),s[a]?s[a]+=i:s[++a]=i),s.length<2?u[0]?Xo(u[0].x):Vo(e):(e=u.length,function(f){for(var l=0,c;l<e;++l)s[(c=u[l]).i]=c.x(f);return s.join("")})}function z(t,e){var r=typeof e,n;return e==null||r==="boolean"?at(e):(r==="number"?w:r==="string"?(n=S(e))?(e=n,B):st:e instanceof S?B:e instanceof Date?Ir:kr(e)?Sr:Array.isArray(e)?Nr:typeof e.valueOf!="function"&&typeof e.toString!="function"||isNaN(e)?Or:w)(t,e)}var Fr=180/Math.PI,Rt={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};function fe(t,e,r,n,o,i){var a,s,u;return(a=Math.sqrt(t*t+e*e))&&(t/=a,e/=a),(u=t*r+e*n)&&(r-=t*u,n-=e*u),(s=Math.sqrt(r*r+n*n))&&(r/=s,n/=s,u/=s),t*n<e*r&&(t=-t,e=-e,u=-u,a=-a),{translateX:o,translateY:i,rotate:Math.atan2(e,t)*Fr,skewX:Math.atan(u)*Fr,scaleX:a,scaleY:s}}var zt;function Rr(t){let e=new(typeof DOMMatrix=="function"?DOMMatrix:WebKitCSSMatrix)(t+"");return e.isIdentity?Rt:fe(e.a,e.b,e.c,e.d,e.e,e.f)}function zr(t){return t==null?Rt:(zt||(zt=document.createElementNS("http://www.w3.org/2000/svg","g")),zt.setAttribute("transform",t),(t=zt.transform.baseVal.consolidate())?(t=t.matrix,fe(t.a,t.b,t.c,t.d,t.e,t.f)):Rt)}function Yr(t,e,r,n){function o(f){return f.length?f.pop()+" ":""}function i(f,l,c,h,p,m){if(f!==c||l!==h){var d=p.push("translate(",null,e,null,r);m.push({i:d-4,x:w(f,c)},{i:d-2,x:w(l,h)})}else(c||h)&&p.push("translate("+c+e+h+r)}function a(f,l,c,h){f!==l?(f-l>180?l+=360:l-f>180&&(f+=360),h.push({i:c.push(o(c)+"rotate(",null,n)-2,x:w(f,l)})):l&&c.push(o(c)+"rotate("+l+n)}function s(f,l,c,h){f!==l?h.push({i:c.push(o(c)+"skewX(",null,n)-2,x:w(f,l)}):l&&c.push(o(c)+"skewX("+l+n)}function u(f,l,c,h,p,m){if(f!==c||l!==h){var d=p.push(o(p)+"scale(",null,",",null,")");m.push({i:d-4,x:w(f,c)},{i:d-2,x:w(l,h)})}else(c!==1||h!==1)&&p.push(o(p)+"scale("+c+","+h+")")}return function(f,l){var c=[],h=[];return f=t(f),l=t(l),i(f.translateX,f.translateY,l.translateX,l.translateY,c,h),a(f.rotate,l.rotate,c,h),s(f.skewX,l.skewX,c,h),u(f.scaleX,f.scaleY,l.scaleX,l.scaleY,c,h),f=l=null,function(p){for(var m=-1,d=h.length,v;++m<d;)c[(v=h[m]).i]=v.x(p);return c.join("")}}}var le=Yr(Rr,"px, ","px)","deg)"),ce=Yr(zr,", ",")",")");var K=0,ft=0,ut=0,Ur=1e3,Yt,lt,Pt=0,W=0,Ut=0,ct=typeof performance=="object"&&performance.now?performance:Date,$r=typeof window=="object"&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function pt(){return W||($r(qo),W=ct.now()+Ut)}function qo(){W=0}function ht(){this._call=this._time=this._next=null}ht.prototype=$t.prototype={constructor:ht,restart:function(t,e,r){if(typeof t!="function")throw new TypeError("callback is not a function");r=(r==null?pt():+r)+(e==null?0:+e),!this._next&&lt!==this&&(lt?lt._next=this:Yt=this,lt=this),this._call=t,this._time=r,he()},stop:function(){this._call&&(this._call=null,this._time=1/0,he())}};function $t(t,e,r){var n=new ht;return n.restart(t,e,r),n}function Hr(){pt(),++K;for(var t=Yt,e;t;)(e=W-t._time)>=0&&t._call.call(void 0,e),t=t._next;--K}function Pr(){W=(Pt=ct.now())+Ut,K=ft=0;try{Hr()}finally{K=0,Ko(),W=0}}function Go(){var t=ct.now(),e=t-Pt;e>Ur&&(Ut-=e,Pt=t)}function Ko(){for(var t,e=Yt,r,n=1/0;e;)e._call?(n>e._time&&(n=e._time),t=e,e=e._next):(r=e._next,e._next=null,e=t?t._next=r:Yt=r);lt=t,he(n)}function he(t){if(!K){ft&&(ft=clearTimeout(ft));var e=t-W;e>24?(t<1/0&&(ft=setTimeout(Pr,t-ct.now()-Ut)),ut&&(ut=clearInterval(ut))):(ut||(Pt=ct.now(),ut=setInterval(Go,Ur)),K=1,$r(Pr))}}function Ht(t,e,r){var n=new ht;return e=e==null?0:+e,n.restart(o=>{n.stop(),t(o+e)},e,r),n}var Zo=te("start","end","cancel","interrupt"),Jo=[],Wr=0,Lr=1,Bt=2,Lt=3,Br=4,Wt=5,mt=6;function Y(t,e,r,n,o,i){var a=t.__transition;if(!a)t.__transition={};else if(r in a)return;Qo(t,r,{name:e,index:n,group:o,on:Zo,tween:Jo,time:i.time,delay:i.delay,duration:i.duration,ease:i.ease,timer:null,state:Wr})}function dt(t,e){var r=x(t,e);if(r.state>Wr)throw new Error("too late; already scheduled");return r}function y(t,e){var r=x(t,e);if(r.state>Lt)throw new Error("too late; already running");return r}function x(t,e){var r=t.__transition;if(!r||!(r=r[e]))throw new Error("transition not found");return r}function Qo(t,e,r){var n=t.__transition,o;n[e]=r,r.timer=$t(i,0,r.time);function i(f){r.state=Lr,r.timer.restart(a,r.delay,r.time),r.delay<=f&&a(f-r.delay)}function a(f){var l,c,h,p;if(r.state!==Lr)return u();for(l in n)if(p=n[l],p.name===r.name){if(p.state===Lt)return Ht(a);p.state===Br?(p.state=mt,p.timer.stop(),p.on.call("interrupt",t,t.__data__,p.index,p.group),delete n[l]):+l<e&&(p.state=mt,p.timer.stop(),p.on.call("cancel",t,t.__data__,p.index,p.group),delete n[l])}if(Ht(function(){r.state===Lt&&(r.state=Br,r.timer.restart(s,r.delay,r.time),s(f))}),r.state=Bt,r.on.call("start",t,t.__data__,r.index,r.group),r.state===Bt){for(r.state=Lt,o=new Array(h=r.tween.length),l=0,c=-1;l<h;++l)(p=r.tween[l].value.call(t,t.__data__,r.index,r.group))&&(o[++c]=p);o.length=c+1}}function s(f){for(var l=f<r.duration?r.ease.call(null,f/r.duration):(r.timer.restart(u),r.state=Wt,1),c=-1,h=o.length;++c<h;)o[c].call(t,l);r.state===Wt&&(r.on.call("end",t,t.__data__,r.index,r.group),u())}function u(){r.state=mt,r.timer.stop(),delete n[e];for(var f in n)return;delete t.__transition}}function Vt(t,e){var r=t.__transition,n,o,i=!0,a;if(r){e=e==null?null:e+"";for(a in r){if((n=r[a]).name!==e){i=!1;continue}o=n.state>Bt&&n.state<Wt,n.state=mt,n.timer.stop(),n.on.call(o?"interrupt":"cancel",t,t.__data__,n.index,n.group),delete r[a]}i&&delete t.__transition}}function Vr(t){return this.each(function(){Vt(this,t)})}function jo(t,e){var r,n;return function(){var o=y(this,t),i=o.tween;if(i!==r){n=r=i;for(var a=0,s=n.length;a<s;++a)if(n[a].name===e){n=n.slice(),n.splice(a,1);break}}o.tween=n}}function ti(t,e,r){var n,o;if(typeof r!="function")throw new Error;return function(){var i=y(this,t),a=i.tween;if(a!==n){o=(n=a).slice();for(var s={name:e,value:r},u=0,f=o.length;u<f;++u)if(o[u].name===e){o[u]=s;break}u===f&&o.push(s)}i.tween=o}}function Xr(t,e){var r=this._id;if(t+="",arguments.length<2){for(var n=x(this.node(),r).tween,o=0,i=n.length,a;o<i;++o)if((a=n[o]).name===t)return a.value;return null}return this.each((e==null?jo:ti)(r,t,e))}function Z(t,e,r){var n=t._id;return t.each(function(){var o=y(this,n);(o.value||(o.value={}))[e]=r.apply(this,arguments)}),function(o){return x(o,n).value[e]}}function Xt(t,e){var r;return(typeof e=="number"?w:e instanceof S?B:(r=S(e))?(e=r,B):st)(t,e)}function ei(t){return function(){this.removeAttribute(t)}}function ri(t){return function(){this.removeAttributeNS(t.space,t.local)}}function ni(t,e,r){var n,o=r+"",i;return function(){var a=this.getAttribute(t);return a===o?null:a===n?i:i=e(n=a,r)}}function oi(t,e,r){var n,o=r+"",i;return function(){var a=this.getAttributeNS(t.space,t.local);return a===o?null:a===n?i:i=e(n=a,r)}}function ii(t,e,r){var n,o,i;return function(){var a,s=r(this),u;return s==null?void this.removeAttribute(t):(a=this.getAttribute(t),u=s+"",a===u?null:a===n&&u===o?i:(o=u,i=e(n=a,s)))}}function ai(t,e,r){var n,o,i;return function(){var a,s=r(this),u;return s==null?void this.removeAttributeNS(t.space,t.local):(a=this.getAttributeNS(t.space,t.local),u=s+"",a===u?null:a===n&&u===o?i:(o=u,i=e(n=a,s)))}}function qr(t,e){var r=I(t),n=r==="transform"?ce:Xt;return this.attrTween(t,typeof e=="function"?(r.local?ai:ii)(r,n,Z(this,"attr."+t,e)):e==null?(r.local?ri:ei)(r):(r.local?oi:ni)(r,n,e))}function si(t,e){return function(r){this.setAttribute(t,e.call(this,r))}}function ui(t,e){return function(r){this.setAttributeNS(t.space,t.local,e.call(this,r))}}function fi(t,e){var r,n;function o(){var i=e.apply(this,arguments);return i!==n&&(r=(n=i)&&ui(t,i)),r}return o._value=e,o}function li(t,e){var r,n;function o(){var i=e.apply(this,arguments);return i!==n&&(r=(n=i)&&si(t,i)),r}return o._value=e,o}function Gr(t,e){var r="attr."+t;if(arguments.length<2)return(r=this.tween(r))&&r._value;if(e==null)return this.tween(r,null);if(typeof e!="function")throw new Error;var n=I(t);return this.tween(r,(n.local?fi:li)(n,e))}function ci(t,e){return function(){dt(this,t).delay=+e.apply(this,arguments)}}function hi(t,e){return e=+e,function(){dt(this,t).delay=e}}function Kr(t){var e=this._id;return arguments.length?this.each((typeof t=="function"?ci:hi)(e,t)):x(this.node(),e).delay}function pi(t,e){return function(){y(this,t).duration=+e.apply(this,arguments)}}function mi(t,e){return e=+e,function(){y(this,t).duration=e}}function Zr(t){var e=this._id;return arguments.length?this.each((typeof t=="function"?pi:mi)(e,t)):x(this.node(),e).duration}function di(t,e){if(typeof e!="function")throw new Error;return function(){y(this,t).ease=e}}function Jr(t){var e=this._id;return arguments.length?this.each(di(e,t)):x(this.node(),e).ease}function gi(t,e){return function(){var r=e.apply(this,arguments);if(typeof r!="function")throw new Error;y(this,t).ease=r}}function Qr(t){if(typeof t!="function")throw new Error;return this.each(gi(this._id,t))}function jr(t){typeof t!="function"&&(t=et(t));for(var e=this._groups,r=e.length,n=new Array(r),o=0;o<r;++o)for(var i=e[o],a=i.length,s=n[o]=[],u,f=0;f<a;++f)(u=i[f])&&t.call(u,u.__data__,f,i)&&s.push(u);return new _(n,this._parents,this._name,this._id)}function tn(t){if(t._id!==this._id)throw new Error;for(var e=this._groups,r=t._groups,n=e.length,o=r.length,i=Math.min(n,o),a=new Array(n),s=0;s<i;++s)for(var u=e[s],f=r[s],l=u.length,c=a[s]=new Array(l),h,p=0;p<l;++p)(h=u[p]||f[p])&&(c[p]=h);for(;s<n;++s)a[s]=e[s];return new _(a,this._parents,this._name,this._id)}function xi(t){return(t+"").trim().split(/^|\\s+/).every(function(e){var r=e.indexOf(".");return r>=0&&(e=e.slice(0,r)),!e||e==="start"})}function yi(t,e,r){var n,o,i=xi(e)?dt:y;return function(){var a=i(this,t),s=a.on;s!==n&&(o=(n=s).copy()).on(e,r),a.on=o}}function en(t,e){var r=this._id;return arguments.length<2?x(this.node(),r).on.on(t):this.each(yi(r,t,e))}function vi(t){return function(){var e=this.parentNode;for(var r in this.__transition)if(+r!==t)return;e&&e.removeChild(this)}}function rn(){return this.on("end.remove",vi(this._id))}function nn(t){var e=this._name,r=this._id;typeof t!="function"&&(t=$(t));for(var n=this._groups,o=n.length,i=new Array(o),a=0;a<o;++a)for(var s=n[a],u=s.length,f=i[a]=new Array(u),l,c,h=0;h<u;++h)(l=s[h])&&(c=t.call(l,l.__data__,h,s))&&("__data__"in l&&(c.__data__=l.__data__),f[h]=c,Y(f[h],e,r,h,f,x(l,r)));return new _(i,this._parents,e,r)}function on(t){var e=this._name,r=this._id;typeof t!="function"&&(t=tt(t));for(var n=this._groups,o=n.length,i=[],a=[],s=0;s<o;++s)for(var u=n[s],f=u.length,l,c=0;c<f;++c)if(l=u[c]){for(var h=t.call(l,l.__data__,c,u),p,m=x(l,r),d=0,v=h.length;d<v;++d)(p=h[d])&&Y(p,e,r,d,h,m);i.push(h),a.push(l)}return new _(i,a,e,r)}var wi=O.prototype.constructor;function an(){return new wi(this._groups,this._parents)}function _i(t,e){var r,n,o;return function(){var i=R(this,t),a=(this.style.removeProperty(t),R(this,t));return i===a?null:i===r&&a===n?o:o=e(r=i,n=a)}}function sn(t){return function(){this.style.removeProperty(t)}}function bi(t,e,r){var n,o=r+"",i;return function(){var a=R(this,t);return a===o?null:a===n?i:i=e(n=a,r)}}function Di(t,e,r){var n,o,i;return function(){var a=R(this,t),s=r(this),u=s+"";return s==null&&(u=s=(this.style.removeProperty(t),R(this,t))),a===u?null:a===n&&u===o?i:(o=u,i=e(n=a,s))}}function Ti(t,e){var r,n,o,i="style."+e,a="end."+i,s;return function(){var u=y(this,t),f=u.on,l=u.value[i]==null?s||(s=sn(e)):void 0;(f!==r||o!==l)&&(n=(r=f).copy()).on(a,o=l),u.on=n}}function un(t,e,r){var n=(t+="")=="transform"?le:Xt;return e==null?this.styleTween(t,_i(t,n)).on("end.style."+t,sn(t)):typeof e=="function"?this.styleTween(t,Di(t,n,Z(this,"style."+t,e))).each(Ti(this._id,t)):this.styleTween(t,bi(t,n,e),r).on("end.style."+t,null)}function Mi(t,e,r){return function(n){this.style.setProperty(t,e.call(this,n),r)}}function Ci(t,e,r){var n,o;function i(){var a=e.apply(this,arguments);return a!==o&&(n=(o=a)&&Mi(t,a,r)),n}return i._value=e,i}function fn(t,e,r){var n="style."+(t+="");if(arguments.length<2)return(n=this.tween(n))&&n._value;if(e==null)return this.tween(n,null);if(typeof e!="function")throw new Error;return this.tween(n,Ci(t,e,r??""))}function Ei(t){return function(){this.textContent=t}}function Ai(t){return function(){var e=t(this);this.textContent=e??""}}function ln(t){return this.tween("text",typeof t=="function"?Ai(Z(this,"text",t)):Ei(t==null?"":t+""))}function Si(t){return function(e){this.textContent=t.call(this,e)}}function ki(t){var e,r;function n(){var o=t.apply(this,arguments);return o!==r&&(e=(r=o)&&Si(o)),e}return n._value=t,n}function cn(t){var e="text";if(arguments.length<1)return(e=this.tween(e))&&e._value;if(t==null)return this.tween(e,null);if(typeof t!="function")throw new Error;return this.tween(e,ki(t))}function hn(){for(var t=this._name,e=this._id,r=qt(),n=this._groups,o=n.length,i=0;i<o;++i)for(var a=n[i],s=a.length,u,f=0;f<s;++f)if(u=a[f]){var l=x(u,e);Y(u,t,r,f,a,{time:l.time+l.delay+l.duration,delay:0,duration:l.duration,ease:l.ease})}return new _(n,this._parents,t,r)}function pn(){var t,e,r=this,n=r._id,o=r.size();return new Promise(function(i,a){var s={value:a},u={value:function(){--o===0&&i()}};r.each(function(){var f=y(this,n),l=f.on;l!==t&&(e=(t=l).copy(),e._.cancel.push(s),e._.interrupt.push(s),e._.end.push(u)),f.on=e}),o===0&&i()})}var Ni=0;function _(t,e,r,n){this._groups=t,this._parents=e,this._name=r,this._id=n}function mn(t){return O().transition(t)}function qt(){return++Ni}var F=O.prototype;_.prototype=mn.prototype={constructor:_,select:nn,selectAll:on,selectChild:F.selectChild,selectChildren:F.selectChildren,filter:jr,merge:tn,selection:an,transition:hn,call:F.call,nodes:F.nodes,node:F.node,size:F.size,empty:F.empty,each:F.each,on:en,attr:qr,attrTween:Gr,style:un,styleTween:fn,text:ln,textTween:cn,remove:rn,tween:Xr,delay:Kr,duration:Zr,ease:Jr,easeVarying:Qr,end:pn,[Symbol.iterator]:F[Symbol.iterator]};function Gt(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}var Ii={time:null,delay:0,duration:250,ease:Gt};function Oi(t,e){for(var r;!(r=t.__transition)||!(r=r[e]);)if(!(t=t.parentNode))throw new Error(`transition ${e} not found`);return r}function dn(t){var e,r;t instanceof _?(e=t._id,t=t._name):(e=qt(),(r=Ii).time=pt(),t=t==null?null:t+"");for(var n=this._groups,o=n.length,i=0;i<o;++i)for(var a=n[i],s=a.length,u,f=0;f<s;++f)(u=a[f])&&Y(u,t,e,f,a,r||Oi(u,e));return new _(n,this._parents,t,e)}O.prototype.interrupt=Vr;O.prototype.transition=dn;var{abs:Sc,max:kc,min:Nc}=Math;function gn(t){return[+t[0],+t[1]]}function Fi(t){return[gn(t[0]),gn(t[1])]}var Ic={name:"x",handles:["w","e"].map(pe),input:function(t,e){return t==null?null:[[+t[0],e[0][1]],[+t[1],e[1][1]]]},output:function(t){return t&&[t[0][0],t[1][0]]}},Oc={name:"y",handles:["n","s"].map(pe),input:function(t,e){return t==null?null:[[e[0][0],+t[0]],[e[1][0],+t[1]]]},output:function(t){return t&&[t[0][1],t[1][1]]}},Fc={name:"xy",handles:["n","w","e","s","nw","ne","sw","se"].map(pe),input:function(t){return t==null?null:Fi(t)},output:function(t){return t}};function pe(t){return{type:t}}var xn={},me={},de=34,gt=10,ge=13;function vn(t){return new Function("d","return {"+t.map(function(e,r){return JSON.stringify(e)+": d["+r+\'] || ""\'}).join(",")+"}")}function Ri(t,e){var r=vn(t);return function(n,o){return e(r(n),o,t)}}function yn(t){var e=Object.create(null),r=[];return t.forEach(function(n){for(var o in n)o in e||r.push(e[o]=o)}),r}function D(t,e){var r=t+"",n=r.length;return n<e?new Array(e-n+1).join(0)+r:r}function zi(t){return t<0?"-"+D(-t,6):t>9999?"+"+D(t,6):D(t,4)}function Yi(t){var e=t.getUTCHours(),r=t.getUTCMinutes(),n=t.getUTCSeconds(),o=t.getUTCMilliseconds();return isNaN(t)?"Invalid Date":zi(t.getUTCFullYear(),4)+"-"+D(t.getUTCMonth()+1,2)+"-"+D(t.getUTCDate(),2)+(o?"T"+D(e,2)+":"+D(r,2)+":"+D(n,2)+"."+D(o,3)+"Z":n?"T"+D(e,2)+":"+D(r,2)+":"+D(n,2)+"Z":r||e?"T"+D(e,2)+":"+D(r,2)+"Z":"")}function xt(t){var e=new RegExp(\'["\'+t+`\n\\r]`),r=t.charCodeAt(0);function n(c,h){var p,m,d=o(c,function(v,T){if(p)return p(v,T-1);m=v,p=h?Ri(v,h):vn(v)});return d.columns=m||[],d}function o(c,h){var p=[],m=c.length,d=0,v=0,T,E=m<=0,M=!1;c.charCodeAt(m-1)===gt&&--m,c.charCodeAt(m-1)===ge&&--m;function Q(){if(E)return me;if(M)return M=!1,xn;var wt,_t=d,j;if(c.charCodeAt(_t)===de){for(;d++<m&&c.charCodeAt(d)!==de||c.charCodeAt(++d)===de;);return(wt=d)>=m?E=!0:(j=c.charCodeAt(d++))===gt?M=!0:j===ge&&(M=!0,c.charCodeAt(d)===gt&&++d),c.slice(_t+1,wt-1).replace(/""/g,\'"\')}for(;d<m;){if((j=c.charCodeAt(wt=d++))===gt)M=!0;else if(j===ge)M=!0,c.charCodeAt(d)===gt&&++d;else if(j!==r)continue;return c.slice(_t,wt)}return E=!0,c.slice(_t,m)}for(;(T=Q())!==me;){for(var U=[];T!==xn&&T!==me;)U.push(T),T=Q();h&&(U=h(U,v++))==null||p.push(U)}return p}function i(c,h){return c.map(function(p){return h.map(function(m){return l(p[m])}).join(t)})}function a(c,h){return h==null&&(h=yn(c)),[h.map(l).join(t)].concat(i(c,h)).join(`\n`)}function s(c,h){return h==null&&(h=yn(c)),i(c,h).join(`\n`)}function u(c){return c.map(f).join(`\n`)}function f(c){return c.map(l).join(t)}function l(c){return c==null?"":c instanceof Date?Yi(c):e.test(c+="")?\'"\'+c.replace(/"/g,\'""\')+\'"\':c}return{parse:n,parseRows:o,format:a,formatBody:s,formatRows:u,formatRow:f,formatValue:l}}var V=xt(","),xe=V.parse,Pi=V.parseRows,Ui=V.format,$i=V.formatBody,Hi=V.formatRows,Li=V.formatRow,Bi=V.formatValue;var X=xt("	"),ye=X.parse,Wi=X.parseRows,Vi=X.format,Xi=X.formatBody,qi=X.formatRows,Gi=X.formatRow,Ki=X.formatValue;function Zi(t){if(!t.ok)throw new Error(t.status+" "+t.statusText);return t.text()}function Kt(t,e){return fetch(t,e).then(Zi)}function wn(t){return function(e,r,n){return arguments.length===2&&typeof r=="function"&&(n=r,r=void 0),Kt(e,r).then(function(o){return t(o,n)})}}var Zt=wn(xe),Jt=wn(ye);function Ji(t){if(!t.ok)throw new Error(t.status+" "+t.statusText);if(!(t.status===204||t.status===205))return t.json()}function Qt(t,e){return fetch(t,e).then(Ji)}function ve(t){return(e,r)=>Kt(e,r).then(n=>new DOMParser().parseFromString(n,t))}var jt=ve("application/xml"),Qi=ve("text/html"),ji=ve("image/svg+xml");var we=new Date,_e=new Date;function C(t,e,r,n){function o(i){return t(i=arguments.length===0?new Date:new Date(+i)),i}return o.floor=i=>(t(i=new Date(+i)),i),o.ceil=i=>(t(i=new Date(i-1)),e(i,1),t(i),i),o.round=i=>{let a=o(i),s=o.ceil(i);return i-a<s-i?a:s},o.offset=(i,a)=>(e(i=new Date(+i),a==null?1:Math.floor(a)),i),o.range=(i,a,s)=>{let u=[];if(i=o.ceil(i),s=s==null?1:Math.floor(s),!(i<a)||!(s>0))return u;let f;do u.push(f=new Date(+i)),e(i,s),t(i);while(f<i&&i<a);return u},o.filter=i=>C(a=>{if(a>=a)for(;t(a),!i(a);)a.setTime(a-1)},(a,s)=>{if(a>=a)if(s<0)for(;++s<=0;)for(;e(a,-1),!i(a););else for(;--s>=0;)for(;e(a,1),!i(a););}),r&&(o.count=(i,a)=>(we.setTime(+i),_e.setTime(+a),t(we),t(_e),Math.floor(r(we,_e))),o.every=i=>(i=Math.floor(i),!isFinite(i)||!(i>0)?null:i>1?o.filter(n?a=>n(a)%i===0:a=>o.count(0,a)%i===0):o)),o}var yt=C(t=>t.setHours(0,0,0,0),(t,e)=>t.setDate(t.getDate()+e),(t,e)=>(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*6e4)/864e5,t=>t.getDate()-1),ta=yt.range,_n=C(t=>{t.setUTCHours(0,0,0,0)},(t,e)=>{t.setUTCDate(t.getUTCDate()+e)},(t,e)=>(e-t)/864e5,t=>t.getUTCDate()-1),ea=_n.range,bn=C(t=>{t.setUTCHours(0,0,0,0)},(t,e)=>{t.setUTCDate(t.getUTCDate()+e)},(t,e)=>(e-t)/864e5,t=>Math.floor(t/864e5)),ra=bn.range;var vt=C(t=>{t.setDate(1),t.setHours(0,0,0,0)},(t,e)=>{t.setMonth(t.getMonth()+e)},(t,e)=>e.getMonth()-t.getMonth()+(e.getFullYear()-t.getFullYear())*12,t=>t.getMonth()),na=vt.range,Dn=C(t=>{t.setUTCDate(1),t.setUTCHours(0,0,0,0)},(t,e)=>{t.setUTCMonth(t.getUTCMonth()+e)},(t,e)=>e.getUTCMonth()-t.getUTCMonth()+(e.getUTCFullYear()-t.getUTCFullYear())*12,t=>t.getUTCMonth()),oa=Dn.range;var J=C(t=>{t.setMonth(0,1),t.setHours(0,0,0,0)},(t,e)=>{t.setFullYear(t.getFullYear()+e)},(t,e)=>e.getFullYear()-t.getFullYear(),t=>t.getFullYear());J.every=t=>!isFinite(t=Math.floor(t))||!(t>0)?null:C(e=>{e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),e.setHours(0,0,0,0)},(e,r)=>{e.setFullYear(e.getFullYear()+r*t)});var ia=J.range,De=C(t=>{t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},(t,e)=>{t.setUTCFullYear(t.getUTCFullYear()+e)},(t,e)=>e.getUTCFullYear()-t.getUTCFullYear(),t=>t.getUTCFullYear());De.every=t=>!isFinite(t=Math.floor(t))||!(t>0)?null:C(e=>{e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},(e,r)=>{e.setUTCFullYear(e.getUTCFullYear()+r*t)});var aa=De.range;function P(t,e,r){this.k=t,this.x=e,this.y=r}P.prototype={constructor:P,scale:function(t){return t===1?this:new P(this.k*t,this.x,this.y)},translate:function(t,e){return t===0&e===0?this:new P(this.k,this.x+this.k*t,this.y+this.k*e)},apply:function(t){return[t[0]*this.k+this.x,t[1]*this.k+this.y]},applyX:function(t){return t*this.k+this.x},applyY:function(t){return t*this.k+this.y},invert:function(t){return[(t[0]-this.x)/this.k,(t[1]-this.y)/this.k]},invertX:function(t){return(t-this.x)/this.k},invertY:function(t){return(t-this.y)/this.k},rescaleX:function(t){return t.copy().domain(t.range().map(this.invertX,this).map(t.invert,t))},rescaleY:function(t){return t.copy().domain(t.range().map(this.invertY,this).map(t.invert,t))},toString:function(){return"translate("+this.x+","+this.y+") scale("+this.k+")"}};var Te=new P(1,0,0);Me.prototype=P.prototype;function Me(t){for(;!t.__zoom;)if(!(t=t.parentNode))return Te;return t.__zoom}function Tn(t,e="auto"){let r=["json","csv","tsv","xml"],n=a=>r.includes(a),o=()=>{let a=e.toLowerCase();if(n(a))return a;let s=t.split(".").pop()?.toLowerCase()||"";return n(s)?s:"json"},i=()=>{throw new Error(`Failed to load data as ${e.toUpperCase()} from ${t}`)};switch(o()){case"json":return Qt(t).catch(i);case"csv":return Zt(t).catch(i);case"tsv":return Jt(t).catch(i);case"xml":return jt(t).catch(i);default:throw new Error(`Unsupported data type: ${e}`)}}function Ce(t,e){for(;t.toString().length<e;)t="0"+t;return t}function ua(t,e,r=!1){let n;return function(o,i){let a=this,s=arguments,u=function(){n=null,r||t.apply(a,s)},f=r&&!n;clearTimeout(n),n=setTimeout(u,e),f&&t.apply(a,s)}}var Sp=ua(function(t,e){e(t)},250);function N(t){let e=new Date(t);if(isNaN(+e))throw new Error(`"${t}" is not a valid date`);let r=e.getFullYear().toString(),n=Ce((1+e.getMonth()).toString(),2),o=Ce(e.getDate().toString(),2);return`${r}-${n}-${o}`}function Mn(t,e,r){let n=[t,...yt.range(t,e)],o=l=>new Date(l.getFullYear(),l.getMonth()+1,0).getDate(),i=t.getDate()===e.getDate(),a=t.getMonth()===e.getMonth(),s=vt.count(t,e),u=J.count(t,e),f=[];return r==="year"?a&&i?f=n.filter(l=>{if(l.getMonth()===t.getMonth()){if(l.getDate()===t.getDate())return!0;if(t.getDate()>o(l))return l.getDate()===o(l)}return!1}):f=n.filter(l=>n.indexOf(l)%Math.round(n.length/u)===0):r==="month"?i?f=n.filter(l=>l.getDate()===t.getDate()?!0:t.getDate()>o(l)?l.getDate()===o(l):!1):f=n.filter(l=>n.indexOf(l)%Math.round(n.length/s)===0):r==="day"&&(f=n),f.length===0&&(f=[t,e]),N(t)!==N(f[0])&&(f=[t,...f]),N(e)!==N(f[f.length-1])&&(f=[...f,e]),f}function Cn(t,e,r){return fa(t,e.dataType,r).then(ca).then(ha(e.startDate,e.endDate)).then(En(e.dataShape)).then(pa(e.fixedOrder)).then(ma).then(da(e.fillDateGapsInterval,e.fillDateGapsValue,e.topN)).then(ga(e.makeCumulative))}function fa(t,e,r){if(typeof t=="string"){let n=t;if(la(n))try{n=new URL(t,r).href}catch{throw new Error(`Invalid URL: ${t}`)}return Tn(n,e)}return Promise.resolve(t)}function la(t){return!t.startsWith("https://")&&!t.startsWith("http://")&&!t.startsWith("data:")}function ca(t){return!Array.isArray(t)||t.length===0?[{date:N(new Date),value:0,name:""}]:t}function ha(t,e){return function(r){return r.map(n=>({...n,date:N(n.date)})).filter(n=>t?n.date>=t:!0).filter(n=>e?n.date<=e:!0)}}function pa(t){return function(e){return t.length===0?e:e.filter(r=>t.includes(r.name)).map(r=>({...r,rank:t.indexOf(r.name)}))}}function ma(t){return t.map(e=>{let r=e.name?e.name:"",n=isNaN(+e.value)?0:+e.value;return{...e,name:r,value:n}}).sort((e,r)=>e.date.localeCompare(r.date)||e.name.localeCompare(r.name))}function da(t,e,r){return function(n){return t?va(n,t,e,r):n}}function ga(t=!1){return function(e){return e.sort((r,n)=>r.name.localeCompare(n.name)||r.date.localeCompare(n.date)).reduce((r,n)=>{if(r.length===0)n.lastValue=n.value;else{let o=r[r.length-1];n.name===o.name?(n.lastValue=o.value,t&&(n.value=o.value+n.value)):n.lastValue=n.value}return[...r,n]},[])}}function xa(t,e){if(e==="long"||e==="wide")return e;let r=t[0];return"date"in r&&"name"in r&&"value"in r?"long":"wide"}function En(t,e=!1){return function(r){if(t==="long"||xa(r,t)==="long")return r;let n=[];return r.forEach(o=>{for(let[i,a]of Object.entries(o)){if(i==="date")continue;let s={date:o.date,name:i};e?s={...s,...a}:s={...s,value:a},n.push(s)}}),n}}function ya(t){let e=[];return t.forEach(r=>{let n=e.filter(s=>s.date===r.date),o=n.length>0?n[0]:{},{date:i,...a}=r;o[r.name]=a,n.length===0&&(o.date=r.date,e.push(o))}),e}function va(t,e,r,n){if(!e)return t;let o=ya(t).map(a=>({...a,date:new Date(a.date)})),i=o.reduce((a,s,u)=>{let f=a[a.length-1].date,l=Mn(f,s.date,e).slice(1),c=1/l.length;if(u<o.length){let h=wa(o[u-1],o[u],n),p=[];return l.forEach((m,d)=>{let v=h(r==="last"?0:(d+1)*c),T={date:l[d]};for(let[E,M]of Object.entries(v))E!=="date"&&(T[E]={...M});p.push(N(s.date)===N(T.date)?s:T)}),[...a,...p]}else return[...a]},[o[0]]).map(a=>({...a,date:N(a.date)}));return En("wide",!0)(i)}function wa(t={},e={},r){let n=u(t,r),o=u(e,r),i=Array.from(new Set([...n,...o])),a=i.reduce((f,l)=>({...f,[l]:t[l]}),{}),s=i.reduce((f,l)=>({...f,[l]:e[l]}),{});return z(a,s);function u(f={},l){return Object.keys(f).filter(c=>c!=="date").map(c=>f[c]).sort(function(c,h){return h.value-c.value}).slice(0,l).map(c=>c.name)}}var An=self;An.addEventListener("message",async t=>{let{type:e,data:r,options:n,baseUrl:o,messageId:i}=t.data;if(e==="prepare-data"){let a=await Cn(r,n,o);An.postMessage({type:"data-prepared",data:a,messageId:i})}});})();\n';
function $5b8488dadf327a2c$var$Vt(t, e) {
    let { names: r, groups: n } = e.getState().data, { showGroups: o, colorSeed: i, colorMap: a } = e.getState().options;
    if (t.color) return t.color;
    let s = !!t.group && o && n.length > 0, l = s ? n : r;
    i && (l = $5b8488dadf327a2c$var$kl(l, $5b8488dadf327a2c$var$zi(i)));
    let u = s ? t.group : t.name, c = l.indexOf(u);
    if (a) {
        if (Array.isArray(a)) {
            for(; c > a.length - 1;)c = c - a.length;
            return a[c];
        } else if (a[u]) return a[u];
    }
    let f = c % 2 === 0 ? 1 : -1, p = $5b8488dadf327a2c$var$Hi(u) / 10 * f, h = 360 / (l.length + 1), m = (l.indexOf(u) + 1) * h;
    return $5b8488dadf327a2c$var$ne(m, .75, .75 + p);
}
function $5b8488dadf327a2c$var$Yt(t) {
    return "icon-" + $5b8488dadf327a2c$var$it(t.name);
}
function $5b8488dadf327a2c$var$cr(t, e) {
    for(; t.toString().length < e;)t = "0" + t;
    return t;
}
function $5b8488dadf327a2c$var$zi(t) {
    t = String(t);
    let e = "";
    for(let r = 0; r < t.length; r++)e += $5b8488dadf327a2c$var$cr(String(t.charCodeAt(r)), 3);
    return +e;
}
var $5b8488dadf327a2c$var$Ut = (t)=>String(t).split(".")[1]?.length || 0;
function $5b8488dadf327a2c$var$Hi(t) {
    let e = $5b8488dadf327a2c$var$zi(t), r = Math.sin(e) * 1e4;
    return r - Math.floor(r);
}
function $5b8488dadf327a2c$var$kl(t, e) {
    let r = [
        ...t
    ], n = r.length, o, i;
    for(; n;)i = Math.floor($5b8488dadf327a2c$var$Hi(e) * n--), o = r[n], r[n] = r[i], r[i] = o, ++e;
    return r;
}
function $5b8488dadf327a2c$export$567fc7097e064344(t = "racingbars", e = 8) {
    let r = Array(3).fill(null).map(()=>Math.random().toString(36).substr(2)).join("");
    return t + r.slice(-e);
}
function $5b8488dadf327a2c$var$fr(t, e, r) {
    let n;
    if (!r) n = t.getBoundingClientRect().height;
    else if (String(r).startsWith("window")) {
        let o = +r.split("*")[1] || 1;
        n = window.innerHeight * o;
    } else n = +r;
    return n > e ? n : e;
}
function $5b8488dadf327a2c$var$pr(t, e, r) {
    let n;
    if (!r) n = t.getBoundingClientRect().width;
    else if (String(r).startsWith("window")) {
        let o = +r.split("*")[1] || 1;
        n = window.innerWidth * o;
    } else n = +r;
    return n > e ? n : e;
}
function $5b8488dadf327a2c$var$hr(t, e) {
    if (t) return e ? t.querySelector("." + e) : t;
}
function $5b8488dadf327a2c$var$yt(t, e, r = !1) {
    let n = $5b8488dadf327a2c$var$hr(t, e);
    n && (r ? n.style.visibility = "unset" : n.style.display = "flex");
}
function $5b8488dadf327a2c$var$J(t, e, r = !1) {
    let n = $5b8488dadf327a2c$var$hr(t, e);
    n && (r ? n.style.visibility = "hidden" : n.style.display = "none");
}
function $5b8488dadf327a2c$var$ot(t, e, r, n, o = !1) {
    return typeof t == "function" ? t(e, r, n) : o ? $5b8488dadf327a2c$var$Bi(e, t) : t;
}
function $5b8488dadf327a2c$var$it(t) {
    return String(t).replace(/[\W]+/g, "_");
}
function $5b8488dadf327a2c$var$wn(t, e, r) {
    $5b8488dadf327a2c$var$j(t).select(e).classed(r, function() {
        return !$5b8488dadf327a2c$var$j(this).classed(r);
    });
}
function $5b8488dadf327a2c$var$Sl(t, e, r = !1) {
    let n;
    return function(o, i) {
        let a = this, s = arguments, l = function() {
            n = null, r || t.apply(a, s);
        }, u = r && !n;
        clearTimeout(n), n = setTimeout(l, e), u && t.apply(a, s);
    };
}
var $5b8488dadf327a2c$var$mr = $5b8488dadf327a2c$var$Sl(function(t, e) {
    e(t);
}, 250);
var $5b8488dadf327a2c$var$Al = (t, e = "text/javascript")=>`data:${e};charset=UTF-8;base64,` + btoa(t), $5b8488dadf327a2c$var$$i = (t)=>{
    try {
        return new Worker($5b8488dadf327a2c$var$Al(t));
    } catch  {
        return new Worker(URL.createObjectURL(new Blob([
            t
        ], {
            type: "application/javascript"
        })));
    }
};
var $5b8488dadf327a2c$var$Vi = (t)=>Array.from(new Set(t.map((e)=>e.date))).sort();
function $5b8488dadf327a2c$var$qt(t) {
    let e = new Date(t);
    if (isNaN(+e)) throw new Error(`"${t}" is not a valid date`);
    let r = e.getFullYear().toString(), n = $5b8488dadf327a2c$var$cr((1 + e.getMonth()).toString(), 2), o = $5b8488dadf327a2c$var$cr(e.getDate().toString(), 2);
    return `${r}-${n}-${o}`;
}
function $5b8488dadf327a2c$var$Bi(t, e = "YYYY-MM-DD") {
    let r = t.slice(0, 4), n = t.slice(5, 7), o = t.slice(8, 10), i = new Date(t), a = String(i.getDay()), s = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec"
    }, l = {
        0: "Sun",
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat"
    };
    return e.replace("MMM", s[n]).replace("DDD", l[a]).replace("YYYY", r).replace("MM", n).replace("DD", o);
}
function $5b8488dadf327a2c$var$Yi(t, e) {
    let r = t.indexOf(e);
    if (r === -1) return t[0];
    let n = t.length - 1;
    return r === n ? t[0] : t[r + 1];
}
var $5b8488dadf327a2c$var$_n = $5b8488dadf327a2c$var$$i($5b8488dadf327a2c$var$Pi);
async function $5b8488dadf327a2c$var$bn(t, e, r = !1) {
    let { dataTransform: n, dataType: o } = e.getState().options;
    typeof n == "function" && (typeof t == "string" && (t = await $5b8488dadf327a2c$export$1686aec5678ceb1c(t, o)), t = n(await t));
    let i = $5b8488dadf327a2c$export$567fc7097e064344();
    $5b8488dadf327a2c$var$_n.postMessage({
        type: "prepare-data",
        data: await t,
        options: $5b8488dadf327a2c$var$Tl(e.getState().options),
        baseUrl: location.href,
        messageId: i
    });
    let a = await new Promise((s)=>{
        let l = (u)=>{
            u.data.type === "data-prepared" && u.data.messageId === i && (s(u.data.data), $5b8488dadf327a2c$var$_n.removeEventListener("message", l));
        };
        $5b8488dadf327a2c$var$_n.addEventListener("message", l);
    });
    return $5b8488dadf327a2c$var$Ml(a, e, r), a;
}
function $5b8488dadf327a2c$var$Tl(t) {
    return Object.keys(t).reduce((e, r)=>(typeof t[r] != "function" && (e[r] = t[r]), e), {});
}
function $5b8488dadf327a2c$var$Ml(t, e, r) {
    let n = Array.from(new Set(t.map((a)=>String(a.name)))).sort(), o = Array.from(new Set(t.map((a)=>String(a.group)))).filter(Boolean).sort(), i = $5b8488dadf327a2c$var$Vi(t);
    e.dispatch($5b8488dadf327a2c$var$T.data.dataLoaded({
        names: n,
        groups: o,
        datesCache: i
    })), r ? e.dispatch($5b8488dadf327a2c$var$T.ticker.changeDates(i)) : e.dispatch($5b8488dadf327a2c$var$T.ticker.initialize(i));
}
function $5b8488dadf327a2c$var$me(t, e, r) {
    let n;
    if (r.getState().data.dateSlices[t]) n = r.getState().data.dateSlices[t];
    else {
        let i = e.filter((s)=>s.date === t && !isNaN(s.value)).sort((s, l)=>l.value - s.value).map((s, l)=>({
                ...s,
                rank: $5b8488dadf327a2c$var$qi(s, l, r)
            })), a = [
            {
                name: "",
                value: 0,
                lastValue: 0,
                date: t,
                rank: 1
            }
        ];
        n = i.length > 0 ? i : a, r.dispatch($5b8488dadf327a2c$var$T.data.addDateSlice(t, n));
    }
    return r.getState().data.groupFilter.length > 0 ? $5b8488dadf327a2c$var$El(n, r) : n;
}
function $5b8488dadf327a2c$var$El(t, e) {
    let r = e.getState().data.groupFilter;
    return t.filter((n)=>n.group ? !r.includes(n.group) : !0).map((n, o)=>({
            ...n,
            rank: $5b8488dadf327a2c$var$qi(n, o, e)
        }));
}
function $5b8488dadf327a2c$var$Ui(t, e) {
    return function() {
        if (e.getState().ticker.isRunning) {
            let r = $5b8488dadf327a2c$var$Yi(e.getState().ticker.dates, e.getState().ticker.currentDate);
            $5b8488dadf327a2c$var$me(r, t, e);
        }
    };
}
function $5b8488dadf327a2c$var$qi(t, e, r) {
    return r.getState().options.fixedOrder.length > 0 ? t.rank : e;
}
var $5b8488dadf327a2c$export$ba43bf67f3d48107 = {
    dataShape: "auto",
    dataType: "auto",
    dataTransform: null,
    valueDecimals: "preserve",
    fillDateGapsInterval: null,
    fillDateGapsValue: "interpolate",
    makeCumulative: !1,
    startDate: "",
    endDate: "",
    colorSeed: "",
    showGroups: !1,
    tickDuration: 500,
    topN: 10,
    mouseControls: !1,
    keyboardControls: !1,
    autorun: !0,
    loop: !1,
    injectStyles: !0,
    title: "",
    subTitle: "",
    caption: "",
    dateCounter: "MM/YYYY",
    labelsPosition: "inside",
    labelsWidth: 150,
    showIcons: !1,
    controlButtons: "all",
    overlays: "none",
    inputHeight: "",
    inputWidth: "",
    minHeight: 300,
    minWidth: 250,
    height: "",
    width: "",
    marginTop: 0,
    marginRight: 20,
    marginBottom: 5,
    marginLeft: 0,
    theme: "light",
    colorMap: {},
    fixedScale: !1,
    fixedOrder: [],
    highlightBars: !1,
    selectBars: !1
}, $5b8488dadf327a2c$var$vn = (t = $5b8488dadf327a2c$export$ba43bf67f3d48107, e)=>{
    switch(e.type){
        case $5b8488dadf327a2c$var$Lt.loadOptions:
        case $5b8488dadf327a2c$var$Lt.changeOptions:
            {
                let r = [
                    "inputHeight",
                    "inputWidth",
                    "minHeight",
                    "minWidth"
                ], n = {};
                Object.keys(e.payload).forEach((b)=>{
                    r.includes(b) || (n[b] = e.payload[b] ?? t[b]);
                });
                let o = n.startDate ? $5b8488dadf327a2c$var$qt(n.startDate) : t.startDate, i = n.endDate ? $5b8488dadf327a2c$var$qt(n.endDate) : t.startDate, a = n.height || t.inputHeight, s = n.width || t.inputWidth, l = Array.isArray(n.fixedOrder) ? [
                    ...n.fixedOrder
                ] : t.fixedOrder, u = Array.isArray(n.colorMap) ? [
                    ...n.colorMap
                ].map(String) : typeof n.colorMap == "object" ? {
                    ...n.colorMap
                } : t.colorMap, c = l.length || Number(n.topN) || t.topN, f = Number(n.tickDuration) || t.tickDuration, p = Number(n.labelsWidth) || t.labelsWidth, h = Number(n.marginTop) || t.marginTop, m = Number(n.marginRight) || t.marginRight, g = Number(n.marginBottom) || t.marginBottom, x = Number(n.marginLeft) || t.marginLeft;
                return {
                    ...t,
                    ...n,
                    startDate: o,
                    endDate: i,
                    inputHeight: a,
                    inputWidth: s,
                    fixedOrder: l,
                    colorMap: u,
                    topN: c,
                    tickDuration: f,
                    labelsWidth: p,
                    marginTop: h,
                    marginRight: m,
                    marginBottom: g,
                    marginLeft: x
                };
            }
        default:
            return t;
    }
};
var $5b8488dadf327a2c$var$Cl = [
    "makeCumulative",
    "loop",
    "showIcons",
    "showGroups",
    "mouseControls",
    "keyboardControls",
    "autorun",
    "injectStyles",
    "highlightBars",
    "selectBars",
    "fixedScale"
], $5b8488dadf327a2c$var$Nl = [
    "labelsWidth",
    "tickDuration",
    "topN",
    "minHeight",
    "minWidth",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft"
], $5b8488dadf327a2c$var$Rl = [
    "theme",
    "startDate",
    "endDate"
], $5b8488dadf327a2c$var$Fl = [
    "colorSeed",
    "inputHeight",
    "inputWidth",
    "height",
    "width"
], $5b8488dadf327a2c$var$Ol = [
    "title",
    "subTitle",
    "dateCounter",
    "caption"
], $5b8488dadf327a2c$var$Il = [
    "long",
    "wide",
    "auto"
], $5b8488dadf327a2c$var$Ll = [
    "json",
    "csv",
    "tsv",
    "xml",
    "auto"
], $5b8488dadf327a2c$var$Pl = [
    "inside",
    "outside",
    "none"
], $5b8488dadf327a2c$var$zl = [
    "all",
    "play",
    "none"
], $5b8488dadf327a2c$var$Hl = [
    "all",
    "play",
    "repeat",
    "none"
], $5b8488dadf327a2c$var$$l = [
    null,
    "year",
    "month",
    "day"
], $5b8488dadf327a2c$var$Bl = [
    "last",
    "interpolate"
];
function $5b8488dadf327a2c$var$gr(t) {
    let e = {};
    return $5b8488dadf327a2c$var$Cl.forEach((r)=>{
        if ($5b8488dadf327a2c$var$tt(t[r], "boolean")) e[r] = t[r];
        else if ($5b8488dadf327a2c$var$tt(t[r], "string")) {
            let n = t[r];
            (n === "true" || n === "false") && (e[r] = n === "true");
        }
    }), $5b8488dadf327a2c$var$Nl.forEach((r)=>{
        $5b8488dadf327a2c$var$tt(t[r], "number") && (e[r] = Number(t[r]));
    }), $5b8488dadf327a2c$var$Rl.forEach((r)=>{
        $5b8488dadf327a2c$var$tt(t[r], "string") && (e[r] = t[r]);
    }), $5b8488dadf327a2c$var$Fl.forEach((r)=>{
        !$5b8488dadf327a2c$var$tt(t[r], "string") && !$5b8488dadf327a2c$var$tt(t[r], "number") || (e[r] = t[r]);
    }), $5b8488dadf327a2c$var$Ol.forEach((r)=>{
        !$5b8488dadf327a2c$var$tt(t[r], "string") && !$5b8488dadf327a2c$var$tt(t[r], "function") || (e[r] = t[r]);
    }), $5b8488dadf327a2c$var$Ot($5b8488dadf327a2c$var$Il, t.dataShape) && (e.dataShape = t.dataShape), $5b8488dadf327a2c$var$Ot($5b8488dadf327a2c$var$Ll, t.dataType) && (e.dataType = t.dataType), $5b8488dadf327a2c$var$Ot($5b8488dadf327a2c$var$Pl, t.labelsPosition) && (e.labelsPosition = t.labelsPosition), $5b8488dadf327a2c$var$Ot($5b8488dadf327a2c$var$zl, t.controlButtons) && (e.controlButtons = t.controlButtons), $5b8488dadf327a2c$var$Ot($5b8488dadf327a2c$var$Hl, t.overlays) && (e.overlays = t.overlays), $5b8488dadf327a2c$var$Ot($5b8488dadf327a2c$var$$l, t.fillDateGapsInterval) && (e.fillDateGapsInterval = t.fillDateGapsInterval), $5b8488dadf327a2c$var$Ot($5b8488dadf327a2c$var$Bl, t.fillDateGapsValue) && (e.fillDateGapsValue = t.fillDateGapsValue), t.valueDecimals === "preserve" && (e.valueDecimals = "preserve"), $5b8488dadf327a2c$var$tt(t.valueDecimals, "number") && (e.valueDecimals = Number(t.valueDecimals)), $5b8488dadf327a2c$var$tt(t.fixedOrder, "array", "string") && (e.fixedOrder = t.fixedOrder), $5b8488dadf327a2c$var$Vl(t.dataTransform) && (e.dataTransform = t.dataTransform), $5b8488dadf327a2c$var$Yl(t.colorMap) && (e.colorMap = t.colorMap), e;
}
function $5b8488dadf327a2c$var$Vl(t) {
    return typeof t > "u" ? !1 : t === null || typeof t == "function";
}
function $5b8488dadf327a2c$var$Yl(t) {
    return typeof t > "u" || t === null ? !1 : $5b8488dadf327a2c$var$tt(t, "array", "string") ? !0 : $5b8488dadf327a2c$var$tt(t, "object") && Object.values(t).every((e)=>typeof e == "string");
}
function $5b8488dadf327a2c$var$tt(t, e, r) {
    return typeof t > "u" ? !1 : e === "number" ? typeof t == "number" && !isNaN(Number(t)) : e === "boolean" ? typeof t == "boolean" || t === "true" || t === "false" : e === "array" ? Array.isArray(t) ? r ? t.every((n)=>$5b8488dadf327a2c$var$tt(n, r)) : !0 : !1 : e === "object" ? t !== null && typeof t == "object" : typeof t === e;
}
function $5b8488dadf327a2c$var$Ot(t, e) {
    return e != null && t.includes(e);
}
function $5b8488dadf327a2c$var$Wi(t, e) {
    let { minHeight: r, inputHeight: n, minWidth: o, inputWidth: i, title: a, subTitle: s, showGroups: l, controlButtons: u, marginTop: c, marginRight: f, marginBottom: p, marginLeft: h, labelsPosition: m, labelsWidth: g, showIcons: x, fixedOrder: b } = t.getState().options, { root: D, maxValue: k } = e, S = b.length > 0 ? b.length : t.getState().options.topN, d = e.height = $5b8488dadf327a2c$var$fr(D, r, String(n)), w = e.width = $5b8488dadf327a2c$var$pr(D, o, String(i)), E = 5, R = a ? 55 : 0, I = s ? a ? 20 : 40 : 0, H = l ? R || I ? 20 : 30 : 0, _ = u !== "none" ? 50 : 0, C = Math.max(R + I + H, _ + H, 10), A = m !== "outside" ? 0 : g, O = {
        top: c + C + 15,
        right: f,
        bottom: p,
        left: h + A
    }, z = e.x = $5b8488dadf327a2c$var$Nt().domain([
        0,
        k
    ]).range([
        O.left,
        w - O.right - 65
    ]), $ = e.y = $5b8488dadf327a2c$var$Nt().domain([
        S,
        0
    ]).range([
        d - O.bottom,
        O.top
    ]), G = e.barPadding = (d - (O.bottom + O.top)) / (S * 5), y = e.labelPadding = 8;
    e.barWidth = (xt)=>Math.abs(z(xt.value) - z(0) - 1);
    let M = e.barHeight = $(1) - $(0) - G;
    e.barHalfHeight = ($(1) - $(0)) / 2 + 1, e.barY = (xt)=>$(xt.rank) + 5;
    let jt = e.iconSize = x ? M * .9 : 0, Gt = e.iconSpace = x ? jt + y : 0;
    e.labelX = m !== "outside" ? (xt)=>z(xt.value) - y - Gt : O.left - y, e.titlePadding = E, e.titleHeight = R, e.margin = O;
}
function $5b8488dadf327a2c$var$yr(t, e) {
    e.svg.selectAll(".halo").remove(), t.select(function() {
        return this.parentNode.insertBefore(this.cloneNode(!0), this);
    }).classed("halo", !0);
}
function $5b8488dadf327a2c$var$Xi(t, e, r) {
    $5b8488dadf327a2c$var$mr(t, function(n) {
        let o = n.detail;
        o === 3 ? r.dispatch($5b8488dadf327a2c$var$T.data.resetFilters()) : o === 2 ? r.dispatch($5b8488dadf327a2c$var$T.data.allExceptFilter(e)) : r.dispatch($5b8488dadf327a2c$var$T.data.toggleFilter(e));
    });
}
function $5b8488dadf327a2c$var$lt(t, e, r) {
    e.getState().options.highlightBars && $5b8488dadf327a2c$var$wn(r.root, "rect." + $5b8488dadf327a2c$var$it(t.name), "highlight");
}
function $5b8488dadf327a2c$var$Wt(t, e, r) {
    e.getState().options.selectBars && ($5b8488dadf327a2c$var$wn(r.root, "rect." + $5b8488dadf327a2c$var$it(t.name), "selected"), e.dispatch($5b8488dadf327a2c$var$T.data.toggleSelection(t.name)));
}
function $5b8488dadf327a2c$var$ji(t, e, r) {
    let n = t.getState().data.groups, o = t.getState().ticker.dates, i = t.getState().ticker.currentDate, { title: a, subTitle: s, marginTop: l, marginLeft: u, showGroups: c } = t.getState().options, { svg: f, margin: p, width: h, titlePadding: m, titleHeight: g } = e;
    if (e.titleText = f.append("text").attr("class", "title").attr("x", u + m).attr("y", l + 24).html($5b8488dadf327a2c$var$ot(a, i, r, o)), e.subTitleText = f.append("text").attr("class", "subTitle").attr("x", u + m).attr("y", l + (g || 24)).html($5b8488dadf327a2c$var$ot(s, i, r, o)), c) {
        let b = f.append("g").selectAll(".legend-wrapper").data(n).enter().append("g").attr("class", "legend legend-wrapper").style("cursor", "pointer").style("opacity", (S)=>t.getState().data.groupFilter.includes(S) ? .3 : 1).on("click", (S, d)=>$5b8488dadf327a2c$var$Xi(S, d, t));
        b.append("rect").attr("class", "legend legend-color").attr("width", 10).attr("height", 10).attr("y", p.top - 35).style("fill", (S)=>$5b8488dadf327a2c$var$Vt({
                group: S
            }, t)), b.append("text").attr("class", "legend legend-text").attr("x", 20).attr("y", p.top - 25).html((S)=>S);
        let D = p.left + m, k = 0;
        b.each(function() {
            let S = $5b8488dadf327a2c$var$j(this), w = S.select("text").node().getBBox();
            D + w.width > h && (D = p.left + m, k += 30), S.attr("transform", "translate(" + D + ", " + k + ")"), D += w.width + 40;
        }), p.top += k;
    }
}
var $5b8488dadf327a2c$var$N = {
    controls: "controls",
    skipBack: "skipBack",
    play: "play",
    pause: "pause",
    skipForward: "skipForward",
    overlay: "overlay",
    overlayPlay: "overlayPlay",
    overlayRepeat: "overlayRepeat"
};
var $5b8488dadf327a2c$var$It = {
    skipBack: '<svg viewBox="0 0 32 32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="M28.46,4a3,3,0,0,0-3,.07l-15.2,9.41A3,3,0,0,0,9,15V5A3,3,0,0,0,6,2H5A3,3,0,0,0,2,5V27a3,3,0,0,0,3,3H6a3,3,0,0,0,3-3V17a3,3,0,0,0,1.22,1.53L25.42,28a3,3,0,0,0,1.58.46,3,3,0,0,0,3-3V6.59A3,3,0,0,0,28.46,4Z"/></g></svg>',
    play: '<svg viewBox="0 0 32 32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="M26.78,13.45,11.58,4A3,3,0,0,0,7,6.59V25.41a3,3,0,0,0,3,3A3,3,0,0,0,11.58,28l15.2-9.41a3,3,0,0,0,0-5.1Z"/></g></svg>',
    pause: '<svg viewBox="0 0 32 32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" stroke="currentColor" xmlns:svg="http://www.w3.org/2000/svg"><g transform="translate(-17)"><path d="m 27,2 h -1 c -1.656854,0 -3,1.3431458 -3,3 v 12 c -0.04755,3.269656 0,6.666667 0,10 0,1.656854 1.343146,3 3,3 h 1 c 1.656854,0 3,-1.343146 3,-3 V 5 C 30,3.3431458 28.656854,2 27,2 Z" /></g><g transform="translate(-4)"><path d="m 27,2 h -1 c -1.656854,0 -3,1.3431458 -3,3 v 12 c -0.04755,3.269656 0,6.666667 0,10 0,1.656854 1.343146,3 3,3 h 1 c 1.656854,0 3,-1.343146 3,-3 V 5 C 30,3.3431458 28.656854,2 27,2 Z" /></g></svg>',
    skipForward: '<svg viewBox="0 0 32 32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="M27,2H26a3,3,0,0,0-3,3V15a3,3,0,0,0-1.22-1.53L6.58,4A3,3,0,0,0,2,6.59V25.41a3,3,0,0,0,3,3A3,3,0,0,0,6.58,28l15.2-9.41A3,3,0,0,0,23,17V27a3,3,0,0,0,3,3h1a3,3,0,0,0,3-3V5A3,3,0,0,0,27,2Z"/></g></svg>',
    overlayPlay: '<svg viewBox="0 0 32 32" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="M26.78,13.45,11.58,4A3,3,0,0,0,7,6.59V25.41a3,3,0,0,0,3,3A3,3,0,0,0,11.58,28l15.2-9.41a3,3,0,0,0,0-5.1Z"/></g></svg>',
    overlayRepeat: '<svg viewBox="0 0 32 32" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="M18,4A12,12,0,0,0,6.05,15H3a1,1,0,0,0-.88.53,1,1,0,0,0,0,1l4,6a1,1,0,0,0,1.66,0l4-6a1,1,0,0,0,.05-1A1,1,0,0,0,11,15H8.05A10,10,0,1,1,18,26a1,1,0,0,0,0,2A12,12,0,0,0,18,4Z"/></g></svg>'
};
function $5b8488dadf327a2c$var$Gi(t, e) {
    let { marginTop: r, controlButtons: n } = t.getState().options, { root: o, width: i, margin: a, barPadding: s } = e, l = o.getBoundingClientRect().width, u = [
        {
            skipBack: $5b8488dadf327a2c$var$It.skipBack
        },
        {
            play: $5b8488dadf327a2c$var$It.play
        },
        {
            pause: $5b8488dadf327a2c$var$It.pause
        },
        {
            skipForward: $5b8488dadf327a2c$var$It.skipForward
        }
    ];
    $5b8488dadf327a2c$var$j(o).append("div").classed("controls", !0).style("position", "absolute").style("top", r + "px").style("right", l - i + a.right + s + "px").selectAll("div").data(u).enter().append("div").html((c)=>Object.values(c)[0]).attr("class", (c)=>Object.keys(c)[0]), n === "play" && ($5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.skipBack), $5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.skipForward)), n === "none" && $5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.controls);
}
function $5b8488dadf327a2c$var$Xt(t, e) {
    let { overlays: r, loop: n } = t.getState().options, { root: o } = e;
    t.getState().ticker.isRunning ? ($5b8488dadf327a2c$var$yt(o, $5b8488dadf327a2c$var$N.pause), $5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.play)) : ($5b8488dadf327a2c$var$yt(o, $5b8488dadf327a2c$var$N.play), $5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.pause)), t.getState().ticker.isFirstDate && (r === "all" || r === "play") && !t.getState().ticker.isRunning ? ($5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.controls, !0), $5b8488dadf327a2c$var$yt(o, $5b8488dadf327a2c$var$N.overlay), $5b8488dadf327a2c$var$yt(o, $5b8488dadf327a2c$var$N.overlayPlay), $5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.overlayRepeat)) : t.getState().ticker.isLastDate && (r === "all" || r === "repeat") && !(n && t.getState().ticker.isRunning) ? ($5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.controls, !0), $5b8488dadf327a2c$var$yt(o, $5b8488dadf327a2c$var$N.overlay), $5b8488dadf327a2c$var$yt(o, $5b8488dadf327a2c$var$N.overlayRepeat), $5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.overlayPlay)) : ($5b8488dadf327a2c$var$yt(o, $5b8488dadf327a2c$var$N.controls, !0), $5b8488dadf327a2c$var$J(o, $5b8488dadf327a2c$var$N.overlay));
}
function $5b8488dadf327a2c$var$Ki(t, e) {
    let { minHeight: r, minWidth: n } = t.getState().options, { root: o } = e, i = [
        {
            overlayPlay: $5b8488dadf327a2c$var$It.overlayPlay
        },
        {
            overlayRepeat: $5b8488dadf327a2c$var$It.overlayRepeat
        }
    ];
    $5b8488dadf327a2c$var$j(o).append("div").classed("overlay", !0).style("min-height", r + "px").style("min-width", n + "px").selectAll("div").data(i).enter().append("div").html((a)=>Object.values(a)[0]).attr("class", (a)=>Object.keys(a)[0]);
}
function $5b8488dadf327a2c$var$xr(t, e, r) {
    let { caption: n, dateCounter: o, labelsPosition: i, showIcons: a, fixedScale: s, fixedOrder: l } = e.getState().options, u = e.getState().ticker.dates, c = r.root, f = l.length > 0 ? l.length : e.getState().options.topN, p = e.getState().ticker.currentDate, h = $5b8488dadf327a2c$var$me(p, t, e), m = h.slice(0, f), g = u.indexOf(p) > 0 ? u.indexOf(p) - 1 : 0, x = e.getState().options.valueDecimals;
    if (r.lastDate = u[g], !c || m.length === 0) return;
    c.innerHTML = "", b(), $5b8488dadf327a2c$var$Gi(e, r), $5b8488dadf327a2c$var$Ki(e, r), $5b8488dadf327a2c$var$Xt(e, r);
    function b() {
        r.maxValue = s ? t.map((y)=>y.value).reduce((y, M)=>y > M ? y : M, 0) : $5b8488dadf327a2c$var$wt(m, (y)=>y.value), $5b8488dadf327a2c$var$Wi(e, r);
        let { margin: D, width: k, height: S, x: d, y: w, barWidth: E, barHeight: R, barY: I, barHalfHeight: H, labelX: _, iconSize: C, labelPadding: A } = r, L = r.svg = $5b8488dadf327a2c$var$j(c).append("svg").attr("width", k).attr("height", S);
        $5b8488dadf327a2c$var$ji(e, r, h);
        let O = r.xAxis = $5b8488dadf327a2c$var$Se(d).ticks(k > 500 ? 5 : 2).tickSize(-(S - (D.top + D.bottom))).tickFormat((y)=>$5b8488dadf327a2c$var$nt(",")(y));
        L.append("g").attr("class", "axis xAxis").attr("transform", `translate(0, ${D.top})`).call(O).selectAll(".tick line").classed("origin", (y)=>y === 0), L.selectAll("rect.bar").data(m, (y)=>y.name).enter().append("rect").attr("class", (y)=>"bar " + $5b8488dadf327a2c$var$it(y.name)).classed("selected", (y)=>e.getState().data.selected.includes(y.name)).attr("x", d(0) + 1).attr("width", E).attr("y", I).attr("height", R).style("fill", (y)=>$5b8488dadf327a2c$var$Vt(y, e)).on("click", (y, M)=>$5b8488dadf327a2c$var$Wt(M, e, r)).on("mouseover", (y, M)=>$5b8488dadf327a2c$var$lt(M, e, r)).on("mouseout", (y, M)=>$5b8488dadf327a2c$var$lt(M, e, r)), L.selectAll("text.label").data(m, (y)=>y.name).enter().append("text").attr("class", "label").classed("outside-bars", i === "outside").classed("hidden", i === "none").attr("x", _).attr("y", (y)=>I(y) + H).style("text-anchor", "end").html((y)=>y.name).on("click", (y, M)=>$5b8488dadf327a2c$var$Wt(M, e, r)).on("mouseover", (y, M)=>$5b8488dadf327a2c$var$lt(M, e, r)).on("mouseout", (y, M)=>$5b8488dadf327a2c$var$lt(M, e, r)), L.selectAll("text.valueLabel").data(m, (y)=>y.name).enter().append("text").attr("class", "valueLabel").attr("x", (y)=>d(y.value) + 5).attr("y", (y)=>I(y) + H).text((y)=>x === "preserve" ? y.lastValue : $5b8488dadf327a2c$var$nt(`,.${$5b8488dadf327a2c$var$Ut(y.lastValue ?? y.value)}f`)(y.lastValue)), a && ((r.defs = L.append("svg:defs")).selectAll("svg").data(m, (M)=>M.name).enter().append("svg:pattern").attr("class", "svgpattern").attr("id", $5b8488dadf327a2c$var$Yt).attr("width", C).attr("height", C).append("svg:image").attr("xlink:href", (M)=>M.icon).attr("width", C).attr("height", C).attr("x", 0).attr("y", 0), L.append("clipPath").attr("id", "clipPath-" + e.getState().container.element.id).append("rect").attr("x", d(0) + 1).attr("y", D.top).attr("width", k).attr("height", S), L.selectAll("circle").data(m, (M)=>M.name).enter().append("circle").attr("cx", (M)=>d(M.value) - C / 2 - A).attr("cy", (M)=>w(M.rank) + H).attr("r", C / 2).style("fill", "transparent").style("fill", (M)=>`url(#${$5b8488dadf327a2c$var$Yt(M)})`).attr("clip-path", `url(#clipPath-${e.getState().container.element.id})`));
        let z = S - D.bottom, $ = k - D.right, G = n ? z - 30 : z - 5;
        r.dateCounterText = L.append("text").attr("class", "dateCounterText").attr("x", $).attr("y", G).style("text-anchor", "end").html($5b8488dadf327a2c$var$ot(o, p, h, u, !0)).call((y)=>$5b8488dadf327a2c$var$yr(y, r)), r.captionText = L.append("text").attr("class", "caption").attr("x", $ - 10).attr("y", z - 5).style("text-anchor", "end").html($5b8488dadf327a2c$var$ot(n, p, h, u));
    }
}
function $5b8488dadf327a2c$var$de(t, e, r) {
    let { svg: n, titleText: o, subTitleText: i, dateCounterText: a, captionText: s, x: l, y: u, xAxis: c, labelPadding: f, barWidth: p, barHeight: h, barHalfHeight: m, barY: g, iconSize: x, labelX: b, defs: D, lastDate: k } = r, S = e.getState().ticker.dates, { showGroups: d } = e.getState().options;
    if (!l) return;
    let { tickDuration: w, title: E, subTitle: R, caption: I, dateCounter: H, marginBottom: _, fixedScale: C, fixedOrder: A, labelsPosition: L } = e.getState().options, O = A.length > 0 ? A.length : e.getState().options.topN, z = e.getState().ticker.currentDate, $ = $5b8488dadf327a2c$var$me(z, t, e), G = $.slice(0, O), y = e.getState().options.valueDecimals;
    d && n.selectAll(".legend-wrapper").style("opacity", (v)=>e.getState().data.groupFilter.includes(v) ? .3 : 1), C || (l.domain([
        0,
        $5b8488dadf327a2c$var$wt(G, (v)=>v.value) || 0
    ]), n.select(".xAxis").transition().duration(w).ease($5b8488dadf327a2c$var$X).call(c));
    let M = n.selectAll(".bar").data(G, (v)=>v.name);
    M.enter().append("rect").attr("class", (v)=>"bar " + $5b8488dadf327a2c$var$it(v.name)).classed("selected", (v)=>e.getState().data.selected.includes(v.name)).attr("x", l(0) + 1).attr("width", p).attr("y", ()=>u(O + 1) + _ + 5).attr("height", h).style("fill", (v)=>$5b8488dadf327a2c$var$Vt(v, e)).on("click", (v, Y)=>$5b8488dadf327a2c$var$Wt(Y, e, r)).on("mouseover", (v, Y)=>$5b8488dadf327a2c$var$lt(Y, e, r)).on("mouseout", (v, Y)=>$5b8488dadf327a2c$var$lt(Y, e, r)).transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("y", g), M.transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("width", (v)=>Math.abs(l(v.value) - l(0) - 1)).attr("y", g), M.exit().transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("width", (v)=>Math.abs(l(v.value) - l(0) - 1)).attr("y", ()=>u(O + 1) + _ + 5).remove();
    let jt = n.selectAll(".label").data(G, (v)=>v.name);
    jt.enter().append("text").attr("class", "label").classed("outside-bars", L === "outside").classed("hidden", L === "none").attr("x", b).attr("y", ()=>u(O + 1) + _ + 5 + m).style("text-anchor", "end").html((v)=>v.name).on("click", (v, Y)=>$5b8488dadf327a2c$var$Wt(Y, e, r)).on("mouseover", (v, Y)=>$5b8488dadf327a2c$var$lt(Y, e, r)).on("mouseout", (v, Y)=>$5b8488dadf327a2c$var$lt(Y, e, r)).transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("y", (v)=>g(v) + m), jt.transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("x", b).attr("y", (v)=>g(v) + m), jt.exit().transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("x", b).attr("y", ()=>u(O + 1) + _ + 5).remove();
    let Gt = n.selectAll(".valueLabel").data(G, (v)=>v.name);
    Gt.enter().append("text").attr("class", "valueLabel").attr("x", (v)=>l(v.value) + 5).attr("y", ()=>u(O + 1) + _ + 5).text((v)=>y === "preserve" ? v.lastValue : $5b8488dadf327a2c$var$nt(`,.${$5b8488dadf327a2c$var$Ut(v.lastValue ?? v.value)}f`)(v.lastValue)).transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("y", (v)=>g(v) + m);
    let xt = k === z;
    if (Gt.transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("x", (v)=>l(v.value) + 5).attr("y", (v)=>g(v) + m).tween("text", function(v) {
        let Y = Number(xt ? v.value : v.lastValue) || 0, B = $5b8488dadf327a2c$var$st(Y, v.value);
        return function(oa) {
            let ia = y === "preserve" ? Math.max($5b8488dadf327a2c$var$Ut(v.value), $5b8488dadf327a2c$var$Ut(Y)) : y;
            this.textContent = $5b8488dadf327a2c$var$nt(`,.${ia || 0}f`)(B(oa));
        };
    }), Gt.exit().transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("x", (v)=>l(v.value) + 5).attr("y", ()=>u(O + 1) + _ + 5).remove(), e.getState().options.showIcons) {
        let v = D.selectAll(".svgpattern").data(G, (B)=>B.name);
        v.enter().append("svg:pattern").attr("class", "svgpattern").attr("id", $5b8488dadf327a2c$var$Yt).attr("width", x).attr("height", x).append("svg:image").attr("xlink:href", (B)=>B.icon).attr("width", x).attr("height", x).style("z-index", "99").attr("x", 0).attr("y", 0), v.exit().transition().duration(w).ease($5b8488dadf327a2c$var$X).remove();
        let Y = n.selectAll("circle").data(G, (B)=>B.name);
        Y.enter().append("circle").attr("cx", (B)=>l(B.value) - x / 2 - f).attr("cy", ()=>u(O + 1) + x + m).attr("r", x / 2).style("z-index", "99").style("fill", "transparent").style("fill", (B)=>`url(#${$5b8488dadf327a2c$var$Yt(B)})`).transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("cy", (B)=>u(B.rank) + m).attr("clip-path", `url(#clipPath-${e.getState().container.element.id})`), Y.transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("cx", (B)=>l(B.value) - x / 2 - f).attr("cy", (B)=>u(B.rank) + m), Y.exit().transition().duration(w).ease($5b8488dadf327a2c$var$X).attr("cx", (B)=>l(B.value) - x / 2 - f).attr("cy", ()=>u(O + 1) + x + m).remove();
    }
    o.html($5b8488dadf327a2c$var$ot(E, z, $, S)), i.html($5b8488dadf327a2c$var$ot(R, z, $, S)), s.html($5b8488dadf327a2c$var$ot(I, z, $, S)), a.html($5b8488dadf327a2c$var$ot(H, z, $, S, !0)).call((v)=>$5b8488dadf327a2c$var$yr(v, r)), $5b8488dadf327a2c$var$Xt(e, r), r.lastDate = z;
}
function $5b8488dadf327a2c$var$Zi(t, e, r) {
    let { inputHeight: n, inputWidth: o, minHeight: i, minWidth: a } = e.getState().options, { root: s } = r;
    if (s && (!n && !o || String(n).startsWith("window") || String(o).startsWith("window"))) {
        r.height = $5b8488dadf327a2c$var$fr(s, i, String(n)), r.width = $5b8488dadf327a2c$var$pr(s, a, String(o));
        let l = s.style.position;
        $5b8488dadf327a2c$var$xr(t, e, r), $5b8488dadf327a2c$var$de(t, e, r), $5b8488dadf327a2c$var$de(t, e, r), $5b8488dadf327a2c$var$Xt(e, r), s.style.position = l;
    }
}
function $5b8488dadf327a2c$var$vr(t, e, r) {
    let n = {
        root: r
    };
    return {
        renderInitialView: ()=>$5b8488dadf327a2c$var$xr(t, e, n),
        renderFrame: ()=>$5b8488dadf327a2c$var$de(t, e, n),
        resize: ()=>$5b8488dadf327a2c$var$Zi(t, e, n)
    };
}
function $5b8488dadf327a2c$var$Dn(t) {
    return window.ResizeObserver && window.requestAnimationFrame ? new ResizeObserver((e)=>{
        window.requestAnimationFrame(()=>{
            e?.length && t();
        });
    }) : {
        observe: ()=>{
            window.addEventListener("resize", t);
        },
        unobserve: ()=>{
            window.removeEventListener("resize", t);
        }
    };
}
function $5b8488dadf327a2c$var$kn(t, e) {
    return function() {
        t.getState().triggerRender && e.renderFrame();
    };
}
var $5b8488dadf327a2c$var$Qi = "__selector__{--base-font-size:max(1vw,12px);--text-font-size:calc(var(--base-font-size)*1.2);--title-font-size:calc(var(--base-font-size)*2);--caption-font-size:calc(var(--base-font-size)*1.5);--counter-font-size:calc(var(--base-font-size)*4);--controls-font-size:calc(var(--base-font-size)*1.5)}__selector__ text{font-family:Open Sans,sans-serif;font-size:var(--text-font-size)}__selector__ text.title{font-size:var(--title-font-size);font-weight:500}__selector__ text.subTitle{font-weight:500}__selector__ text.caption{font-size:var(--caption-font-size);font-weight:400}__selector__ text.legend-text{user-select:none}__selector__ text.label{font-weight:600}__selector__ text.label.hidden{visibility:hidden}__selector__ text.valueLabel{font-weight:300}__selector__ text.dateCounterText{font-size:var(--counter-font-size);font-weight:700}__selector__ .xAxis .tick:nth-child(2) text{text-anchor:start}__selector__ .tick line{shape-rendering:CrispEdges}__selector__ path.domain{display:none}__selector__{position:relative}__selector__ .controls{display:flex}__selector__ .controls div,__selector__ .overlay div{align-items:center;border-radius:5px;cursor:pointer;display:flex;justify-content:center;margin:5px}__selector__ .controls div{height:10vw;max-height:32px;max-width:32px;width:10vw}__selector__ .controls svg{height:7vw;margin:5px auto;max-height:24px;max-width:24px;width:7vw}__selector__ .overlay{height:100%;left:0;position:absolute;top:0;width:100%}__selector__ .overlay,__selector__ .overlay div{align-items:center;display:flex;justify-content:center}__selector__ .overlay div{border-radius:100px;height:20vw;max-height:200px;max-width:200px;position:relative;width:20vw}__selector__ .overlay svg{height:50%;width:50%}";
var $5b8488dadf327a2c$var$Ji = "__selector__ text.subTitle{fill:#777}__selector__ text.dateCounterText{fill:#bbb;opacity:1}__selector__ text.caption{fill:#777}__selector__ .halo{fill:#fff;opacity:1;stroke:#fff;stroke-linejoin:round;stroke-width:10}__selector__ text.label,__selector__ text.label.outside-bars,__selector__ text.legend-text,__selector__ text.valueLabel{fill:#000}__selector__ .tick text{fill:#777}__selector__ .tick line{shape-rendering:CrispEdges;stroke:#ddd}__selector__ .tick line.origin{stroke:#aaa}__selector__ .controls div,__selector__ .overlay div{background:#777;border:1px solid #000;color:#fff;opacity:.5}__selector__ .controls div:hover,__selector__ .overlay div:hover{background:#aaa;color:#000}__selector__ .overlay{background-color:#000;opacity:.7}__selector__ .highlight{fill:#ff2727!important}__selector__ .selected{fill:#d12020!important;stroke:#777!important;stroke-width:1!important}";
var $5b8488dadf327a2c$var$ta = "__selector__{background-color:#1e1e1e}__selector__ text.title{fill:#fafafa}__selector__ text.subTitle{fill:#ccc}__selector__ text.dateCounterText{fill:#ccc;opacity:1}__selector__ text.caption{fill:#ccc}__selector__ .halo{fill:#313639;opacity:1;stroke:#313639;stroke-linejoin:round;stroke-width:10}__selector__ text.legend-text{fill:#fafafa}__selector__ text.label{fill:#313639}__selector__ text.label.outside-bars,__selector__ text.valueLabel{fill:#fafafa}__selector__ .tick text{fill:#ccc}__selector__ .tick line{shape-rendering:CrispEdges;stroke:#ddd}__selector__ .tick line.origin{stroke:#aaa}__selector__ .controls div,__selector__ .overlay div{background:#777;border:1px solid #000;color:#fff;opacity:.5}__selector__ .controls div:hover,__selector__ .overlay div:hover{background:#aaa;color:#000}__selector__ .overlay{background-color:#000;opacity:.7}__selector__ .highlight{fill:#ff2727!important}__selector__ .selected{fill:#d12020!important;stroke:#777!important;stroke-width:1!important}";
var $5b8488dadf327a2c$var$Xl = {
    light: $5b8488dadf327a2c$var$Ji,
    dark: $5b8488dadf327a2c$var$ta
};
function $5b8488dadf327a2c$var$wr(t, e, r = "top", n = $5b8488dadf327a2c$var$Qi, o = $5b8488dadf327a2c$var$Xl) {
    let i = n + o[e];
    if (!i || !t || typeof document > "u") return "";
    t.id = t.id || $5b8488dadf327a2c$export$567fc7097e064344(), i = i.replace(/__selector__/g, "#" + t.id);
    let a = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    return s.id = $5b8488dadf327a2c$export$567fc7097e064344("styles"), s.type = "text/css", r === "top" && a.firstChild ? a.insertBefore(s, a.firstChild) : a.appendChild(s), s.styleSheet ? s.styleSheet.cssText = i : s.appendChild(document.createTextNode(i)), s.id;
}
function $5b8488dadf327a2c$var$ea(t, e) {
    let r = t.getState().container.element, n = [];
    return o(), {
        reregister: i,
        unregister: f,
        addApiEventHandler: h
    };
    function o() {
        a(), s(), l(), u();
    }
    function i() {
        f(!1), o();
    }
    function a() {
        p(r, $5b8488dadf327a2c$var$N.skipBack, "click", ()=>e.skipBack()), p(r, $5b8488dadf327a2c$var$N.play, "click", ()=>e.start()), p(r, $5b8488dadf327a2c$var$N.pause, "click", ()=>e.stop()), p(r, $5b8488dadf327a2c$var$N.skipForward, "click", ()=>e.skipForward());
    }
    function s() {
        p(r, $5b8488dadf327a2c$var$N.overlayPlay, "click", ()=>{
            $5b8488dadf327a2c$var$J(r, $5b8488dadf327a2c$var$N.overlay), e.start();
        }), p(r, $5b8488dadf327a2c$var$N.overlayRepeat, "click", ()=>{
            $5b8488dadf327a2c$var$J(r, $5b8488dadf327a2c$var$N.overlay), e.skipBack(), e.start();
        });
    }
    function l() {
        t.getState().options.mouseControls && r.querySelector("svg").addEventListener("click", (g)=>{
            let x = g.target;
            !x || x.classList.contains("legend") || $5b8488dadf327a2c$var$mr(g, function(b) {
                let D = b.detail;
                D === 3 ? e.skipBack() : D === 2 ? e.skipForward() : e.toggle();
            });
        });
    }
    function u() {
        t.getState().options.keyboardControls && p(document, "", "keyup", c);
    }
    function c(m) {
        let g = document.activeElement;
        if (g && [
            "input",
            "textarea"
        ].includes(g.tagName.toLowerCase())) return;
        let x = {
            spacebar: " ",
            A: "a",
            S: "s",
            D: "d"
        };
        switch(m.key){
            case x.spacebar:
                e.toggle(), m.preventDefault();
                break;
            case x.A:
                e.skipBack();
                break;
            case x.S:
                e.toggle();
                break;
            case x.D:
                e.skipForward();
                break;
        }
    }
    function f(m = !0) {
        n.filter((g)=>m ? !0 : !g.userDefined).forEach((g)=>{
            g.element.removeEventListener(g.eventType, g.handler), n.splice(n.indexOf(g), 1);
        });
    }
    function p(m, g, x, b) {
        let D = $5b8488dadf327a2c$var$hr(m, g);
        D && (D.addEventListener(x, b), n.push({
            element: D,
            userDefined: !1,
            eventType: x,
            handler: b
        }));
    }
    function h(m, g) {
        return r.addEventListener(m, g), n.push({
            element: r,
            userDefined: !0,
            eventType: m,
            handler: g
        }), {
            remove: ()=>{
                r.removeEventListener(m, g);
            }
        };
    }
}
function $5b8488dadf327a2c$var$_r(t) {
    let { ticker: e, data: r } = t.getState();
    return {
        date: e.currentDate,
        isFirstDate: e.isFirstDate,
        isLastDate: e.isLastDate,
        isRunning: e.isRunning,
        allDates: r.datesCache
    };
}
function $5b8488dadf327a2c$var$ge(t, e) {
    let r = t.getState().container.element;
    r && r.dispatchEvent(new CustomEvent(e, {
        bubbles: !0,
        detail: $5b8488dadf327a2c$var$_r(t)
    }));
}
function $5b8488dadf327a2c$var$ra(t) {
    let e = "", r;
    return function() {
        let n = t.getState().ticker.currentDate, o = t.getState().ticker.isRunning;
        n !== e && ($5b8488dadf327a2c$var$ge(t, "dateChange"), t.getState().ticker.isFirstDate && $5b8488dadf327a2c$var$ge(t, "firstDate"), t.getState().ticker.isLastDate && $5b8488dadf327a2c$var$ge(t, "lastDate"), e = n), !r && o && $5b8488dadf327a2c$var$ge(t, "play"), r && !o && $5b8488dadf327a2c$var$ge(t, "pause"), r = o;
    };
}
async function $5b8488dadf327a2c$export$236c05de452bec2(t, e, r = {}) {
    if (typeof e == "object" && !(e instanceof HTMLElement) && (!r || Object.keys(r).length === 0) && (r = e, e = r.selector), !e) {
        let d = document.createElement("div");
        document.body.appendChild(d), e = d;
    }
    let n = typeof e == "string" ? document.querySelector(e) : e;
    if (!n) throw new Error("Container element is not found.");
    let o = $5b8488dadf327a2c$var$gr(r), i = $5b8488dadf327a2c$var$Li($5b8488dadf327a2c$var$ur);
    i.dispatch($5b8488dadf327a2c$var$T.container.setContainer({
        element: n
    })), i.dispatch($5b8488dadf327a2c$var$T.options.loadOptions(o));
    let a = $5b8488dadf327a2c$var$gn(i), s = await $5b8488dadf327a2c$var$bn(t, i), l = $5b8488dadf327a2c$var$vr(s, i, n), { injectStyles: u, theme: c, autorun: f } = i.getState().options, p = [];
    x(i, l, s);
    let h;
    u && (h = $5b8488dadf327a2c$var$wr(n, c)), l.renderInitialView(), a.start(), f || a.stop();
    let m = $5b8488dadf327a2c$var$ea(i, a), g = $5b8488dadf327a2c$var$Dn(D);
    g?.observe(n);
    function x(d, w, E) {
        [
            $5b8488dadf327a2c$var$kn(d, w),
            $5b8488dadf327a2c$var$Ui(E, d),
            $5b8488dadf327a2c$var$ra(d),
            ...p
        ].forEach((I)=>{
            d.subscribe(I);
        });
    }
    function b(d) {
        return p.push(d), i.subscribe(d);
    }
    function D() {
        l.resize(), m.reregister();
    }
    function k() {
        throw new Error("Cannot perform this operation after calling destroy()");
    }
    return {
        play () {
            i.getState().ticker.isRunning || a.start();
        },
        pause () {
            a.stop();
        },
        toggle () {
            a.toggle();
        },
        skipBack () {
            a.skipBack();
        },
        skipForward () {
            a.skipForward();
        },
        inc (d = 1) {
            isNaN(Number(d)) || (d = 1), i.dispatch($5b8488dadf327a2c$var$T.ticker.inc(Number(d)));
        },
        dec (d = 1) {
            isNaN(Number(d)) || (d = 1), i.dispatch($5b8488dadf327a2c$var$T.ticker.dec(Number(d)));
        },
        setDate (d) {
            i.dispatch($5b8488dadf327a2c$var$T.ticker.updateDate($5b8488dadf327a2c$var$qt(d)));
        },
        getDate () {
            return i.getState().ticker.currentDate;
        },
        getAllDates () {
            return [
                ...i.getState().ticker.dates
            ];
        },
        isRunning () {
            return i.getState().ticker.isRunning;
        },
        select (d) {
            $5b8488dadf327a2c$var$j(n).select("rect." + $5b8488dadf327a2c$var$it(d)).classed("selected", !0), i.dispatch($5b8488dadf327a2c$var$T.data.addSelection(String(d)));
        },
        unselect (d) {
            $5b8488dadf327a2c$var$j(n).select("rect." + $5b8488dadf327a2c$var$it(d)).classed("selected", !1), i.dispatch($5b8488dadf327a2c$var$T.data.removeSelection(String(d)));
        },
        unselectAll () {
            $5b8488dadf327a2c$var$j(n).selectAll("rect").classed("selected", !1), i.dispatch($5b8488dadf327a2c$var$T.data.resetSelections());
        },
        hideGroup (d) {
            i.dispatch($5b8488dadf327a2c$var$T.data.addFilter(String(d)));
        },
        showGroup (d) {
            i.dispatch($5b8488dadf327a2c$var$T.data.removeFilter(String(d)));
        },
        showOnlyGroup (d) {
            i.dispatch($5b8488dadf327a2c$var$T.data.allExceptFilter(String(d)));
        },
        showAllGroups () {
            i.dispatch($5b8488dadf327a2c$var$T.data.resetFilters());
        },
        async changeOptions (d) {
            let w = $5b8488dadf327a2c$var$gr(d);
            [
                "dataShape",
                "dataType"
            ].forEach((A)=>{
                if (w[A] && w[A] !== i.getState().options[A]) throw new Error(`The option "${A}" cannot be changed.`);
            });
            let R = [
                "dataTransform",
                "fillDateGapsInterval",
                "fillDateGapsValue",
                "startDate",
                "endDate",
                "fixedOrder",
                "makeCumulative"
            ], I = !1;
            R.forEach((A)=>{
                w[A] && w[A] !== i.getState().options[A] && (I = !0);
            }), i.dispatch($5b8488dadf327a2c$var$T.options.changeOptions(w));
            let { injectStyles: H, theme: _, autorun: C } = i.getState().options;
            if (I && (i.unsubscribeAll(), i.dispatch($5b8488dadf327a2c$var$T.data.clearDateSlices()), s = await $5b8488dadf327a2c$var$bn(t, i, !0), l = $5b8488dadf327a2c$var$vr(s, i, n), x(i, l, s)), ("injectStyles" in w || "theme" in w) && (document.getElementById(h)?.remove(), H && (h = $5b8488dadf327a2c$var$wr(n, _))), l.renderInitialView(), m.reregister(), C) {
                let { isFirstDate: A, isRunning: L } = i.getState().ticker;
                A && !L && a.start();
            }
        },
        onDate (d, w) {
            if (typeof w != "function") throw new Error("The second argument must be a function");
            let E = $5b8488dadf327a2c$var$qt(d), R = "", I = b(()=>{
                i.getState().ticker.currentDate === E && E !== R && (R = i.getState().ticker.currentDate, w($5b8488dadf327a2c$var$_r(i))), R = i.getState().ticker.currentDate;
            });
            return {
                remove () {
                    I.unsubscribe();
                }
            };
        },
        on (d, w) {
            if (typeof w != "function") throw new Error("The second argument must be a function");
            let E = m.addApiEventHandler(d, ()=>{
                w($5b8488dadf327a2c$var$_r(i));
            });
            return {
                remove () {
                    E.remove();
                }
            };
        },
        destroy () {
            a.stop(), i.unsubscribeAll(), m.unregister(), g?.unobserve(n), n.innerHTML = "", document.getElementById(h)?.remove();
            for (let d of Object.keys(this))this[d] = k;
        }
    };
}


const $94d8d0d4841b00df$var$chartOptions = {
    autoRun: false,
    labelsPosition: 'outside',
    labelsWidth: 62,
    showIcons: true,
    mouseControls: true,
    tickDuration: 150,
    theme: 'dark'
};
const $94d8d0d4841b00df$var$calculateChartHeight = (numCoins)=>{
    return 300 + numCoins * 20 + 'px';
};
class $94d8d0d4841b00df$var$RaceBarChart {
    constructor(rootElement, selectedCoins, coinsData){
        this.startDate = null;
        this.rootElement = rootElement;
        this.overlayElement = rootElement.querySelector('.chart-overlay');
        this.playButtonElement = rootElement.querySelector('.play-button');
        this.chartElement = rootElement.querySelector('.race');
        this.selectedCoins = selectedCoins;
        this.coinsData = coinsData;
        this.selectedCoinsRows = [];
        this.chart = null;
        this.initialize();
    }
    async initialize() {
        this.chart = await (0, $5b8488dadf327a2c$export$236c05de452bec2)(this.selectedCoinsRows, this.chartElement, $94d8d0d4841b00df$var$chartOptions);
        this.playButtonElement.addEventListener('click', ()=>{
            this.hideOverlay();
            this.chart.play();
        });
    }
    showLoading() {
        this.overlayElement.classList.add('visible', 'loading');
    }
    showPlayButton() {
        this.overlayElement.classList.remove('loading');
        this.overlayElement.classList.add('visible');
    }
    hideOverlay() {
        this.overlayElement.classList.remove('visible', 'loading');
    }
    updateSelectedCoinsRows() {
        this.selectedCoinsRows = Array.from(this.selectedCoins).flatMap((coinId)=>{
            const coinData = this.coinsData.get(coinId) || [];
            if (this.startDate) {
                const startDate = new Date(this.startDate);
                return coinData.filter((dataPoint)=>{
                    const pointDate = new Date(dataPoint.date);
                    return pointDate >= startDate;
                });
            }
            return coinData;
        });
    }
    setStartDate(date) {
        this.startDate = date;
        const options = {
            ...$94d8d0d4841b00df$var$chartOptions
        };
        if (date) options.startDate = date;
        this.updateChart(true, options);
    }
    play() {
        this.chart.play();
    }
    pause() {
        this.chart.pause();
    }
    async updateChart(shouldShowPlay = true, options = $94d8d0d4841b00df$var$chartOptions) {
        this.showLoading();
        // Ensure minimum loading time of 300ms
        await new Promise((resolve)=>setTimeout(resolve, 300));
        this.updateChartHeight(this.selectedCoins.size);
        this.updateSelectedCoinsRows();
        this.chartElement.innerHTML = '';
        this.chart = await (0, $5b8488dadf327a2c$export$236c05de452bec2)(this.selectedCoinsRows, this.chartElement, options);
        this.chart.pause();
        if (shouldShowPlay) this.showPlayButton();
        else {
            this.hideOverlay();
            this.chart.play();
        }
    }
    updateChartHeight(numCoins) {
        this.chartElement.style.height = $94d8d0d4841b00df$var$calculateChartHeight(numCoins);
    }
}
var $94d8d0d4841b00df$export$2e2bcd8739ae039 = $94d8d0d4841b00df$var$RaceBarChart;



var $hS1nG = parcelRequire("hS1nG");

var $kUihX = parcelRequire("kUihX");
class $6e0b2c686233c5aa$export$43dfd9221dbb4cd4 {
    constructor(rootElement, selectedCoins, coinIdToCoinMap, resetToInitialSelectionCb, deselectCoinCb){
        this.rootElement = rootElement;
        this.selectedCoins = selectedCoins;
        this.coinIdToCoinMap = coinIdToCoinMap;
        this.resetToInitialSelectionCb = resetToInitialSelectionCb;
        this.deselectCoinCb = deselectCoinCb;
        this.initialCoinSelection = new Set(selectedCoins);
        this.refreshButton = rootElement.querySelector('.refresh-coins');
        this.coinsContainer = rootElement.querySelector('.coins-selected-list');
        this.init();
        this.update();
    }
    init() {
        this.refreshButton.addEventListener('click', ()=>{
            this.resetToInitialSelectionCb();
        });
    }
    update() {
        const equalSets = (a, b)=>a.size === b.size && [
                ...a
            ].every((value)=>b.has(value));
        const isDisabled = equalSets(this.selectedCoins, this.initialCoinSelection);
        this.refreshButton.disabled = isDisabled;
        this.refreshButton.classList.toggle('disabled', isDisabled);
        this.coinsContainer.innerHTML = '';
        this.selectedCoins.forEach((coinId)=>{
            const coinElement = (0, $kUihX.createCoinElement)(this.coinIdToCoinMap.get(coinId), 'selected', true, this.deselectCoinCb);
            this.coinsContainer.appendChild(coinElement);
        });
    }
}



var $hf2iT = parcelRequire("hf2iT");
class $b1054d10c03d9052$export$f1b16d16783c806e {
    constructor(rootElement, selectedCoins, coinIdToCoinMap, changeDateCb){
        this.rootElement = rootElement;
        this.selectedCoins = selectedCoins;
        this.coinIdToCoinMap = coinIdToCoinMap;
        this.changeDateCb = changeDateCb;
        this.debounceTimeout = null;
        this.startDateElement = this.rootElement.querySelector('.earliest-date');
        this.latestDateElement = this.rootElement.querySelector('.latest-date');
        this.dateRangeElement = this.rootElement.querySelector('.date-range');
        this.earliestDate = new Date();
        this.latestDate = new Date();
        this.currentDate = new Date();
        this.init();
        this.update();
    }
    debounce(callback, delay) {
        if (this.debounceTimeout) window.clearTimeout(this.debounceTimeout);
        this.debounceTimeout = window.setTimeout(callback, delay);
    }
    init() {
        this.dateRangeElement.addEventListener('input', ()=>{
            const percentage = parseInt(this.dateRangeElement.value);
            this.currentDate = this.getDateFromPercentage(percentage);
            this.startDateElement.textContent = this.formatDate(this.currentDate);
            // Debounce the callback to prevent too many updates
            this.debounce(()=>{
                // If at earliest date, pass null to remove the parameter
                if (this.currentDate.getTime() === this.earliestDate.getTime()) this.changeDateCb(null);
                else this.changeDateCb(this.currentDate.toISOString().split('T')[0]);
            }, 100);
        });
    }
    setDate(dateStr) {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return;
        // Calculate the percentage for the range input
        const totalTime = this.latestDate.getTime() - this.earliestDate.getTime();
        const time = date.getTime() - this.earliestDate.getTime();
        const percentage = Math.round(time / totalTime * 100);
        // Update the range input and display
        this.dateRangeElement.value = percentage.toString();
        this.currentDate = date;
        this.startDateElement.textContent = this.formatDate(date);
    }
    reset() {
        this.currentDate = this.earliestDate;
        this.dateRangeElement.value = '0';
        this.startDateElement.textContent = this.formatDate(this.earliestDate);
        this.changeDateCb(null); // Notify that we're at the earliest date
    }
    getDateFromPercentage(percentage) {
        const totalTime = this.latestDate.getTime() - this.earliestDate.getTime();
        const time = percentage / 100 * totalTime + this.earliestDate.getTime();
        return new Date(time);
    }
    formatDate(date) {
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }
    update() {
        const coins = Array.from(this.selectedCoins).map((coinId)=>this.coinIdToCoinMap.get(coinId));
        if (coins.length === 0) return;
        // Find earliest and latest dates
        this.earliestDate = coins.map((coin)=>new Date(coin.startDate)).reduce((a, b)=>a < b ? a : b);
        this.latestDate = new Date(); // Current date as the latest date
        this.currentDate = this.earliestDate; // Reset current date to earliest date
        // Update the display
        this.startDateElement.textContent = this.formatDate(this.earliestDate);
        this.latestDateElement.textContent = this.formatDate(this.latestDate);
        // Reset the range input to 0
        this.dateRangeElement.value = '0';
    }
}



var $kj7if = parcelRequire("kj7if");

var $1VIpI = parcelRequire("1VIpI");
const $5140b15fd1989b85$var$MAX_SELECTABLE_COINS = 15;
const $5140b15fd1989b85$var$selectedCoins = new Set();
const $5140b15fd1989b85$var$topCoinIds = [];
const $5140b15fd1989b85$var$initialCoinsSelection = new Set();
const $5140b15fd1989b85$var$isDefaultRoute = (0, $kj7if.router).getPathName() === '/' && !(0, $kj7if.router).getQuery().coins;
const $5140b15fd1989b85$var$coinIdToCoinMap = new Map();
const $5140b15fd1989b85$var$chart = new (0, $94d8d0d4841b00df$export$2e2bcd8739ae039)(document.getElementById('chart-container'), $5140b15fd1989b85$var$selectedCoins, (0, $1VIpI.coinsHistoricalDataMap));
const $5140b15fd1989b85$var$allCoins = [];
let $5140b15fd1989b85$var$selectedStartDate;
// Update URL when coins selection changes
function $5140b15fd1989b85$var$updateUrlWithSelectedCoins(startDate) {
    const selectedCoinsArray = Array.from($5140b15fd1989b85$var$selectedCoins);
    const query = {
        coins: selectedCoinsArray
    };
    if (startDate) query.startDate = startDate;
    (0, $kj7if.router).navigate('/', query);
}
const $5140b15fd1989b85$var$init = async ()=>{
    const { top_coins_history: top_coins_history, coin_markets: coin_markets, latest_update: latest_update, coinIdToCoinMap: cid2coinmap } = await (0, $1VIpI.loadAllCoinsData)();
    cid2coinmap.forEach((coin, cid)=>{
        $5140b15fd1989b85$var$coinIdToCoinMap.set(cid, coin);
    });
    $5140b15fd1989b85$var$allCoins.push(...coin_markets);
    $5140b15fd1989b85$var$topCoinIds.push(...Array.from((0, $1VIpI.coinsHistoricalDataMap).keys()));
    const routeCoinIds = [
        (0, $kj7if.router).getQuery().coins || []
    ].flat();
    if ($5140b15fd1989b85$var$isDefaultRoute && routeCoinIds.length === 0) $5140b15fd1989b85$var$topCoinIds.forEach((coinId)=>{
        $5140b15fd1989b85$var$selectedCoins.add(coinId);
        $5140b15fd1989b85$var$initialCoinsSelection.add(coinId);
    });
    else routeCoinIds.forEach((coinId)=>{
        $5140b15fd1989b85$var$selectedCoins.add(coinId);
        $5140b15fd1989b85$var$initialCoinsSelection.add(coinId);
    });
    // Setup router
    (0, $kj7if.router).on('/', async (params, query)=>{
        let needsChartUpdate = false;
        // Handle coins parameter
        if (typeof query.coins === 'string') {
            // Handle single coin case
            const coinId = query.coins;
            if ($5140b15fd1989b85$var$coinIdToCoinMap.has(coinId)) {
                $5140b15fd1989b85$var$selectedCoins.clear();
                if (!(0, $1VIpI.coinsHistoricalDataMap).has(coinId)) (0, $1VIpI.coinsHistoricalDataMap).set(coinId, await (0, $1VIpI.loadCoinHistory)(coinId));
                $5140b15fd1989b85$var$selectedCoins.add(coinId);
                needsChartUpdate = true;
            }
        } else if (Array.isArray(query.coins)) {
            // Handle multiple coins case
            const coinIds = query.coins;
            $5140b15fd1989b85$var$selectedCoins.clear();
            const toLoad = coinIds.filter((coinId)=>$5140b15fd1989b85$var$coinIdToCoinMap.has(coinId) && $5140b15fd1989b85$var$selectedCoins.size < $5140b15fd1989b85$var$MAX_SELECTABLE_COINS);
            const loaded = await Promise.all(toLoad.map((coinId)=>(0, $1VIpI.loadCoinHistory)(coinId)));
            loaded.forEach((data)=>{
                (0, $1VIpI.coinsHistoricalDataMap).set(data.name, data);
            });
            coinIds.forEach((coinId)=>$5140b15fd1989b85$var$selectedCoins.add(coinId));
            needsChartUpdate = true;
        }
        // Handle startDate parameter
        if (query.startDate && typeof query.startDate === 'string') {
            $5140b15fd1989b85$var$chart.setStartDate(query.startDate);
            if (dateSelectionComponent) dateSelectionComponent.setDate(query.startDate);
        } else if (needsChartUpdate) {
            // Only reset the date if we're updating coins
            $5140b15fd1989b85$var$chart.setStartDate(null);
            if (dateSelectionComponent) dateSelectionComponent.reset();
        }
        // Update components if needed
        if (needsChartUpdate) {
            if (selectedCoinsComponent) selectedCoinsComponent.update();
            if (availableCoinsComponent) availableCoinsComponent.update();
        }
    });
    const toLoad = Array.from($5140b15fd1989b85$var$selectedCoins).filter((coinId)=>!$5140b15fd1989b85$var$coinIdToCoinMap.has(coinId) && $5140b15fd1989b85$var$selectedCoins.size < $5140b15fd1989b85$var$MAX_SELECTABLE_COINS);
    const loaded = await Promise.all(toLoad.map((coinId)=>(0, $1VIpI.loadCoinHistory)(coinId).then((csvData)=>(0, $1VIpI.parseCSVData)(csvData, coinId, $5140b15fd1989b85$var$coinIdToCoinMap))));
    for(let i = 0; i < toLoad.length; i++)(0, $1VIpI.coinsHistoricalDataMap).set(toLoad[i], loaded[i]);
    $5140b15fd1989b85$var$chart.updateChart(false);
    // Display latest update information
    function displayLatestUpdate() {
        const lastUpdateSpan = document.querySelector('.last-update');
        if (lastUpdateSpan && latest_update) {
            const date = new Date(latest_update.lastUpdated);
            const formattedDate = date.toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            lastUpdateSpan.textContent = `Last updated: ${formattedDate}`;
        }
    }
    displayLatestUpdate();
    let selectedCoinsComponent, availableCoinsComponent, dateSelectionComponent;
    (0, $hS1nG.initShareButton)(document.querySelector('.share-button'));
    const selectedContainer = document.querySelector('.coin-selected-container');
    const availableContainer = document.querySelector('.available-coins-container');
    const dateSelectionContainer = document.querySelector('.date-selection');
    if (!selectedContainer || !availableContainer) throw new Error('Required DOM elements not found');
    selectedCoinsComponent = new (0, $6e0b2c686233c5aa$export$43dfd9221dbb4cd4)(selectedContainer, $5140b15fd1989b85$var$selectedCoins, $5140b15fd1989b85$var$coinIdToCoinMap, resetToInitialSelection, deselectCoin);
    availableCoinsComponent = new (0, $hf2iT.AvailableCoinsComponent)(availableContainer, $5140b15fd1989b85$var$selectedCoins, $5140b15fd1989b85$var$allCoins, addCoin);
    dateSelectionComponent = new (0, $b1054d10c03d9052$export$f1b16d16783c806e)(dateSelectionContainer, $5140b15fd1989b85$var$selectedCoins, $5140b15fd1989b85$var$coinIdToCoinMap, (date)=>{
        $5140b15fd1989b85$var$chart.setStartDate(date);
        $5140b15fd1989b85$var$updateUrlWithSelectedCoins(date);
    });
    function resetToInitialSelection() {
        $5140b15fd1989b85$var$selectedCoins.clear();
        $5140b15fd1989b85$var$initialCoinsSelection.forEach((coinId)=>{
            $5140b15fd1989b85$var$selectedCoins.add(coinId);
        });
        $5140b15fd1989b85$var$chart.updateChart(false);
        selectedCoinsComponent.update();
        availableCoinsComponent.update();
        if ($5140b15fd1989b85$var$isDefaultRoute) (0, $kj7if.router).navigate('/');
        else (0, $kj7if.router).navigate('/', {
            coins: Array.from($5140b15fd1989b85$var$initialCoinsSelection)
        });
    }
    function deselectCoin(coinId) {
        $5140b15fd1989b85$var$selectedCoins.delete(coinId);
        $5140b15fd1989b85$var$chart.updateChart(false);
        selectedCoinsComponent.update();
        availableCoinsComponent.update();
        $5140b15fd1989b85$var$updateUrlWithSelectedCoins();
        dateSelectionComponent.update();
    }
    async function addCoin(coinId) {
        if ($5140b15fd1989b85$var$selectedCoins.size >= $5140b15fd1989b85$var$MAX_SELECTABLE_COINS) return;
        await (0, $1VIpI.loadCoinHistory)(coinId);
        dateSelectionComponent.update();
        $5140b15fd1989b85$var$selectedCoins.add(coinId);
        $5140b15fd1989b85$var$chart.updateChart(false);
        selectedCoinsComponent.update();
        availableCoinsComponent.update();
        $5140b15fd1989b85$var$updateUrlWithSelectedCoins();
    }
    await $5140b15fd1989b85$var$chart.updateChart(false); // Start playing immediately without showing play button
};
document.addEventListener('DOMContentLoaded', async ()=>{
    await $5140b15fd1989b85$var$init().catch(console.error);
});


//# sourceMappingURL=web_page.ac283b30.js.map
